// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 1000 1000%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noiseFilter%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.65%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noiseFilter%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noiseFilter%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.65%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noiseFilter%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --demmi-50: #eff2ed;
  --demmi-100: #d4ddd0;
  --demmi-200: #b7c4b0;
  --demmi-300: #99ae8f;
  --demmi-400: #849b78;
  --demmi-500: #6f8a60;
  --demmi-600: #607854;
  --demmi-700: #506345;
  --demmi-800: #40493c;
  --demmi-900: #2d312b;
  --demmi-50-hsl: 96, 16%, 94%;
  --demmi-100-hsl: 102, 16%, 84%;
  --demmi-200-hsl: 99, 14%, 73%;
  --demmi-300-hsl: 101, 16%, 62%;
  --demmi-400-hsl: 99, 15%, 54%;
  --demmi-500-hsl: 99, 18%, 46%;
  --demmi-600-hsl: 100, 18%, 40%;
  --demmi-700-hsl: 98, 18%, 33%;
  --demmi-800-hsl: 102, 10%, 26%;
  --demmi-900-hsl: 100, 7%, 18%;
  --palette-50-s: 35%;
  --palette-50-l: 93%;
  --palette-100-s: 40%;
  --palette-100-l: 84%;
  --palette-200-s: 45%;
  --palette-200-l: 73%;
  --palette-300-s: 50%;
  --palette-300-l: 63%;
  --palette-400-s: 55%;
  --palette-400-l: 55%;
  --palette-500-s: 60%;
  --palette-500-l: 47%;
  --palette-600-s: 65%;
  --palette-600-l: 42%;
  --palette-700-s: 70%;
  --palette-700-l: 36%;
  --palette-800-s: 75%;
  --palette-800-l: 30%;
  --palette-900-s: 80%;
  --palette-900-l: 23%;
  --palette-50: hsl(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l));
}

/**
    Get values from Demmi palette
*/
/**
    Set a custom colour value for light/dark mode.
        - If exists in palette, parse palette value.
        - If type is number, something?????
        - Else use provided value.
*/
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar {
  width: 1.6rem;
  height: 1.6rem;
  background-color: transparent;
}
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb {
  border: 0.5rem solid transparent;
  border-radius: 0.8rem;
  background-clip: padding-box;
  outline: none;
  background-color: rgba(255, 255, 255, 0.7);
}
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:hover {
  border-width: 0.4rem;
  background-color: rgba(255, 255, 255, 0.9);
}
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:active {
  border-width: 0.4rem;
  background-color: rgba(255, 255, 255, 0.9);
}

body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 1rem;
}

body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-corner {
  background-color: transparent;
}

body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar {
  background-color: transparent;
}
body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb {
  border: 0.5rem solid transparent;
  background-color: hsla(var(--demmi-100-hsl), 0.6);
}
body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:hover {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:active {
  background-color: hsla(var(--demmi-100-hsl), 1);
}

body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-track {
  background: transparent;
}

body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-corner {
  background-color: transparent;
}

:root {
  --theme-bg-hue: 96;
  --theme-bg-pos: 20;
  --theme-bg-intensity: 0.6;
  --theme-bg-grain: 0.4;
  --theme-bg-svg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --theme-config-svg: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@keyframes inAnimation {
  0% {
    transform: translate3d(0, 4rem, 0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
  }
}
@keyframes outAnimation {
  0% {
    transform: scale(1);
  }
  100% {
    transform: translate3d(0, 4rem, 0);
    opacity: 0;
  }
}
#demmi-portal {
  height: 100%;
  width: 100vw;
  box-sizing: border-box;
  overflow: hidden;
  justify-items: start;
  position: relative;
  color: rgba(0, 0, 0, 0.6);
}
#demmi-portal {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark #demmi-portal {
  color: white;
}

#demmi-portal:after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
}
#demmi-portal {
  z-index: 0;
  border-radius: 2.4rem;
}
#demmi-portal {
  background-color: hsla(var(--demmi-500-hsl), 0.2);
}
body.theme-dark #demmi-portal {
  background-color: hsla(var(--demmi-500-hsl), 0.1);
}

#demmi-portal::before {
  z-index: 0;
  content: "";
  inset: 0;
  position: absolute;
  opacity: 0.4;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, hsla(var(--demmi-200-hsl), 0.5), transparent, transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, hsla(var(--demmi-200-hsl), 0.3), transparent, transparent);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
#demmi-portal::after {
  z-index: 0;
  content: "";
  inset: 0;
  position: absolute;
  background: var(--theme-bg-svg);
}
#demmi-portal::after {
  mix-blend-mode: color-burn;
}
body.theme-dark #demmi-portal::after {
  mix-blend-mode: color-dodge;
}

#demmi-portal::after {
  opacity: 0.3;
}
body.theme-dark #demmi-portal::after {
  opacity: 0.1;
}

body.theme-dark #demmi-portal::before {
  opacity: 0.5;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, hsla(var(--demmi-400-hsl), 0.3), transparent, transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, hsla(var(--demmi-400-hsl), 0.2), transparent, transparent);
}

h1 {
  position: relative;
  margin: 2.8rem 0 1.2rem;
  font-size: 3.2rem;
  line-height: 3.6rem;
  font-weight: 500;
  letter-spacing: 0.08rem;
}
h1::before {
  content: "h1";
  position: absolute;
  left: -3rem;
  top: 1.8rem;
  opacity: 0.4;
  font-size: 1.3rem;
  line-height: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-align: end;
  text-transform: none;
}
@media (max-width: 600px) {
  h1::before {
    left: -2.4rem;
  }
}
h1 {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark h1 {
  color: rgba(255, 255, 255, 0.86);
}

h2 {
  position: relative;
  margin: 2.4rem 0 1.2rem;
  font-size: 2.4rem;
  line-height: 2.8rem;
  font-weight: 500;
  letter-spacing: 0.08rem;
}
h2::before {
  content: "h2";
  position: absolute;
  left: -3rem;
  top: 1.1rem;
  opacity: 0.4;
  font-size: 1.3rem;
  line-height: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-align: end;
  text-transform: none;
}
@media (max-width: 600px) {
  h2::before {
    left: -2.4rem;
  }
}
h2 {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark h2 {
  color: rgba(255, 255, 255, 0.86);
}

h3 {
  position: relative;
  margin: 2rem 0 1.2rem;
  font-size: 1.8rem;
  line-height: 2.1rem;
  font-weight: 700;
  letter-spacing: 0.1rem;
}
h3::before {
  content: "h3";
  position: absolute;
  left: -3rem;
  top: 0.6rem;
  opacity: 0.4;
  font-size: 1.3rem;
  line-height: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-align: end;
  text-transform: none;
}
@media (max-width: 600px) {
  h3::before {
    left: -2.4rem;
  }
}
h3 {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark h3 {
  color: rgba(255, 255, 255, 0.86);
}

h4 {
  position: relative;
  margin: 1.6rem 0 1rem;
  font-size: 1.6rem;
  line-height: 1.8rem;
  font-weight: 700;
  letter-spacing: 0.1rem;
}
h4::before {
  content: "h4";
  position: absolute;
  left: -3rem;
  top: 0.3rem;
  opacity: 0.4;
  font-size: 1.3rem;
  line-height: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-align: end;
  text-transform: none;
}
@media (max-width: 600px) {
  h4::before {
    left: -2.4rem;
  }
}
h4 {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark h4 {
  color: rgba(255, 255, 255, 0.86);
}

h5 {
  position: relative;
  margin: 1.2rem 0 1rem;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
}
h5::before {
  content: "h5";
  position: absolute;
  left: -3rem;
  top: 0.3rem;
  opacity: 0.4;
  font-size: 1.3rem;
  line-height: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-align: end;
  text-transform: none;
}
@media (max-width: 600px) {
  h5::before {
    left: -2.4rem;
  }
}
h5 {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark h5 {
  color: rgba(255, 255, 255, 0.86);
}

h6 {
  position: relative;
  margin: 1rem 0;
  font-size: 1.3rem;
  line-height: 1.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
}
h6::before {
  content: "h6";
  position: absolute;
  left: -3rem;
  top: 0.3rem;
  opacity: 0.4;
  font-size: 1.3rem;
  line-height: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-align: end;
  text-transform: none;
}
@media (max-width: 600px) {
  h6::before {
    left: -2.4rem;
  }
}
h6 {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark h6 {
  color: rgba(255, 255, 255, 0.86);
}

p {
  position: relative;
  margin: 1rem 0;
  line-height: 1.8rem;
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.04rem;
}
p {
  color: rgba(0, 0, 0, 0.7);
}
body.theme-dark p {
  color: rgb(255, 255, 255);
}

p::before {
  content: "";
  position: absolute;
  left: -1rem;
  top: 0;
  bottom: 0;
  width: 0.1rem;
  transition: opacity 0.1s ease-in-out;
  opacity: 0;
}
p::before {
  background-color: rgba(0, 0, 0, 0.6);
}
body.theme-dark p::before {
  background-color: rgb(255, 255, 255);
}

p:hover::before {
  opacity: 1;
}

blockquote {
  position: relative;
  margin: 1.2rem 4rem;
  line-height: 1.8rem;
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.08rem;
  font-style: italic;
}
blockquote::before {
  content: "";
  position: absolute;
  left: -1.4rem;
  top: 0;
  bottom: 0;
  width: 0.3rem;
  border-radius: 0.2rem;
  transition: opacity 0.1s ease-in-out;
}
blockquote::before {
  background-color: rgba(0, 0, 0, 0.1);
}
body.theme-dark blockquote::before {
  background-color: rgba(255, 255, 255, 0.2);
}

code {
  outline: none;
  border: none;
  padding: 0;
  resize: none;
  position: relative;
  line-height: inherit;
  font-size: 1.2rem;
  font-family: monospace;
  font-weight: 400;
  letter-spacing: 0.06rem;
  background: transparent;
}
code {
  color: rgba(0, 0, 0, 0.9);
}
body.theme-dark code {
  color: rgba(255, 255, 255, 0.9);
}

pre {
  font-family: monospace;
  outline: none;
  border: none;
  width: 100%;
  height: auto;
  padding: 0.8rem 1.2rem;
  border-radius: 0.6rem;
  font-size: 1.2rem;
  line-height: 2rem;
  box-sizing: border-box;
  white-space: pre-wrap;
  word-wrap: break-word;
}

blockquote p::before,
ul p::before {
  display: none;
}

.async-image {
  content: "";
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.async-image.async-image--loaded img {
  animation: image-fade-in 0.2s forwards;
}
.async-image.async-image--loaded .async-image__loading-indicator-wrapper {
  animation: loader-fade-out 0.2s forwards;
}
.async-image .async-image__loading-indicator-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  animation: image-loader 1.2s linear infinite;
  opacity: 0.6;
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator {
  background: linear-gradient(hsla(var(--demmi-400-hsl), 1), hsla(99, 90%, 80%, 0), hsla(var(--demmi-300-hsl), 1));
}
body.theme-dark .async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:before {
  content: "";
  inset: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(0.4rem);
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:before {
  background: linear-gradient(hsla(var(--demmi-400-hsl), 1), hsla(99, 90%, 80%, 0), hsla(var(--demmi-300-hsl), 1));
}
body.theme-dark .async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:before {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:after {
  content: "";
  position: absolute;
  inset: 0.2rem;
  border-radius: 50%;
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:after {
  background-color: hsl(99, 0%, 98%);
}
body.theme-dark .async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:after {
  background-color: 0.8;
}

@keyframes image-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes image-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes loader-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: opacity 0.5s ease-in-out;
  border-radius: 2rem;
}
.loading-overlay {
  background-color: white;
}
body.theme-dark .loading-overlay {
  background-color: hsla(var(--demmi-900-hsl), 1);
}

.loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 0%, 0), hsl(99, 22%, 57%));
}
body.theme-dark .loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 80%, 0), hsl(99, 22%, 57%));
}

.loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator:before {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 0%, 0), hsl(99, 22%, 57%));
}
body.theme-dark .loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator:before {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 80%, 0), hsl(99, 22%, 57%));
}

.loading-overlay.loading-overlay--animated .loading-overlay__title {
  animation: load-title 0.4s forwards;
  animation-delay: 0.4s;
  opacity: 0;
}
.loading-overlay.loading-overlay--animated .loading-overlay__subtitle {
  animation: load-subtitle 0.4s forwards;
  animation-delay: 0.7s;
  opacity: 0;
}
.loading-overlay .loading-overlay__logo {
  position: relative;
  width: 30rem;
  height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.loading-overlay .loading-overlay__title {
  position: relative;
}
.loading-overlay .loading-overlay__title img {
  width: 20rem;
}
.loading-overlay .loading-overlay__subtitle {
  position: relative;
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: 400;
  margin-top: 0.8rem;
  letter-spacing: 0.05rem;
  color: hsl(99, 30%, 74%);
  pointer-events: none;
  user-select: none;
}
.loading-overlay .loading-overlay__loading-indicator {
  position: absolute;
  inset: 0;
  width: 30rem;
  height: 30rem;
  border-radius: 50%;
  animation: animate-loader 1.2s linear infinite;
  transition: opacity 0.3s ease-in-out;
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 80%, 0), hsl(99, 22%, 57%));
  opacity: 0.6;
}
.loading-overlay .loading-overlay__loading-indicator:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(0.8rem);
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 80%, 0), hsl(99, 22%, 57%));
}
.loading-overlay .loading-overlay__loading-indicator:after {
  content: "";
  position: absolute;
  inset: 0.3rem;
  border-radius: 50%;
}
.loading-overlay .loading-overlay__loading-indicator:after {
  background-color: white;
}
body.theme-dark .loading-overlay .loading-overlay__loading-indicator:after {
  background-color: hsla(var(--demmi-900-hsl), 1);
}

.loading-overlay.loading-overlay--auth .loading-overlay__subtitle {
  opacity: 1;
  animation: none;
}

@keyframes globalLoadingIn {
  0% {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  100% {
    transform: scale(1);
    backdrop-filter: blur(10px);
  }
}
@keyframes globalLoadingOut {
  0% {
    transform: scale(1);
    backdrop-filter: blur(10px);
  }
  100% {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
}
@keyframes animate-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes load-text-in {
  0% {
    transform: scale3d(0, 0, 0);
    opacity: 0;
  }
  50% {
    transform: scale3d(1, 1.2, 1);
    opacity: 0.7;
  }
  100% {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
@keyframes load-title {
  0% {
    bottom: -3rem;
  }
  50% {
    bottom: 1.2rem;
    opacity: 1;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
@keyframes load-subtitle {
  0% {
    bottom: 1.6rem;
  }
  50% {
    bottom: -0.4rem;
    opacity: 1;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
.element-loading-indicator {
  position: absolute;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
}
.element-loading-indicator.element-loading-indicator--loading {
  display: flex;
}
.element-loading-indicator .element-loading-indicator__loading-indicator {
  position: relative;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  animation: element-loading-indicator 1.2s linear infinite;
  opacity: 0.6;
  display: block;
}
.element-loading-indicator .element-loading-indicator__loading-indicator {
  background: linear-gradient(hsla(var(--demmi-400-hsl), 1), hsla(99, 90%, 80%, 0), hsla(var(--demmi-300-hsl), 1));
}
body.theme-dark .element-loading-indicator .element-loading-indicator__loading-indicator {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.element-loading-indicator .element-loading-indicator__loading-indicator:before {
  content: "";
  inset: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(0.4rem);
}
.element-loading-indicator .element-loading-indicator__loading-indicator:before {
  background: linear-gradient(hsla(var(--demmi-400-hsl), 1), hsla(99, 90%, 80%, 0), hsla(var(--demmi-300-hsl), 1));
}
body.theme-dark .element-loading-indicator .element-loading-indicator__loading-indicator:before {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.element-loading-indicator .element-loading-indicator__loading-indicator:after {
  content: "";
  position: absolute;
  inset: 0.2rem;
  border-radius: 50%;
}
.element-loading-indicator .element-loading-indicator__loading-indicator:after {
  background-color: hsl(99, 0%, 98%);
}
body.theme-dark .element-loading-indicator .element-loading-indicator__loading-indicator:after {
  background-color: hsla(var(--demmi-900-hsl), 0.6);
}

@keyframes element-loading-indicator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.toolbar__wrapper {
  grid-area: toolbar;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
}
.toolbar__wrapper .toolbar {
  display: flex;
  gap: 0.8rem;
  border-radius: 0.8rem;
}
.toolbar__wrapper .toolbar {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .toolbar__wrapper .toolbar {
  background-color: hsla(var(--demmi-200-hsl), 0.4);
}

.toolbar__wrapper .toolbar:first-child {
  padding: 0 0.8rem;
  border-top-left-radius: 2.2rem;
  border-bottom-left-radius: 2.2rem;
}
.toolbar__wrapper .toolbar:last-child {
  border-top-right-radius: 2.2rem;
  border-bottom-right-radius: 2.2rem;
  overflow: hidden;
}
.toolbar__wrapper .toolbar:last-child .toolbar__item {
  border-radius: 0;
}
.toolbar__wrapper .toolbar .toolbar__item {
  cursor: pointer;
  user-select: none;
  display: flex;
  gap: 1.4rem;
  padding: 1.4rem 2rem;
  border-radius: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.toolbar__wrapper .toolbar .toolbar__item {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item {
  color: white;
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  background-color: white;
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  background-color: hsla(var(--demmi-100-hsl), 1);
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  color: black;
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active .toolbar__item-icon {
  color: hsla(var(--demmi-900-hsl), 0.5);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active .toolbar__item-icon {
  color: black;
}

.toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.6rem;
  height: 1.6rem;
  font-size: 1.4rem;
  line-height: 1.4rem;
}
.toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
  color: hsla(var(--demmi-900-hsl), 0.5);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
  color: white;
}

.toolbar__wrapper .toolbar .toolbar__item .toolbar__item-text {
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  line-height: 1.6rem;
}
.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  background-color: hsla(var(--demmi-200-hsl), 0.4);
}

.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  background-color: rgba(255, 255, 255, 0.8);
}
.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  background-color: hsla(var(--demmi-200-hsl), 0.6);
}

.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  box-shadow: 0 1.6rem 2.2rem hsl(99, 100%, 20%,0.14);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

@media (max-width: 650px) {
  .toolbar__wrapper .toolbar {
    gap: 0.4rem;
  }
  .toolbar__wrapper .toolbar .toolbar__item {
    padding: 1.4rem 1.6rem;
    gap: 1.2rem;
  }
  .toolbar__wrapper .toolbar .toolbar__item .toolbar__item-text {
    font-size: 1.2rem;
    letter-spacing: 0.02rem;
  }
}
@media (max-width: 550px) {
  .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active) .toolbar__item-text {
    display: none;
  }
}
@media (max-width: 480px) {
  .toolbar__wrapper .toolbar .toolbar__item .toolbar__item-text {
    display: none;
  }
}
@media (max-width: 480px) {
  .toolbar__wrapper {
    width: 100%;
    gap: 0.4rem;
  }
  .toolbar__wrapper .toolbar {
    flex: 1 1 14.2857142857%;
    width: 100%;
    gap: 0.2rem;
  }
  .toolbar__wrapper .toolbar:first-child {
    padding: 0 0rem;
    border-radius: 0.8rem;
    flex: 1 1 71.4285714286%;
  }
  .toolbar__wrapper .toolbar:last-child {
    border-radius: 0.8rem;
  }
  .toolbar__wrapper .toolbar .toolbar__item {
    box-sizing: border-box;
    width: 100%;
    padding: 1.4rem 1rem;
  }
  .toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
    margin: 0 auto;
  }
}

.sidebar-button {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 2rem;
  font-size: 1.3rem;
  box-sizing: border-box;
  line-height: 1.6rem;
  padding: 1.3rem 2.4rem;
  font-weight: 500;
  letter-spacing: 0.15rem;
  text-align: start;
  background-color: hsla(var(--theme-bg-hue), 60%, 90%, 0);
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.sidebar-button {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .sidebar-button {
  color: white;
}

.sidebar-button:disabled {
  opacity: 0.4;
}
.sidebar-button:not(:disabled):not(.sidebar-button--active):hover {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .sidebar-button:not(:disabled):not(.sidebar-button--active):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.sidebar-button:not(:disabled):not(.sidebar-button--active):active {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .sidebar-button:not(:disabled):not(.sidebar-button--active):active {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.sidebar-button.sidebar-button--active {
  background-color: white;
}
body.theme-dark .sidebar-button.sidebar-button--active {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.sidebar-button.sidebar-button--active {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .sidebar-button.sidebar-button--active {
  color: white;
}

.sidebar-button.sidebar-button--active .sidebar-button__icon svg {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .sidebar-button.sidebar-button--active .sidebar-button__icon svg {
  color: white;
}

.sidebar-button .sidebar-button__icon {
  height: 1.6rem;
  line-height: 1.6rem;
}
.sidebar-button .sidebar-button__icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.sidebar-button .sidebar-button__icon svg {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .sidebar-button .sidebar-button__icon svg {
  color: rgba(255, 255, 255, 0.8);
}

.sidebar-button.sidebar-button--custom-button {
  display: block;
  padding: 0;
}

.sidebar {
  position: relative;
  width: 34rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  transform: translate3d(-30rem, 0, 0);
}
.sidebar {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .sidebar {
  background-color: hsla(var(--demmi-900-hsl), 0.4);
}

.sidebar .sidebar__header {
  width: 34rem;
  opacity: 0;
  flex: 0 0 auto;
  transition: opacity 0.3s ease-in-out;
  padding: 1.6rem;
  box-sizing: border-box;
}
.sidebar .sidebar__header .sidebar__title {
  font-size: 1.8rem;
  letter-spacing: 0.15rem;
  font-weight: 400;
  line-height: 4rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-left: 0.8rem;
}
.sidebar .sidebar__header .sidebar__title {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .sidebar .sidebar__header .sidebar__title {
  color: white;
}

.sidebar .sidebar__header .sidebar__title .sidebar__title-buttons {
  display: flex;
  gap: 0.5rem;
}
.sidebar .sidebar__header .sidebar__search {
  margin: 2rem 0 0;
}
.sidebar .sidebar__buttons {
  width: 34rem;
  opacity: 0;
  flex: 1 1 auto;
  padding: 1rem 0;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  overflow: auto;
  box-sizing: border-box;
  transition: opacity 0.3s ease-in-out;
}
.sidebar.sidebar--fixed {
  transform: translate3d(0, 0, 0);
  border: none !important;
}
.sidebar.sidebar--fixed .sidebar__header {
  opacity: 1;
}
.sidebar.sidebar--fixed .sidebar__buttons {
  opacity: 1;
}
.sidebar.sidebar--fixed .sidebar__invisible-contents {
  opacity: 0;
  transform: translate3d(-30rem, 0, 0);
  pointer-events: none;
}
.sidebar:hover {
  transform: translate3d(0, 0, 0);
}
.sidebar:hover .sidebar__header {
  opacity: 1;
}
.sidebar:hover .sidebar__buttons {
  opacity: 1;
}
.sidebar:hover .sidebar__invisible-contents {
  opacity: 0;
  transform: translate3d(-30rem, 0, 0);
  pointer-events: none;
}
.sidebar .sidebar__invisible-contents {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 4rem;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
.sidebar .sidebar__invisible-contents .sidebar__invisible-contents-text {
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
  transform: rotate3d(0, 0, 1, -90deg);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sidebar .sidebar__invisible-contents .sidebar__invisible-contents-text {
  color: hsla(var(--demmi-400-hsl), 1);
}
body.theme-dark .sidebar .sidebar__invisible-contents .sidebar__invisible-contents-text {
  color: hsla(var(--demmi-100-hsl), 1);
}

.theme-switcher {
  position: relative;
  display: flex;
  gap: 0rem;
  width: fit-content;
  box-sizing: border-box;
  padding: 0 0.3rem;
  border-radius: 2rem;
  z-index: 100;
  background-color: red;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out;
}
.theme-switcher {
  background-color: hsla(var(--demmi-200-hsl), 0.6);
}
body.theme-dark .theme-switcher {
  background-color: hsla(var(--demmi-200-hsl), 0.4);
}

.theme-switcher:not(:disabled):hover {
  transform: scale3d(1.1, 1.1, 1.1);
}
.theme-switcher:not(:disabled):active {
  transform: scale3d(0.9, 0.9, 0.9);
}
.theme-switcher .theme-switcher__item {
  z-index: 1;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 3rem;
  gap: 1.2rem;
  transition: color 0.1s ease;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-icon {
  flex: 0 0 1.2rem;
  width: 1.2rem;
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-icon {
  color: white;
}
body.theme-dark .theme-switcher .theme-switcher__item .theme-switcher__item-icon {
  color: white;
}

.theme-switcher .theme-switcher__item .theme-switcher__item-icon svg {
  display: block;
  width: 1.2rem;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-text {
  display: none;
}
.theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-text {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-text {
  color: black;
}

.theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-icon {
  color: hsla(var(--demmi-900-hsl), 0.5);
}
body.theme-dark .theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-icon {
  color: black;
}

.theme-switcher .theme-switcher__item:not(.theme-switcher--active) .theme-switcher__item-text {
  opacity: 0;
  width: 0;
}
.theme-switcher .theme-switcher__indicator {
  z-index: 0;
  pointer-events: none;
  border-radius: 50%;
  position: absolute;
  width: 3.4rem;
  top: -0.2rem;
  bottom: -0.2rem;
  left: 0.1rem;
  transition: transform 0.2s ease;
}
.theme-switcher .theme-switcher__indicator {
  background-color: white;
}
body.theme-dark .theme-switcher .theme-switcher__indicator {
  background-color: hsla(var(--demmi-100-hsl), 1);
}

.theme-switcher.theme-switcher--light .theme-switcher__indicator {
  transform: translate3d(3rem, 0, 0);
}
.theme-switcher.theme-switcher--dark .theme-switcher__indicator {
  transform: translate3d(6rem, 0, 0);
}

.notifications-panel {
  position: absolute;
  inset: 0;
  z-index: 9999;
}
.notifications-panel.notifications-panel--visible .notifications-panel__content {
  opacity: 1;
}
.notifications-panel.notifications-panel--visible .notifications-panel__backdrop {
  opacity: 1;
}
.notifications-panel.notifications-panel--visible .notifications-panel-content {
  transition: transform 0.4s ease-out;
  transform: translate3d(0, 0, 0);
}
.notifications-panel .notifications-panel__backdrop {
  opacity: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  inset: 0;
  transition: opacity 0.3s ease-in-out;
}
.notifications-panel .notifications-panel__backdrop {
  background-color: rgba(0, 0, 0, 0.2);
}
body.theme-dark .notifications-panel .notifications-panel__backdrop {
  background-color: rgba(0, 0, 0, 0.4);
}

.notifications-panel-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: calc(100% - 4rem);
  max-width: 46rem;
  height: calc(100% - 1rem);
  margin: 0.5rem;
  box-sizing: border-box;
  border-radius: 2rem;
  transform: translate3d(-48rem, 0, 0);
  transition: transform 0.3s ease-in;
}
.notifications-panel-content {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .notifications-panel-content {
  color: white;
}

.notifications-panel-content {
  background-color: white;
}
body.theme-dark .notifications-panel-content {
  background-color: hsl(var(--theme-bg-hue), 10%, 18%);
}

.notifications-panel-content {
  box-shadow: 1.2rem 0rem 4rem hsla(var(--demmi-900-hsl), 0.1);
}
body.theme-dark .notifications-panel-content {
  box-shadow: 1.2rem 0rem 4rem rgba(0, 0, 0, 0.3);
}

.notifications-panel-content .notifications-panel-content__title {
  flex-direction: 0 0 auto;
  text-align: center;
  font-size: 1.6rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 6rem;
}
.notifications-panel-content .notifications-panel-content__title {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .notifications-panel-content .notifications-panel-content__title {
  color: hsla(var(--demmi-50-hsl), 1);
}

.notifications-panel-content .notifications-panel-content__content {
  overflow: auto;
  max-height: 100%;
}

.notification-item {
  position: relative;
  display: grid;
  grid-template: "badge action" 3.8rem "message message" auto "timestamp title" 2rem "type type" auto/auto auto;
  padding: 1.2rem 1rem;
  gap: 1.6rem;
  border-top: 0.1rem solid transparent;
  border-bottom: 0.1rem solid transparent;
  transition: background-color 0.1s ease-in-out;
}
.notification-item {
  border-color: hsla(var(--demmi-100-hsl), 0.6);
}
body.theme-dark .notification-item {
  border-color: hsla(var(--demmi-400-hsl), 0.4);
}

.notification-item:not(:last-child) {
  border-bottom: none;
}
.notification-item:hover {
  background-color: hsla(var(--demmi-400-hsl), 0.08);
}
body.theme-dark .notification-item:hover {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.notification-item.notification-item--new .notification-item__badge {
  padding-left: 3rem;
}
.notification-item.notification-item--new::before {
  content: "";
  position: absolute;
  width: 1rem;
  height: 1rem;
  left: 2rem;
  top: 2.6rem;
  border-radius: 0.5rem;
}
.notification-item.notification-item--new::before {
  background-color: hsl(101, 71%, 68%);
}
body.theme-dark .notification-item.notification-item--new::before {
  background-color: hsl(101, 71%, 68%);
}

.notification-item .notification-item__badge {
  grid-area: badge;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-start;
  text-align: center;
  border-radius: 0.8rem;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  padding: 0 1.5rem;
  line-height: 1.6rem;
}
.notification-item .notification-item__badge {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .notification-item .notification-item__badge {
  color: hsla(var(--demmi-50-hsl), 1);
}

.notification-item .notification-item__badge {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .notification-item .notification-item__badge {
  background-color: hsla(var(--demmi-200-hsl), 0.2);
}

.notification-item .notification-item__badge svg {
  margin-right: 1rem;
  height: 1.4rem;
}
.notification-item .notification-item__type-badge {
  grid-area: type;
  margin: -0.8rem -0.6rem -0.8rem -0.6rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-self: stretch;
  text-align: start;
  border-radius: 0.4rem;
  font-size: 1.1rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  box-sizing: border-box;
  padding: 1rem 1.6rem;
  line-height: 1.6rem;
  text-transform: uppercase;
}
.notification-item .notification-item__type-badge {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .notification-item .notification-item__type-badge {
  color: hsla(var(--demmi-50-hsl), 1);
}

.notification-item .notification-item__type-badge {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .notification-item .notification-item__type-badge {
  background-color: hsla(var(--demmi-200-hsl), 0.2);
}

.notification-item .notification-item__type-badge svg {
  margin-right: 1rem;
  height: 1.4rem;
}
.notification-item .notification-item__type-badge span {
  font-weight: 400;
  margin-left: 0.8rem;
  font-size: 1.3rem;
  text-transform: none;
}
.notification-item .notification-item__timestamp {
  grid-area: timestamp;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  margin-left: 0.6rem;
  margin-top: -1.2rem;
}
.notification-item .notification-item__timestamp {
  color: hsla(var(--demmi-900-hsl), 0.9);
}
body.theme-dark .notification-item .notification-item__timestamp {
  color: hsla(var(--demmi-50-hsl), 1);
}

.notification-item .notification-item__buttons {
  justify-self: flex-end;
  grid-area: action;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}
.notification-item .notification-item__buttons .demmi-ui-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .notification-item .notification-item__buttons .demmi-ui-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.notification-item .notification-item__message {
  grid-area: message;
  display: flex;
  flex-direction: column;
}
.notification-item .notification-item__message {
  color: hsla(var(--demmi-900-hsl), 0.7);
}
body.theme-dark .notification-item .notification-item__message {
  color: hsla(var(--demmi-50-hsl), 1);
}

.notification-item .notification-item__message .notification-item__text {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  line-height: 2rem;
  padding: 0 0.6rem 0.4rem;
}
.notification-item .notification-item__message .notification-item__text strong {
  font-weight: 600;
}

.notifications__icon {
  position: absolute;
  top: 0.8rem;
  left: 0.8rem;
}
@media (max-width: 1200px) {
  .notifications__icon {
    left: 0.5rem;
    top: 0.4rem;
  }
}
.notifications__icon .notifications__icon-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -0.3rem;
  right: -0.3rem;
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 1.1rem;
  color: white;
}
.notifications__icon .notifications__icon-indicator {
  background-color: hsl(101, 50%, 60%);
}
body.theme-dark .notifications__icon .notifications__icon-indicator {
  background-color: hsl(101, 37%, 55%);
}

.portal-sidebar-button {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 2rem;
  font-size: 1.3rem;
  box-sizing: border-box;
  line-height: 2.4rem;
  padding: 1.3rem 2.4rem;
  font-weight: 500;
  letter-spacing: 0.15rem;
  text-align: start;
  border-radius: 0.8rem;
  background-color: hsla(var(--theme-bg-hue), 60%, 90%, 0);
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.portal-sidebar-button {
  color: white;
}
body.theme-dark .portal-sidebar-button {
  color: white;
}

.portal-sidebar-button:disabled {
  opacity: 0.4;
}
.portal-sidebar-button:not(:disabled):not(.portal-sidebar-button--active):hover {
  background-color: rgba(255, 255, 255, 0.1);
}
body.theme-dark .portal-sidebar-button:not(:disabled):not(.portal-sidebar-button--active):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.portal-sidebar-button:not(:disabled):not(.portal-sidebar-button--active):active {
  background-color: rgba(255, 255, 255, 0.1);
}
body.theme-dark .portal-sidebar-button:not(:disabled):not(.portal-sidebar-button--active):active {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.portal-sidebar-button.portal-sidebar-button--active {
  background-color: rgba(255, 255, 255, 0.2);
}
body.theme-dark .portal-sidebar-button.portal-sidebar-button--active {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.portal-sidebar-button .portal-sidebar-button__icon {
  height: 1.6rem;
  line-height: 1.6rem;
}
.portal-sidebar-button .portal-sidebar-button__icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.portal-sidebar-button .portal-sidebar-button__icon svg {
  color: white;
}
body.theme-dark .portal-sidebar-button .portal-sidebar-button__icon svg {
  color: rgba(255, 255, 255, 0.8);
}

.portal-sidebar {
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.portal-sidebar .portal-sidebar__logo {
  padding: 3rem 0;
}
.portal-sidebar .portal-sidebar__logo .portal-sidebar__logo-colour {
  display: none;
}
body.theme-dark .portal-sidebar .portal-sidebar__logo .portal-sidebar__logo-colour {
  display: block;
}

.portal-sidebar .portal-sidebar__logo .portal-sidebar__logo-white {
  display: block;
}
body.theme-dark .portal-sidebar .portal-sidebar__logo .portal-sidebar__logo-white {
  display: none;
}

.portal-sidebar .portal-sidebar__logo img {
  height: 3rem;
}
.portal-sidebar .portal-sidebar__bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
}
.portal-sidebar .portal-sidebar__buttons {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.3rem;
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}
.portal-sidebar .portal-sidebar__version {
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  line-height: 1.4rem;
  pointer-events: none;
  user-select: none;
  text-transform: uppercase;
}
.portal-sidebar .portal-sidebar__version .portal-sidebar__version-build,
.portal-sidebar .portal-sidebar__version .portal-sidebar__version-date {
  display: flex;
  justify-content: space-between;
}
.portal-sidebar .portal-sidebar__version .portal-sidebar__version-key {
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  text-align: start;
  letter-spacing: 0.1rem;
}
.portal-sidebar .portal-sidebar__version .portal-sidebar__version-key {
  color: hsla(var(--demmi-300-hsl), 1);
}
body.theme-dark .portal-sidebar .portal-sidebar__version .portal-sidebar__version-key {
  color: hsla(var(--demmi-300-hsl), 1);
}

.portal-sidebar .portal-sidebar__version .portal-sidebar__version-val {
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 700;
  text-align: end;
  letter-spacing: 0.2rem;
}
.portal-sidebar .portal-sidebar__version .portal-sidebar__version-val {
  color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .portal-sidebar .portal-sidebar__version .portal-sidebar__version-val {
  color: hsla(var(--demmi-200-hsl), 1);
}

.portal-wrapper {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template: "sidebar content" 1fr/26rem 1fr;
}
.portal-wrapper .portal-wrapper__content-wrapper {
  position: relative;
  grid-area: content;
  display: flex;
  z-index: 1;
  align-self: center;
  justify-self: center;
  border-radius: 2rem;
  height: calc(100% - 2rem);
  width: calc(100% - 1rem);
  margin-right: 1rem;
  box-sizing: border-box;
  transition: transform 0.5s cubic-bezier(0.68, -0.53, 0.34, 1.66);
  overflow: hidden;
}
.portal-wrapper .portal-wrapper__content-wrapper {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .portal-wrapper .portal-wrapper__content-wrapper {
  background-color: hsla(var(--demmi-900-hsl), 1);
}

.portal-wrapper .portal-wrapper__content-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: 2rem;
}
.portal-wrapper .portal-wrapper__content-wrapper::before {
  background: radial-gradient(circle at 30% 80%, hsla(var(--demmi-500-hsl), 0.1), hsla(var(--demmi-500-hsl), 0), hsla(var(--demmi-500-hsl), 0));
}
body.theme-dark .portal-wrapper .portal-wrapper__content-wrapper::before {
  background: radial-gradient(circle at 30% 80%, hsla(var(--demmi-400-hsl), 0.3), hsla(var(--demmi-400-hsl), 0.1));
}

.portal-wrapper .portal-wrapper__content-wrapper .portal-wrapper__content {
  display: flex;
  flex: 1 1 auto;
  overflow: auto hidden;
}
.portal-wrapper .portal-wrapper__nav-bar {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6rem;
}
.portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__menu-toggle-button {
  position: relative;
  height: 6rem;
  width: 6rem;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-logo .portal-wrapper__logo-colour {
  display: none;
}
body.theme-dark .portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-logo .portal-wrapper__logo-colour {
  display: block;
}

.portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-logo .portal-wrapper__logo-white {
  display: block;
}
body.theme-dark .portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-logo .portal-wrapper__logo-white {
  display: none;
}

.portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-logo img {
  height: 2.8rem;
}
.portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__nav-bar-empty {
  width: 6rem;
}
@media (max-width: 800px) {
  .portal-wrapper {
    display: block;
  }
  .portal-wrapper .portal-wrapper__nav-bar {
    display: flex;
    justify-content: space-between;
  }
  .portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__menu-toggle-button .demmi-ui-icon-button.fa-arrow-left {
    display: none;
  }
  .portal-wrapper .portal-wrapper__nav-bar .portal-wrapper__menu-toggle-button .demmi-ui-icon-button.fa-bars {
    display: block;
  }
  .portal-wrapper.portal-wrapper--menu-visible .portal-wrapper__menu-toggle-button .demmi-ui-icon-button.fa-arrow-left {
    display: block;
  }
  .portal-wrapper.portal-wrapper--menu-visible .portal-wrapper__menu-toggle-button .demmi-ui-icon-button.fa-bars {
    display: none;
  }
  .portal-wrapper.portal-wrapper--menu-visible .portal-wrapper__content-wrapper {
    transform: translate3d(28rem, 0, 0);
  }
  .portal-wrapper.portal-wrapper--menu-visible .portal-sidebar {
    opacity: 1;
  }
  .portal-wrapper .portal-wrapper__content-wrapper {
    position: absolute;
    left: 1rem;
    bottom: 0.5rem;
    right: 0;
    height: calc(100% - 0.5rem - 6rem);
  }
  .portal-wrapper .portal-sidebar {
    position: absolute;
    top: 6rem;
    bottom: 0;
    left: 0;
    width: 28rem;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
  .portal-wrapper .portal-sidebar .portal-sidebar__logo {
    display: none;
  }
}

.raw-details {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.raw-details .raw-details__content {
  position: relative;
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.raw-details .raw-details__content .raw-details__dump {
  width: 100%;
  border-radius: 2rem;
  user-select: none;
}
.raw-details .raw-details__content .raw-details__dump {
  background-color: hsla(var(--demmi-300-hsl), 0.2);
}
body.theme-dark .raw-details .raw-details__content .raw-details__dump {
  background-color: hsla(var(--demmi-900-hsl), 0.4);
}

.raw-details .raw-details__content .raw-details__dump .raw-details__dump-title {
  cursor: pointer;
  line-height: 4rem;
  padding: 0 2rem;
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-align: center;
  border-radius: 2rem;
}
.raw-details .raw-details__content .raw-details__dump .raw-details__dump-title {
  color: hsla(var(--demmi-400-hsl), 1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__dump .raw-details__dump-title {
  color: hsla(var(--demmi-100-hsl), 1);
}

.raw-details .raw-details__content .raw-details__dump .raw-details__dump-title:hover {
  color: hsla(var(--demmi-600-hsl), 1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__dump .raw-details__dump-title:hover {
  color: hsla(var(--demmi-50-hsl), 1);
}

.raw-details .raw-details__content .raw-details__dump .raw-details__dump-title:hover {
  background-color: hsla(var(--demmi-300-hsl), 0.1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__dump .raw-details__dump-title:hover {
  background-color: hsla(var(--demmi-900-hsl), 0.3);
}

.raw-details .raw-details__content .raw-details__dump pre {
  display: none;
  margin: 0;
}
.raw-details .raw-details__content .raw-details__dump pre {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__dump pre {
  color: hsla(var(--demmi-50-hsl), 1);
}

.raw-details .raw-details__content .raw-details__dump.raw-details__dump--visible pre {
  display: block;
}
.raw-details .raw-details__content .raw-details__item {
  position: relative;
  flex: 1 0 100%;
  min-width: 200px;
  margin-top: 1rem;
}
.raw-details .raw-details__content .raw-details__item.raw-details__item--has-indent::before {
  content: "";
  position: absolute;
  left: 1rem;
  top: 2.5rem;
  bottom: 0rem;
  width: 0.2rem;
  border-radius: 0.2rem;
}
.raw-details .raw-details__content .raw-details__item.raw-details__item--has-indent::before {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__item.raw-details__item--has-indent::before {
  background-color: hsla(var(--demmi-50-hsl), 0.5);
}

.raw-details .raw-details__content .raw-details__item .raw-details__item-key {
  position: relative;
  line-height: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
}
.raw-details .raw-details__content .raw-details__item .raw-details__item-key {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__item .raw-details__item-key {
  color: hsla(var(--demmi-50-hsl), 1);
}

.raw-details .raw-details__content .raw-details__item .raw-details__item-value {
  position: relative;
  line-height: 2rem;
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.raw-details .raw-details__content .raw-details__item .raw-details__item-value {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .raw-details .raw-details__content .raw-details__item .raw-details__item-value {
  color: hsla(var(--demmi-100-hsl), 1);
}

.page {
  position: relative;
  z-index: 100;
  margin: 0 auto;
  display: grid;
  grid-template: "sidebar details" 1fr/4rem 1fr;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto hidden;
  transition: grid 0.3s ease-in-out;
}
.page {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .page {
  color: white;
}

.page.page--sidebar-fixed {
  grid-template: "sidebar details" 1fr/34rem 1fr;
}
.page.page:has(> .sidebar:hover) {
  grid-template: "sidebar details" 1fr/34rem 1fr;
}
.page .page__view {
  position: relative;
  min-width: 60rem;
  max-width: 120rem;
  width: 100%;
  margin: 0 auto;
  padding: 2rem 2rem;
  box-sizing: border-box;
  overflow: auto;
}

.modal-create-invite-code {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 50rem;
  margin: 4rem auto 8rem;
}
.modal-create-invite-code .modal-create-invite-code__title {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-invite-code .modal-create-invite-code__title {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .modal-create-invite-code .modal-create-invite-code__title {
  color: white;
}

.modal-create-invite-code .modal-create-invite-code__error {
  margin-top: 1rem;
  line-height: 2rem;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-invite-code .modal-create-invite-code__error {
  color: hsl(0, 70%, 70%);
}
body.theme-dark .modal-create-invite-code .modal-create-invite-code__error {
  color: hsl(0, 100%, 88%);
}

.modal-create-invite-code .modal-create-invite-code__code-area {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 1.6rem;
  margin-top: 1rem;
  padding: 2rem;
}
.modal-create-invite-code .modal-create-invite-code__code-area {
  background-color: hsla(var(--demmi-200-hsl), 0.2);
}
body.theme-dark .modal-create-invite-code .modal-create-invite-code__code-area {
  background-color: hsla(var(--demmi-800-hsl), 0.6);
}

.modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__code-title {
  line-height: 2rem;
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  text-align: center;
}
.modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__code-title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__code-title {
  color: hsla(var(--demmi-100-hsl), 1);
}

.modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__code {
  text-align: center;
  font-size: 2.4rem;
  letter-spacing: 1.5rem;
  font-weight: 300;
  line-height: 3rem;
}
.modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__code {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__code {
  color: hsla(var(--demmi-200-hsl), 1);
}

.modal-create-invite-code .modal-create-invite-code__code-area .modal-create-invite-code__toggle-item input {
  margin-top: 1rem;
}

.card-authentication__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  max-width: 40rem;
  width: calc(100% - 2rem);
  box-sizing: border-box;
  background-color: hsla(var(--demmi-400-hsl), 0.2);
  border-radius: 2rem;
}
.card-authentication__wrapper .card-authentication {
  flex: 0 0 auto;
  padding: 0 !important;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 2rem;
  overflow: hidden;
}
.card-authentication__wrapper .card-authentication .card-authentication__title {
  line-height: 2.4rem;
  font-weight: 700;
  font-size: 1.4rem;
  letter-spacing: 0.4rem;
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 2rem;
  color: hsl(99, 22%, 57%);
  text-transform: uppercase;
}
.card-authentication__wrapper .card-authentication .card-authentication__title img {
  width: 16rem;
}
.card-authentication__wrapper .card-authentication .card-authentication__title span {
  margin-top: 1rem;
  display: block;
}
.card-authentication__wrapper .card-authentication .card-authentication__inputs-area {
  padding: 2rem 2rem 2rem;
  box-sizing: border-box;
}
.card-authentication__wrapper .card-authentication .card-authentication__inputs-area .card-authentication__inputs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.card-authentication__wrapper .card-authentication.card-authentication__invite-area {
  z-index: 0;
  position: relative;
  padding: 3rem 0 !important;
  flex: 0 0 auto;
  text-align: center;
  justify-content: space-evenly;
}
.card-authentication__wrapper .card-authentication.card-authentication__invite-area::before {
  z-index: 0;
  content: "";
  inset: 0;
  position: absolute;
}
.card-authentication__wrapper .card-authentication.card-authentication__invite-area::before {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .card-authentication__wrapper .card-authentication.card-authentication__invite-area::before {
  background-color: rgba(0, 0, 0, 0.15);
}

.login-error {
  max-width: 40rem;
  width: calc(100% - 2rem);
  opacity: 0;
  margin-top: -5rem;
  pointer-events: none;
  transition: opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66), margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);
}
.login-error.login-error--visible {
  opacity: 1;
  margin-top: 0;
}
.login-error .login-error__error {
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(176, 51, 46, 0.5);
  line-height: 2rem;
  font-weight: 500;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  text-align: center;
  color: white;
  border-radius: 1.6rem;
}

.login__wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  z-index: 1;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
}
.login__wrapper.login--hide {
  transform: translate3d(0, 4rem, 0);
  opacity: 0;
}
.login__wrapper.login--error .login__sign-in {
  margin-top: 0rem;
}
.login__wrapper.login--error .login__submit-button {
  margin-top: 0rem;
}
.login__wrapper .demmi-ui-input {
  text-align: center;
  font-size: 1.5rem;
  line-height: 3.2rem;
  font-weight: 300;
  border: none;
  letter-spacing: 0.2rem;
  color: white;
}
.login__wrapper .demmi-ui-input:focus {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .login__wrapper .demmi-ui-input:focus {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.login__wrapper .login__submit-button {
  z-index: 1;
  transition: margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);
}
.login__wrapper .demmi-ui-button {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .login__wrapper .demmi-ui-button {
  background-color: hsla(var(--demmi-400-hsl), 0.6);
}

.login__wrapper .demmi-ui-button {
  border-color: transparent;
}
body.theme-dark .login__wrapper .demmi-ui-button {
  border-color: transparent;
}

.login__wrapper .demmi-ui-button {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .login__wrapper .demmi-ui-button {
  color: hsla(var(--demmi-50-hsl), 1);
}

.login__wrapper .demmi-ui-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .login__wrapper .demmi-ui-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.login__wrapper .demmi-ui-button:not(:disabled):hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .login__wrapper .demmi-ui-button:not(:disabled):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.6);
}

.login__wrapper .demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .login__wrapper .demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.login__wrapper .demmi-ui-button:not(:disabled):active {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .login__wrapper .demmi-ui-button:not(:disabled):active {
  background-color: hsla(var(--demmi-400-hsl), 0.6);
}

.login__wrapper .demmi-ui-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .login__wrapper .demmi-ui-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.login__wrapper .theme-switcher {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
}

.customer-details {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.customer-details .customer-details__title {
  line-height: 3rem;
  font-weight: 300;
  font-size: 2.4rem;
  letter-spacing: 0.1rem;
  text-align: start;
  margin-top: 3rem;
  margin-left: 2rem;
}
.customer-details .customer-details__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customer-details .customer-details__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.customer-details .customer-details__image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  overflow: auto;
  gap: 1rem;
}
.customer-details .customer-details__image-grid .customer-details__image-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 1.5rem;
  padding: 0.5rem;
}
.customer-details .customer-details__image-grid .customer-details__image-item {
  background-color: white;
}
body.theme-dark .customer-details .customer-details__image-grid .customer-details__image-item {
  background-color: hsla(var(--demmi-900-hsl), 0.2);
}

.customer-details .customer-details__image-grid .customer-details__image-item .customer-details__image-wrapper {
  width: 100%;
  box-sizing: border-box;
  height: 30rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.customer-details .customer-details__image-grid .customer-details__image-item .customer-details__image-wrapper img {
  max-height: 100%;
  max-width: 100%;
  border-radius: 0.5rem;
}
.customer-details .customer-details__content {
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem 2rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.customer-details .customer-details__content .customer-details__item {
  flex: 1 0 100%;
  min-width: 200px;
}
.customer-details .customer-details__content .customer-details__item .customer-details__item-key {
  line-height: 3rem;
  font-size: 1.4rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.customer-details .customer-details__content .customer-details__item .customer-details__item-value {
  position: relative;
  line-height: 2.2rem;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.customer-details .customer-details__content .customer-details__item .customer-details__item-value span {
  display: block;
  margin-bottom: 2rem;
}
.customer-details .customer-details__content .customer-details__item .customer-details__item-value span:last-child {
  margin-bottom: 0;
}
.customer-details .customer-details-shop {
  max-width: 60rem !important;
  min-width: 55rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.customer-details .customer-details-shop .customer-details-shop__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 1rem;
  padding: 0;
}
.customer-details .customer-details-shop .customer-details-shop__days .demmi-ui-card {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .customer-details .customer-details-shop .customer-details-shop__days .demmi-ui-card {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.2rem 1rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
}
.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item {
  color: white;
}
body.theme-dark .customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item {
  color: hsla(var(--demmi-200-hsl), 1);
}

.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-hours {
  flex: 1 1 18rem;
  display: flex;
  gap: 2rem;
}
.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-hours .customer-details-shop__details-hours-item {
  flex: 1 1 auto;
}
.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-hours .customer-details-shop__details-hours-item .customer-details-shop__details-hours-item-title {
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
  font-weight: 600;
  line-height: 1.4rem;
  text-transform: uppercase;
  margin: 0.2rem 0 1rem 1rem;
}
.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-hours .customer-details-shop__details-hours-item .customer-details-shop__details-hours-item-title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-hours .customer-details-shop__details-hours-item .customer-details-shop__details-hours-item-title {
  color: white;
}

.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-title {
  flex: 1 1 10rem;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.4rem;
  margin: 0.5rem 1rem 1rem;
}
.customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customer-details .customer-details-shop .customer-details-shop__days .customer-details-shop__details-item .customer-details-shop__details-title {
  color: white;
}

.home {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 4rem;
  box-sizing: border-box;
}
.home .home__title {
  line-height: 5rem;
  font-weight: 300;
  font-size: 4rem;
  letter-spacing: 0.1rem;
  text-align: center;
  color: hsl(99, 22%, 57%);
  margin-top: 1rem;
  margin-bottom: 4rem;
}
.home .home__description {
  line-height: 2.4rem;
  font-weight: 400;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  text-align: center;
  margin-top: 2rem;
}
@media (max-width: 520px) {
  .home {
    padding: 4rem 2rem 2rem;
  }
}

.customers-view--address {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.customers-view--address .customers-view__geo {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.customers-view--address .customers-view__geo #gmaps-view {
  height: 40rem;
  border-radius: 1rem;
  overflow: hidden;
}
.customers-view--address .customers-view__geo .gmap-autocomplete {
  width: 30rem;
  box-sizing: border-box;
  margin-top: 0.8rem;
  margin-left: 0.8rem;
}
.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input {
  opacity: 0.9;
  box-sizing: border-box;
}
.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  opacity: 1;
}
.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  box-shadow: 0 0.9rem 1.2rem hsl(99, 100%, 20%,0.18);
}
body.theme-dark .customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  box-shadow: 0 0.9rem 1.2rem hsl(99, 100%, 20%,0.16);
}

.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:focus {
  opacity: 1;
}
.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:focus {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-input:focus {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-menu {
  margin-top: 0.8rem;
  box-sizing: border-box;
}
.customers-view--address .customers-view__geo .gmap-autocomplete .demmi-ui-menu .demmi-ui-menu-item {
  text-align: start;
}
.customers-view--address .customers-view__geo .gmap-autocomplete .customers-view--address .customers-view__geo .gmap-autocomplete__predictions {
  box-sizing: border-box;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden auto;
  max-height: 40rem;
  border-radius: 2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}
.customers-view--address .customers-view__geo .customers-view__address-preview {
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 3rem;
  box-sizing: border-box;
}
.customers-view--address .customers-view__geo .customers-view__address-preview .customers-view__details-item {
  flex: 1 0 calc(50% - 2rem);
  min-width: 200px;
}
.customers-view--address .customers-view__geo .customers-view__address-preview .customers-view__details-item .customers-view__details-key {
  line-height: 2.2rem;
  font-size: 1.2rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.customers-view--address .customers-view__geo .customers-view__address-preview .customers-view__details-item .customers-view__details-value {
  position: relative;
  line-height: 2rem;
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.customers-view--address .customers-view__geo .customers-view__buttons-row {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
}

.customers-view--details {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.customers-view--details .customers-view__raw-content {
  position: relative;
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.customers-view--details .customers-view__raw-content pre.customers-view__dump {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .customers-view--details .customers-view__raw-content pre.customers-view__dump {
  background-color: hsla(var(--demmi-900-hsl), 0.5);
}

.customers-view--details .customers-view__raw-content pre.customers-view__dump {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .customers-view--details .customers-view__raw-content pre.customers-view__dump {
  color: hsla(var(--demmi-50-hsl), 1);
}

.customers-view--details .customers-view__raw-content .customers-view__item {
  position: relative;
  flex: 1 0 100%;
  min-width: 200px;
  margin-top: 1rem;
}
.customers-view--details .customers-view__raw-content .customers-view__item.customers-view__item--has-indent::before {
  content: "";
  position: absolute;
  left: 1rem;
  top: 2.5rem;
  bottom: 0rem;
  width: 0.2rem;
  border-radius: 0.2rem;
}
.customers-view--details .customers-view__raw-content .customers-view__item.customers-view__item--has-indent::before {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .customers-view--details .customers-view__raw-content .customers-view__item.customers-view__item--has-indent::before {
  background-color: hsla(var(--demmi-50-hsl), 0.5);
}

.customers-view--details .customers-view__raw-content .customers-view__item .customers-view__item-key {
  position: relative;
  line-height: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
}
.customers-view--details .customers-view__raw-content .customers-view__item .customers-view__item-key {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customers-view--details .customers-view__raw-content .customers-view__item .customers-view__item-key {
  color: hsla(var(--demmi-50-hsl), 1);
}

.customers-view--details .customers-view__raw-content .customers-view__item .customers-view__item-value {
  position: relative;
  line-height: 2rem;
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.customers-view--details .customers-view__raw-content .customers-view__item .customers-view__item-value {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customers-view--details .customers-view__raw-content .customers-view__item .customers-view__item-value {
  color: hsla(var(--demmi-100-hsl), 1);
}

.customers__sidebar-button {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem 2.4rem;
}
.customers__sidebar-button {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .customers__sidebar-button {
  color: white;
}

.customers__sidebar-button .customers__sidebar-button-text {
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.customers__sidebar-button .customers__sidebar-button-address {
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 1.6rem;
  opacity: 0.7;
}

.customers-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.customers-view .customers-view__title {
  line-height: 4rem;
  font-weight: 300;
  font-size: 3.2rem;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.customers-view .customers-view__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customers-view .customers-view__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.customers-view .customers-view__subtitle {
  line-height: 3rem;
  font-weight: 400;
  font-size: 1.6rem;
  letter-spacing: 0.1rem;
  text-align: start;
  margin-bottom: 4rem;
}
.customers-view .customers-view__subtitle {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .customers-view .customers-view__subtitle {
  color: hsla(var(--demmi-200-hsl), 1);
}

.customers-view .customers-view__subtitle span {
  font-weight: 500;
  letter-spacing: 0.16rem;
}
.customers-view .customers-view__tabs {
  margin-bottom: 3rem;
}
.customers-view .customers-view__content {
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem 2rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.customers-view .customers-view__content .customers-view__item {
  flex: 1 0 100%;
  min-width: 200px;
}
.customers-view .customers-view__content .customers-view__item .customers-view__item-key {
  line-height: 3rem;
  font-size: 1.4rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.customers-view .customers-view__content .customers-view__item .customers-view__item-value {
  position: relative;
  line-height: 2.2rem;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.order-details {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.order-details .order-details__title {
  line-height: 3rem;
  font-weight: 300;
  font-size: 2.4rem;
  letter-spacing: 0.1rem;
  text-align: start;
  margin-top: 3rem;
  margin-left: 2rem;
}
.order-details .order-details__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .order-details .order-details__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.order-details .order-details__raw-content {
  position: relative;
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.order-details .order-details__raw-content pre.order-details__dump {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .order-details .order-details__raw-content pre.order-details__dump {
  background-color: hsla(var(--demmi-900-hsl), 0.5);
}

.order-details .order-details__raw-content pre.order-details__dump {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .order-details .order-details__raw-content pre.order-details__dump {
  color: hsla(var(--demmi-50-hsl), 1);
}

.order-details .order-details__raw-content .order-details__item {
  position: relative;
  flex: 1 0 100%;
  min-width: 200px;
  margin-top: 1rem;
}
.order-details .order-details__raw-content .order-details__item.order-details__item--has-indent::before {
  content: "";
  position: absolute;
  left: 1rem;
  top: 2.5rem;
  bottom: 0rem;
  width: 0.2rem;
  border-radius: 0.2rem;
}
.order-details .order-details__raw-content .order-details__item.order-details__item--has-indent::before {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .order-details .order-details__raw-content .order-details__item.order-details__item--has-indent::before {
  background-color: hsla(var(--demmi-50-hsl), 0.5);
}

.order-details .order-details__raw-content .order-details__item .order-details__item-key {
  position: relative;
  line-height: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
}
.order-details .order-details__raw-content .order-details__item .order-details__item-key {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .order-details .order-details__raw-content .order-details__item .order-details__item-key {
  color: hsla(var(--demmi-50-hsl), 1);
}

.order-details .order-details__raw-content .order-details__item .order-details__item-value {
  position: relative;
  line-height: 2rem;
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.order-details .order-details__raw-content .order-details__item .order-details__item-value {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .order-details .order-details__raw-content .order-details__item .order-details__item-value {
  color: hsla(var(--demmi-100-hsl), 1);
}

.orders__sidebar-button {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem 2.4rem;
}
.orders__sidebar-button {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .orders__sidebar-button {
  color: white;
}

.orders__sidebar-button .orders__sidebar-button-text {
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.orders__sidebar-button .orders__sidebar-button-address {
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 1.6rem;
  opacity: 0.7;
}

.orders-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.orders-view .orders-view__title {
  line-height: 4rem;
  font-weight: 300;
  font-size: 3.2rem;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.orders-view .orders-view__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .orders-view .orders-view__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.orders-view .orders-view__subtitle {
  line-height: 2rem;
  font-weight: 300;
  font-size: 1.8rem;
  letter-spacing: 0.2rem;
  text-align: center;
  margin-bottom: 4rem;
}
.orders-view .orders-view__subtitle {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .orders-view .orders-view__subtitle {
  color: hsla(var(--demmi-100-hsl), 1);
}

.orders-view .orders-view__tabs {
  margin-bottom: 3rem;
}

.demmi-support-chat {
  grid-area: chat;
  position: relative;
  display: flex;
  max-width: 60rem;
  flex-direction: column;
  border-radius: 2rem;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  height: 100%;
}
.demmi-support-chat {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-support-chat {
  background-color: rgba(0, 0, 0, 0.4);
}

.demmi-support-chat.demmi-support-chat--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .demmi-support-chat--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.demmi-support-chat .demmi-support-chat__title {
  display: flex;
  padding: 0.8rem 0.21rem;
  flex-direction: column;
  gap: 0.4rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  margin: 0.3rem;
  border-radius: 1.8rem;
}
.demmi-support-chat .demmi-support-chat__title {
  color: hsla(var(--demmi-900-hsl), 0.6);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__title {
  color: white;
}

.demmi-support-chat .demmi-support-chat__title {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__title {
  background-color: hsla(var(--demmi-300-hsl), 0.2);
}

.demmi-support-chat .demmi-support-chat__title .demmi-support-chat__title-vendor-name {
  font-size: 1.2rem;
  opacity: 0.8;
}
.demmi-support-chat .demmi-support-chat__content {
  flex: 1 1 auto;
  overflow: auto;
  box-sizing: border-box;
  padding: 1rem;
}
.demmi-support-chat .demmi-support-chat__content .demmi-support-chat__no-messages {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 300;
  line-height: 1.8rem;
  text-align: center;
}
.demmi-support-chat .demmi-support-chat__content .demmi-support-chat__no-messages {
  color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__content .demmi-support-chat__no-messages {
  color: hsla(var(--demmi-100-hsl), 1);
}

.demmi-support-chat .demmi-support-chat__input-area {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  gap: 1rem;
  margin: 0 1rem 1rem;
}
.demmi-support-chat .demmi-support-chat__input-area.demmi-support-chat .demmi-support-chat__input-area--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .demmi-support-chat .demmi-support-chat__input-area--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.demmi-support-chat-item {
  position: relative;
  padding: 1rem 1.5rem;
  margin: 0 0.5rem 1rem 6.5rem;
  border-radius: 1.6rem 0 1.6rem 1.6rem;
  opacity: 1;
}
.demmi-support-chat-item {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-support-chat-item {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.demmi-support-chat-item.demmi-support-chat-item--demmi {
  opacity: 1;
  margin: 0 6.5rem 1rem 0.5rem;
  border-radius: 0 1.6rem 1.6rem 1.6rem;
}
.demmi-support-chat-item.demmi-support-chat-item--demmi {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-support-chat-item.demmi-support-chat-item--demmi {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.demmi-support-chat-item.demmi-support-chat-item--demmi:after {
  left: -1rem;
  right: auto;
}
.demmi-support-chat-item.demmi-support-chat-item--demmi:after {
  border-top-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-support-chat-item.demmi-support-chat-item--demmi:after {
  border-top-color: hsla(var(--demmi-800-hsl), 1);
}

.demmi-support-chat-item:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  right: -1rem;
  left: auto;
  top: 0;
  bottom: auto;
  border: 1rem solid;
  box-sizing: border-box;
  border-color: transparent;
}
.demmi-support-chat-item:after {
  border-top-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-support-chat-item:after {
  border-top-color: hsla(var(--demmi-800-hsl), 1);
}

.demmi-support-chat-item .demmi-support-chat-item__text {
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 2rem;
}
.demmi-support-chat-item .demmi-support-chat-item__text {
  color: hsla(var(--demmi-900-hsl), 1);
}
body.theme-dark .demmi-support-chat-item .demmi-support-chat-item__text {
  color: white;
}

.demmi-support-chat-item .demmi-support-chat-item__timestamp {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  text-align: end;
  margin-top: 1rem;
  line-height: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.15rem;
}
.demmi-support-chat-item .demmi-support-chat-item__timestamp {
  color: hsla(var(--demmi-900-hsl), 0.5);
}
body.theme-dark .demmi-support-chat-item .demmi-support-chat-item__timestamp {
  color: hsla(var(--demmi-50-hsl), 0.8);
}

.portal-wrapper--support-chat .page__view {
  min-width: 34rem;
}

.demmi-support__sidebar-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 1.6rem 2.2rem;
}
.demmi-support__sidebar-button {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .demmi-support__sidebar-button {
  color: white;
}

.demmi-support__sidebar-button .demmi-support__sidebar-button-text {
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.demmi-support__sidebar-button .demmi-support__sidebar-button-vendor {
  align-self: flex-end;
  font-size: 1.1rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 2rem;
  border-radius: 0.4rem;
  padding: 0 1rem;
  margin-top: 0.8rem;
  margin-right: -0.8rem;
}
.demmi-support__sidebar-button .demmi-support__sidebar-button-vendor {
  background-color: hsla(var(--demmi-200-hsl), 0.5);
}
body.theme-dark .demmi-support__sidebar-button .demmi-support__sidebar-button-vendor {
  background-color: hsla(var(--demmi-300-hsl), 0.5);
}

.demmi-support__sidebar-button .demmi-support__sidebar-button-vendor {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .demmi-support__sidebar-button .demmi-support__sidebar-button-vendor {
  color: white;
}

.demmi-support__sidebar-button .demmi-support__sidebar-button-message {
  font-size: 1.2rem;
  letter-spacing: 0.08rem;
  font-weight: 500;
  line-height: 1.5rem;
}
.demmi-support__sidebar-button .demmi-support__sidebar-button-message {
  color: hsla(var(--demmi-700-hsl), 0.7);
}
body.theme-dark .demmi-support__sidebar-button .demmi-support__sidebar-button-message {
  color: hsla(var(--demmi-200-hsl), 1);
}

.demmi-support__sidebar-button .demmi-support__sidebar-button-no-message {
  font-size: 1rem;
  letter-spacing: 0.12rem;
  font-weight: 600;
  line-height: 1.5rem;
  text-transform: uppercase;
}
.demmi-support__sidebar-button .demmi-support__sidebar-button-no-message {
  color: hsla(var(--demmi-700-hsl), 0.7);
}
body.theme-dark .demmi-support__sidebar-button .demmi-support__sidebar-button-no-message {
  color: hsla(var(--demmi-200-hsl), 1);
}

.demmi-support-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.demmi-support-view .demmi-support-view__title {
  line-height: 4rem;
  font-weight: 300;
  font-size: 3.2rem;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.demmi-support-view .demmi-support-view__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .demmi-support-view .demmi-support-view__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.demmi-support-view .demmi-support-view__subtitle {
  line-height: 2rem;
  font-weight: 300;
  font-size: 1.8rem;
  letter-spacing: 0.2rem;
  text-align: center;
  margin-bottom: 4rem;
}
.demmi-support-view .demmi-support-view__subtitle {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-support-view .demmi-support-view__subtitle {
  color: hsla(var(--demmi-100-hsl), 1);
}

.vendors-view--details {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.vendors-view--details .vendors-view__title {
  line-height: 3rem;
  font-weight: 300;
  font-size: 2.4rem;
  letter-spacing: 0.1rem;
  text-align: start;
  margin-left: 2rem;
}
.vendors-view--details .vendors-view__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .vendors-view--details .vendors-view__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.vendors-view--details .vendors-view__image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  overflow: auto;
  gap: 1rem;
}
.vendors-view--details .vendors-view__image-grid .vendors-view__image-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 1.5rem;
  padding: 0.5rem;
}
.vendors-view--details .vendors-view__image-grid .vendors-view__image-item {
  background-color: white;
}
body.theme-dark .vendors-view--details .vendors-view__image-grid .vendors-view__image-item {
  background-color: hsla(var(--demmi-900-hsl), 0.2);
}

.vendors-view--details .vendors-view__image-grid .vendors-view__image-item .vendors-view__image-wrapper {
  width: 100%;
  box-sizing: border-box;
  height: 30rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vendors-view--details .vendors-view__image-grid .vendors-view__image-item .vendors-view__image-wrapper img {
  max-height: 100%;
  max-width: 100%;
  border-radius: 0.5rem;
}
.vendors-view--details .vendors-view__content {
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem 2rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.vendors-view--details .vendors-view__content .vendors-view__item {
  flex: 1 0 100%;
  min-width: 200px;
}
.vendors-view--details .vendors-view__content .vendors-view__item .vendors-view__item-key {
  line-height: 3rem;
  font-size: 1.4rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.vendors-view--details .vendors-view__content .vendors-view__item .vendors-view__item-value {
  position: relative;
  line-height: 2.2rem;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.vendors-view--details .vendors-view__content .vendors-view__item .vendors-view__item-value span {
  display: block;
  margin-bottom: 2rem;
}
.vendors-view--details .vendors-view__content .vendors-view__item .vendors-view__item-value span:last-child {
  margin-bottom: 0;
}
.vendors-view--details .vendors-view-shop {
  max-width: 60rem !important;
  min-width: 55rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 1rem;
  padding: 0;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days .demmi-ui-card {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .vendors-view--details .vendors-view-shop .vendors-view-shop__days .demmi-ui-card {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.2rem 1rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item {
  color: white;
}
body.theme-dark .vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item {
  color: hsla(var(--demmi-200-hsl), 1);
}

.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-hours {
  flex: 1 1 18rem;
  display: flex;
  gap: 2rem;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-hours .vendors-view-shop__details-hours-item {
  flex: 1 1 auto;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-hours .vendors-view-shop__details-hours-item .vendors-view-shop__details-hours-item-title {
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
  font-weight: 600;
  line-height: 1.4rem;
  text-transform: uppercase;
  margin: 0.2rem 0 1rem 1rem;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-hours .vendors-view-shop__details-hours-item .vendors-view-shop__details-hours-item-title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-hours .vendors-view-shop__details-hours-item .vendors-view-shop__details-hours-item-title {
  color: white;
}

.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-title {
  flex: 1 1 10rem;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.4rem;
  margin: 0.5rem 1rem 1rem;
}
.vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .vendors-view--details .vendors-view-shop .vendors-view-shop__days .vendors-view-shop__details-item .vendors-view-shop__details-title {
  color: white;
}

.vendors-view--address {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.vendors-view--address .vendors-view__geo {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.vendors-view--address .vendors-view__geo #gmaps-view {
  height: 40rem;
  border-radius: 1rem;
  overflow: hidden;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete {
  width: 30rem;
  box-sizing: border-box;
  margin-top: 0.8rem;
  margin-left: 0.8rem;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input {
  opacity: 0.9;
  box-sizing: border-box;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  opacity: 1;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  box-shadow: 0 0.9rem 1.2rem hsl(99, 100%, 20%,0.18);
}
body.theme-dark .vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  box-shadow: 0 0.9rem 1.2rem hsl(99, 100%, 20%,0.16);
}

.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:hover {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:focus {
  opacity: 1;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:focus {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-input:focus {
  background-color: hsla(var(--demmi-800-hsl), 1);
}

.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-menu {
  margin-top: 0.8rem;
  box-sizing: border-box;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete .demmi-ui-menu .demmi-ui-menu-item {
  text-align: start;
}
.vendors-view--address .vendors-view__geo .gmap-autocomplete .vendors-view--address .vendors-view__geo .gmap-autocomplete__predictions {
  box-sizing: border-box;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden auto;
  max-height: 40rem;
  border-radius: 2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}
.vendors-view--address .vendors-view__geo .vendors-view__address-preview {
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 3rem;
  box-sizing: border-box;
}
.vendors-view--address .vendors-view__geo .vendors-view__address-preview .vendors-view__details-item {
  flex: 1 0 calc(50% - 2rem);
  min-width: 200px;
}
.vendors-view--address .vendors-view__geo .vendors-view__address-preview .vendors-view__details-item .vendors-view__details-key {
  line-height: 2.2rem;
  font-size: 1.2rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.vendors-view--address .vendors-view__geo .vendors-view__address-preview .vendors-view__details-item .vendors-view__details-value {
  position: relative;
  line-height: 2rem;
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.vendors-view--address .vendors-view__geo .vendors-view__buttons-row {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
}

.vendor-inventory {
  position: relative;
  display: grid;
  grid-template: "sidebar content"/34rem 1fr;
  height: 100%;
  width: 100%;
  overflow: hidden;
  gap: 2rem;
  margin-top: 2rem;
}
.vendor-inventory .vendor-inventory__sidebar {
  grid-area: sidebar;
  overflow: auto;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button {
  display: grid;
  grid-template: "image title" 1fr "image info"/5rem 1fr;
  height: 7rem;
  flex-direction: column;
  gap: 0 1.5rem;
  padding: 1rem 1.5rem;
  box-sizing: border-box;
  align-items: center;
  overflow: hidden;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button {
  color: white;
}

.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button .vendor-inventory__sidebar-button-image {
  grid-area: image;
  flex: 0 0 5rem;
  height: 5rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button .vendor-inventory__sidebar-button-image img {
  width: 5rem;
  height: 5rem;
  border-radius: 0.5rem;
  object-fit: cover;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button .vendor-inventory__sidebar-button-title {
  grid-area: title;
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 2rem;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button .vendor-inventory__sidebar-button-text {
  grid-area: info;
  display: flex;
  justify-content: space-between;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 2rem;
  opacity: 0.7;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button .vendor-inventory__sidebar-button-text .vendor-inventory__sidebar-button-variants {
  text-align: start;
}
.vendor-inventory .vendor-inventory__sidebar .vendor-inventory__sidebar-button .vendor-inventory__sidebar-button-text .vendor-inventory__sidebar-button-date {
  text-align: end;
}
.vendor-inventory .vendor-inventory__content {
  grid-area: content;
  display: grid;
  grid-template: "tabs" 5rem "content"/1fr;
  overflow: auto;
  gap: 2rem;
  border-radius: 1.6rem;
  padding: 2rem 1rem 1rem;
}
.vendor-inventory .vendor-inventory__content {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .vendor-inventory .vendor-inventory__content {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.vendor-inventory .vendor-inventory__content .vendor-inventory__tabs {
  grid-area: tabs;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vendor-inventory .vendor-inventory__content .vendor-inventory__content-inner {
  grid-area: content;
}
.vendor-inventory .vendor-inventory__content .vendor-inventory__content-inner .vendor-inventory-variants {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.vendor-stripe {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.vendor-stripe .vendor-stripe__title {
  line-height: 3rem;
  font-weight: 300;
  font-size: 2.4rem;
  letter-spacing: 0.1rem;
  text-align: start;
  margin-top: 3rem;
  margin-left: 2rem;
}
.vendor-stripe .vendor-stripe__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .vendor-stripe .vendor-stripe__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.vendor-raw {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
}
.vendor-raw .vendor-raw__title {
  line-height: 3rem;
  font-weight: 300;
  font-size: 2.4rem;
  letter-spacing: 0.1rem;
  text-align: start;
  margin-top: 3rem;
  margin-left: 2rem;
}
.vendor-raw .vendor-raw__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .vendor-raw .vendor-raw__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.vendors__sidebar-button {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem 2.4rem;
}
.vendors__sidebar-button {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .vendors__sidebar-button {
  color: white;
}

.vendors__sidebar-button .vendors__sidebar-button-text {
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.vendors__sidebar-button .vendors__sidebar-button-address {
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 1.6rem;
  opacity: 0.7;
}

.vendors-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 1rem;
}
.vendors-view .vendors-view__title {
  line-height: 4rem;
  font-weight: 300;
  font-size: 3.2rem;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 3rem;
}
.vendors-view .vendors-view__title {
  color: hsla(var(--demmi-500-hsl), 1);
}
body.theme-dark .vendors-view .vendors-view__title {
  color: hsla(var(--demmi-200-hsl), 1);
}

.vendors-view .vendors-view__tabs {
  margin-bottom: 3rem;
}
.vendors-view .vendors-view__content {
  width: 100%;
  padding: 0rem 1rem 2rem;
  display: flex;
  gap: 3rem 2rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.vendors-view .vendors-view__content .vendors-view__item {
  flex: 1 0 100%;
  min-width: 200px;
}
.vendors-view .vendors-view__content .vendors-view__item .vendors-view__item-key {
  line-height: 3rem;
  font-size: 1.4rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.vendors-view .vendors-view__content .vendors-view__item .vendors-view__item-value {
  position: relative;
  line-height: 2.2rem;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.invite-codes__sidebar-button {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.6rem 2rem;
}
.invite-codes__sidebar-button {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .invite-codes__sidebar-button {
  color: white;
}

.invite-codes__sidebar-button .invite-codes__sidebar-button-code {
  font-size: 1.6rem;
  letter-spacing: 1rem;
  font-weight: 400;
  line-height: 2rem;
}
.invite-codes__sidebar-button .invite-codes__sidebar-button-email {
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 1.6rem;
  opacity: 0.7;
}

.invite-codes-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.invite-codes-view .invite-codes-view__buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}
.invite-codes-view .invite-codes-view__card {
  width: auto;
}
.invite-codes-view .invite-codes-view__card .invite-codes-view__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem 3rem;
}
.invite-codes-view .invite-codes-view__card .invite-codes-view__content .invite-codes-view__code {
  line-height: 5rem;
  text-align: center;
  font-weight: 200;
  font-size: 3.2rem;
  letter-spacing: 1.5rem;
}
.invite-codes-view .invite-codes-view__card .invite-codes-view__content .invite-codes-view__code {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .invite-codes-view .invite-codes-view__card .invite-codes-view__content .invite-codes-view__code {
  color: white;
}

.invite-codes-view .invite-codes-view__card .invite-codes-view__content .invite-codes-view__email {
  line-height: 2rem;
  text-align: center;
  font-weight: 400;
  font-size: 1.4rem;
  letter-spacing: 0.2rem;
}

.demmi-ui-modal {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.demmi-ui-modal.demmi-ui-modal--visible .demmi-ui-modal__content {
  opacity: 1;
}
.demmi-ui-modal.demmi-ui-modal--visible .demmi-ui-modal__backdrop {
  opacity: 1;
}
.demmi-ui-modal .demmi-ui-modal__backdrop {
  opacity: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  inset: 0;
  transition: opacity 0.3s ease-in-out;
}
.demmi-ui-modal .demmi-ui-modal__backdrop {
  background-color: hsla(var(--demmi-900-hsl), 0.8);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__backdrop {
  background-color: rgba(0, 0, 0, 0.8);
}

.demmi-ui-modal .demmi-ui-modal__content {
  position: relative;
  opacity: 0;
  z-index: 1;
  max-height: 100%;
  width: 100%;
  overflow: visible auto;
  transition: opacity 0.2s ease-in-out;
  justify-content: center;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper {
  overflow: hidden;
  border-radius: 2rem;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__divider {
  margin: 2rem 0;
  height: 0.1rem;
  width: 100%;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__divider {
  background-color: hsla(0, 0%, 0%, 0.06);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__divider {
  background-color: black;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area {
  width: 100%;
  box-sizing: border-box;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area {
  margin: unset;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area {
  margin: 1rem 0;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  border-radius: unset;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  border-radius: 1.6rem;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  background-color: hsla(var(--demmi-200-hsl), 0.4);
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  border-radius: unset;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  border-radius: 1.6rem;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  background-color: white;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  background-color: hsla(var(--demmi-100-hsl), 0.8);
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-title {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-buttons {
  padding: 2rem;
  position: relative;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-buttons.demmi-ui-modal__area-buttons--doing-request .demmi-ui-modal__action-buttons {
  opacity: 0.2;
  pointer-events: none;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-buttons .demmi-ui-modal__action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
}

.demmi-ui-button {
  cursor: pointer;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-weight: 500;
  letter-spacing: 0.15rem;
  font-size: 1.3rem;
  line-height: 2rem;
  padding: 1.2rem 2.4rem;
  border: 0.2rem solid;
  border-radius: 1rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.demmi-ui-button {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-button {
  background-color: rgba(0, 0, 0, 0.8);
}

.demmi-ui-button {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-button {
  border-color: transparent;
}

.demmi-ui-button {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-button {
  color: white;
}

.demmi-ui-button {
  box-shadow: 0 0.2rem 0.4rem hsl(99, 100%, 20%,0.22);
}
body.theme-dark .demmi-ui-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-button:disabled {
  cursor: default;
  opacity: 0.4;
}
.demmi-ui-button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-button:not(:disabled):hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-button:not(:disabled):hover {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-button:not(:disabled):active {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-button:not(:disabled):active {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-button.demmi-ui-button--outlined {
  background-color: rgba(255, 255, 255, 0.1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  background-color: transparent;
}

.demmi-ui-button.demmi-ui-button--outlined {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  border-color: 0.5;
}

.demmi-ui-button.demmi-ui-button--outlined {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  color: black;
}

.demmi-ui-button.demmi-ui-button--outlined {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  border-color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  border-color: 1;
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  border-color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  border-color: 1;
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  background-color: rgba(0, 0, 0, 0);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-button.demmi-ui-button--delete {
  border-color: transparent;
  color: white;
}
.demmi-ui-button.demmi-ui-button--delete {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--delete {
  background-color: hsl(0, 40%, 50%);
}

.demmi-ui-button.demmi-ui-button--delete:not(:disabled):hover {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--delete:not(:disabled):hover {
  background-color: hsl(0, 40%, 50%);
}

.demmi-ui-button.demmi-ui-button--delete:not(:disabled):active {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--delete:not(:disabled):active {
  background-color: hsl(0, 40%, 50%);
}

.demmi-ui-button.demmi-ui-button--save {
  border-color: transparent;
  color: white;
}
.demmi-ui-button.demmi-ui-button--save {
  background-color: hsl(90, 50%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--save {
  background-color: hsl(90, 25%, 50%);
}

.demmi-ui-button.demmi-ui-button--save:not(:disabled):hover {
  background-color: hsl(90, 50%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--save:not(:disabled):hover {
  background-color: hsl(90, 25%, 50%);
}

.demmi-ui-button.demmi-ui-button--save:not(:disabled):active {
  background-color: hsl(90, 50%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--save:not(:disabled):active {
  background-color: hsl(90, 25%, 50%);
}

.demmi-ui-button.demmi-ui-button--size-small {
  letter-spacing: 0.15rem;
  font-size: 1.1rem;
  line-height: 1.4rem;
  font-weight: 700;
  padding: 1rem 2rem;
  text-transform: uppercase;
}
.demmi-ui-button .demmi-ui-button__icon {
  margin-right: 1.2rem;
  height: 1.4rem;
  line-height: 1.4rem;
}
.demmi-ui-button .demmi-ui-button__icon svg {
  display: block;
  pointer-events: none;
  height: 1.4rem;
  width: 1.4rem;
}

.demmi-ui-toggle {
  cursor: pointer;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 1.3rem;
  line-height: 1.6rem;
  padding: 0.8rem 0.8rem 0.8rem 1.6rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  border-radius: 1.2rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
}
.demmi-ui-toggle {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .demmi-ui-toggle {
  color: rgba(255, 255, 255, 0.8);
}

.demmi-ui-toggle input {
  display: none;
}
.demmi-ui-toggle input:checked ~ .demmi-ui-toggle__indicator:before {
  transform: translate3d(2.8rem, 0, 0);
}
.demmi-ui-toggle input:checked ~ .demmi-ui-toggle__indicator:before {
  background-color: 1;
}
body.theme-dark .demmi-ui-toggle input:checked ~ .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--demmi-100-hsl), 1);
}

.demmi-ui-toggle:hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-toggle:hover {
  background-color: rgba(255, 255, 255, 0.12);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator {
  cursor: pointer;
  position: relative;
  width: 6rem;
  height: 3.2rem;
  border-radius: 2rem;
}
.demmi-ui-toggle .demmi-ui-toggle__indicator {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator {
  background-color: 0.3;
}

.demmi-ui-toggle .demmi-ui-toggle__indicator {
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.08);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator {
  box-shadow: 0 0.1rem 0.1rem rgba(255, 255, 255, 0.16);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  position: absolute;
  content: "";
  height: 2.4rem;
  width: 2.4rem;
  left: 0.4rem;
  top: 0.4rem;
  border-radius: 50%;
  transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
}
.demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--demmi-50-hsl), 0.4);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--demmi-100-hsl), 0.2);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  box-shadow: inset 0 0.1rem 0.1rem rgb(255, 255, 255), 0 0.2rem 0.4rem rgba(0, 0, 0, 0.16);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  box-shadow: inset 0 0.1rem 0.1rem rgba(255, 255, 255, 0.12), 0 0.2rem 0.4rem rgba(0, 0, 0, 0.32);
}

.demmi-ui-toggle.demmi-ui-toggle--disabled {
  pointer-events: none;
  opacity: 0.6;
}

.demmi-ui-icon-button {
  cursor: pointer;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6rem;
  border-radius: 0.8rem;
  box-sizing: border-box;
  padding: 1.2rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
  color: rgba(255, 255, 255, 0.8);
  background-color: hsla(var(--theme-bg-hue), 20%, 10%, 0);
}
.demmi-ui-icon-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.24);
}
body.theme-dark .demmi-ui-icon-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-icon-button:disabled {
  cursor: default;
  opacity: 0.4;
}
.demmi-ui-icon-button:not(:disabled):hover {
  border-radius: 50%;
}
.demmi-ui-icon-button:not(:disabled):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.demmi-ui-icon-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 50%;
}
.demmi-ui-icon-button:not(:disabled):active {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):active {
  background-color: hsla(var(--demmi-400-hsl), 0.4);
}

.demmi-ui-icon-button:not(:disabled):focus-visible {
  transform: translate3d(0, -0.1rem, 0);
}
.demmi-ui-icon-button:not(:disabled):focus-visible {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):focus-visible {
  background-color: hsla(var(--demmi-400-hsl), 0.4);
}

.demmi-ui-icon-button svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.demmi-ui-icon-button svg {
  color: hsla(var(--demmi-400-hsl), 1);
}
body.theme-dark .demmi-ui-icon-button svg {
  color: white;
}

.demmi-ui-icon-button.demmi-ui-icon-button--invert:not(:disabled):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.4);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--invert:not(:disabled):hover {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.demmi-ui-icon-button.demmi-ui-icon-button--invert:not(:disabled):active {
  background-color: hsla(var(--demmi-400-hsl), 0.6);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--invert:not(:disabled):active {
  background-color: hsla(var(--demmi-400-hsl), 0.4);
}

.demmi-ui-icon-button.demmi-ui-icon-button--invert:not(:disabled):focus-visible {
  background-color: hsla(var(--demmi-400-hsl), 0.6);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--invert:not(:disabled):focus-visible {
  background-color: hsla(var(--demmi-400-hsl), 0.4);
}

.demmi-ui-icon-button.demmi-ui-icon-button--invert svg {
  color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--invert svg {
  color: white;
}

.demmi-ui-icon-button.demmi-ui-icon-button--small {
  line-height: 1.2rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--small svg {
  height: 1.2rem;
  width: 1.2rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--mini {
  line-height: 1rem;
  padding: 0.8rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--mini svg {
  height: 1.1rem;
  width: 1.1rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--mini:not(:disabled):active {
  border-radius: 50%;
}

.demmi-ui-item-switch {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: center;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
  width: fit-content;
  box-sizing: border-box;
  padding: 0rem 0.4rem;
  margin: 0;
  border-radius: 0.8rem;
  gap: 0.4rem;
}
.demmi-ui-item-switch {
  background-color: hsla(var(--demmi-100-hsl), 0.4);
}
body.theme-dark .demmi-ui-item-switch {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.demmi-ui-item-switch .demmi-ui-item-switch__item {
  z-index: 1;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 1.2rem 2rem;
  transition: opacity 0.1s ease-in-out;
  background: rgba(255, 0, 0, 0.1);
  background: transparent;
  opacity: 0.8;
}
.demmi-ui-item-switch .demmi-ui-item-switch__item .demmi-ui-item-switch__item-content {
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.12rem;
  text-align: center;
  overflow: hidden;
}
.demmi-ui-item-switch .demmi-ui-item-switch__item:hover:not(.demmi-ui-item-switch--active) {
  opacity: 1;
}
.demmi-ui-item-switch .demmi-ui-item-switch__item.demmi-ui-item-switch__item--active {
  opacity: 1;
}
.demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  position: absolute;
  top: 0.4rem;
  bottom: 0.4rem;
  left: 0;
  pointer-events: none;
  border-radius: 0.8rem;
  transition: all 0.3s cubic-bezier(0.38, 0.1, 0.26, 1.41);
  background-color: white;
}
.demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.12);
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item:hover:not(.demmi-ui-item-switch--active) .demmi-ui-button-switch__item {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item:hover:not(.demmi-ui-item-switch--active) .demmi-ui-button-switch__item {
  color: hsla(var(--demmi-50-hsl), 1);
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item.demmi-ui-item-switch__item--active .demmi-ui-button-switch__item {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item.demmi-ui-item-switch__item--active .demmi-ui-button-switch__item {
  color: hsla(var(--demmi-600-hsl), 1);
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item {
  z-index: 1;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  height: 1.4rem;
  align-items: center;
  padding: 0;
  transition: color 0.1s ease;
  background: rgba(255, 0, 0, 0.1);
  background: transparent;
}
.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item {
  color: hsla(var(--demmi-800-hsl), 0.8);
}
body.theme-dark .demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item {
  color: hsla(var(--demmi-100-hsl), 1);
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item .demmi-ui-button-switch__item-text {
  pointer-events: none;
  background-color: transparent;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.12rem;
  text-align: center;
  overflow: hidden;
}
.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  top: -0.2rem;
  bottom: -0.2rem;
  left: 0;
}

.demmi-ui-input-file-button {
  display: block;
  margin: 0 auto;
  cursor: pointer;
  font-size: 1.3rem;
  box-sizing: border-box;
  line-height: 2rem;
  padding: 1.2rem 2.4rem;
  border-radius: 1rem;
  font-weight: 500;
  letter-spacing: 0.15rem;
  border: 0.2rem solid;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.demmi-ui-input-file-button {
  box-shadow: 0 0.2rem 0.4rem hsl(99, 100%, 20%,0.22);
}
body.theme-dark .demmi-ui-input-file-button {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-input-file-button {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-input-file-button {
  background-color: rgba(0, 0, 0, 0.8);
}

.demmi-ui-input-file-button {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-input-file-button {
  border-color: transparent;
}

.demmi-ui-input-file-button {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-input-file-button {
  color: white;
}

.demmi-ui-input-file-button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-input-file-button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-input-file-button:not(:disabled):hover {
  border-color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):hover {
  border-color: transparent;
}

.demmi-ui-input-file-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-input-file-button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-input-file-button:not(:disabled):active {
  border-color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):active {
  border-color: transparent;
}

.demmi-ui-input-time {
  width: 18rem;
  box-sizing: border-box;
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  border-radius: 1.6rem;
}
.demmi-ui-input-time {
  background-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-input-time {
  background-color: hsla(var(--demmi-100-hsl), 0.6);
}

.demmi-ui-input-time span {
  font-size: 1.8rem;
  font-weight: 600;
}
.demmi-ui-input-time span {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-input-time span {
  color: black;
}

.demmi-ui-input-time .demmi-ui-input-time__button {
  flex: 1 1 50%;
  cursor: pointer;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.3rem;
  box-sizing: border-box;
  line-height: 1.4rem;
  padding: 1.2rem;
  border-radius: 1.4rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.demmi-ui-input-time .demmi-ui-input-time__button {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button {
  background-color: hsla(var(--demmi-700-hsl), 0.7);
}

.demmi-ui-input-time .demmi-ui-input-time__button {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button {
  border-color: transparent;
}

.demmi-ui-input-time .demmi-ui-input-time__button {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button {
  color: white;
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  background-color: hsla(var(--demmi-800-hsl), 0.9);
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  background-color: hsla(var(--demmi-800-hsl), 0.9);
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-input-time.demmi-ui-input-time--disabled .demmi-ui-input-time__button {
  cursor: default;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll {
  max-height: 20rem;
  padding: 0.5rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
  overflow: auto;
}
.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll {
  background-color: white;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item {
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-align: center;
  border-radius: 1.6rem;
  padding: 1.2rem 1.6rem;
  cursor: pointer;
  user-select: none;
}
.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item {
  color: black;
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item {
  color: black;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  background-color: black;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  color: black;
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  color: white;
}

.demmi-ui-input {
  padding: 1rem 1.6rem;
  font-size: 1.3rem;
  letter-spacing: 0.08rem;
  line-height: 2rem;
  border-radius: 1rem;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  border: 0.2rem solid transparent;
  transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.demmi-ui-input {
  background-color: hsla(var(--demmi-600-hsl), 0.04);
}
body.theme-dark .demmi-ui-input {
  background-color: hsla(var(--demmi-400-hsl), 0.2);
}

.demmi-ui-input {
  color: hsla(var(--demmi-800-hsl), 1);
}
body.theme-dark .demmi-ui-input {
  color: hsla(var(--demmi-50-hsl), 1);
}

.demmi-ui-input {
  border-color: hsla(var(--demmi-700-hsl), 0.2);
}
body.theme-dark .demmi-ui-input {
  border-color: transparent;
}

.demmi-ui-input.demmi-ui-input--error {
  border-color: rgb(228, 97, 97);
}
body.theme-dark .demmi-ui-input.demmi-ui-input--error {
  border-color: rgb(219, 113, 113);
}

.demmi-ui-input.demmi-ui-input--invert {
  background-color: rgba(255, 255, 255, 0.3);
}
body.theme-dark .demmi-ui-input.demmi-ui-input--invert {
  background-color: 0.3;
}

.demmi-ui-input.demmi-ui-input--invert {
  border-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-ui-input.demmi-ui-input--invert {
  border-color: transparent;
}

.demmi-ui-input:hover {
  background-color: hsla(var(--demmi-600-hsl), 0.08);
}
body.theme-dark .demmi-ui-input:hover {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.demmi-ui-input:hover.demmi-ui-input--invert {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .demmi-ui-input:hover.demmi-ui-input--invert {
  background-color: 0.4;
}

.demmi-ui-input:focus {
  border-radius: 3rem;
}
.demmi-ui-input:focus {
  background-color: hsla(var(--demmi-600-hsl), 0.08);
}
body.theme-dark .demmi-ui-input:focus {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.demmi-ui-input:focus {
  border-color: hsla(var(--demmi-700-hsl), 0.2);
}
body.theme-dark .demmi-ui-input:focus {
  border-color: transparent;
}

.demmi-ui-input:focus {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-input:focus {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-input:focus.demmi-ui-input--invert {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .demmi-ui-input:focus.demmi-ui-input--invert {
  background-color: 0.5;
}

.demmi-ui-input::placeholder {
  color: hsla(var(--demmi-900-hsl), 0.5);
}
body.theme-dark .demmi-ui-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.demmi-ui-input__wrapper {
  position: relative;
}
.demmi-ui-input__wrapper textarea.demmi-ui-input {
  height: 40rem;
  max-width: 100%;
  min-width: 100%;
  resize: none;
  box-sizing: border-box;
  padding-bottom: 3rem;
}
.demmi-ui-input__wrapper textarea.demmi-ui-input:focus {
  border-radius: 1rem;
}
.demmi-ui-input__wrapper .demmi-ui-input__max-length {
  position: absolute;
  bottom: 1rem;
  right: 0.6rem;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.4rem;
  border-radius: 0.5rem;
  text-transform: uppercase;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  color: white;
  backdrop-filter: blur(10px);
}
.demmi-ui-input__wrapper .demmi-ui-input__max-length {
  background-color: hsla(var(--demmi-700-hsl), 0.4);
}
body.theme-dark .demmi-ui-input__wrapper .demmi-ui-input__max-length {
  background-color: 0.8;
}

.demmi-ui-menu {
  opacity: 0;
  transform: translate3d(0, -1.2rem, 0);
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  position: fixed;
  top: 10rem;
  left: 10rem;
  z-index: 9999;
}
.demmi-ui-menu .demmi-ui-menu__card {
  box-sizing: border-box;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden auto;
  max-height: 40rem;
  border-radius: 2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}
.demmi-ui-menu.demmi-ui-menu--static {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  position: relative;
  top: unset;
  left: unset;
}
.demmi-ui-menu.demmi-ui-menu--visible {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.demmi-ui-menu .demmi-ui-menu__section-heading {
  padding: 2rem 0rem 0;
  margin: 0 2rem 0.8rem;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.8rem;
  letter-spacing: 0.1rem;
}
.demmi-ui-menu .demmi-ui-menu__section-heading {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu__section-heading {
  color: rgba(255, 255, 255, 0.6);
}

.demmi-ui-menu .demmi-ui-menu__section-items {
  padding: 1rem;
}
.demmi-ui-menu .demmi-ui-menu__divider {
  height: 0.1rem;
  margin: 2rem -1rem;
}
.demmi-ui-menu .demmi-ui-menu__divider {
  background-color: rgba(0, 0, 0, 0.08);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu__divider {
  background-color: rgba(255, 255, 255, 0.08);
}

.demmi-ui-menu .demmi-ui-menu-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  border-radius: 0.8rem;
  padding: 1.4rem 2rem 1.4rem 1.6rem;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.4rem;
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
  background: transparent;
  outline: none;
  border: none;
}
.demmi-ui-menu .demmi-ui-menu-item {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu-item {
  color: black;
}

.demmi-ui-menu .demmi-ui-menu-item svg {
  width: 1.4rem;
  height: 1.4rem;
  opacity: 0.6;
}
.demmi-ui-menu .demmi-ui-menu-item:disabled {
  opacity: 0.4;
}
.demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  background-color: black;
}

.demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  color: rgba(0, 0, 0, 0.8);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  color: white;
}

.demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) svg {
  opacity: 0.8;
}
.demmi-ui-menu.demmi-ui-menu--visible .demmi-ui-menu__content {
  opacity: 1;
}
.demmi-ui-menu.demmi-ui-menu--visible .demmi-ui-menu__backdrop {
  opacity: 1;
}

.demmi-ui-menu-trigger-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2rem;
  padding-right: 1.6rem;
}
.demmi-ui-menu-trigger-button {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-menu-trigger-button {
  background-color: rgba(255, 255, 255, 0.8);
}

.demmi-ui-menu-trigger-button {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-menu-trigger-button {
  border-color: transparent;
}

.demmi-ui-menu-trigger-button {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-menu-trigger-button {
  color: black;
}

.demmi-ui-menu-trigger-button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-menu-trigger-button:not(:disabled):hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-menu-trigger-button:not(:disabled):hover {
  background-color: white;
}

.demmi-ui-menu-trigger-button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(99, 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-menu-trigger-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-menu-trigger-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-menu-trigger-button:not(:disabled):active {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-menu-trigger-button:not(:disabled):active {
  background-color: white;
}

.demmi-ui-menu-trigger-button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(99, 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-menu-trigger-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(99, 100%, 20%,0.28);
}

.demmi-ui-menu-trigger-button .demmi-ui-menu-trigger-button__content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.2rem;
}
.demmi-ui-menu-trigger-button .demmi-ui-menu-trigger-button__dropdown-icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.demmi-ui-menu-trigger-button .demmi-ui-menu-trigger-button__dropdown-icon svg {
  color: hsla(var(--demmi-400-hsl), 1);
}
body.theme-dark .demmi-ui-menu-trigger-button .demmi-ui-menu-trigger-button__dropdown-icon svg {
  color: black;
}

.demmi-ui-chip {
  cursor: pointer;
  position: relative;
  width: fit-content;
  box-sizing: border-box;
  padding: 0.8rem 1.6rem;
  border-radius: 2rem;
  border: 0.2rem solid;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
}
.demmi-ui-chip {
  background-color: hsla(var(--demmi-50-hsl), 0.6);
}
body.theme-dark .demmi-ui-chip {
  background-color: 0.2;
}

.demmi-ui-chip {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-chip {
  border-color: 0.5;
}

.demmi-ui-chip input {
  display: none;
}
.demmi-ui-chip.demmi-ui-chip--active {
  background-color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .demmi-ui-chip.demmi-ui-chip--active {
  background-color: 1;
}

.demmi-ui-chip.demmi-ui-chip--active {
  border-color: hsla(var(--demmi-200-hsl), 1);
}
body.theme-dark .demmi-ui-chip.demmi-ui-chip--active {
  border-color: transparent;
}

.demmi-ui-chip.demmi-ui-chip--active .demmi-ui-chip__text {
  font-weight: 500;
}
.demmi-ui-chip.demmi-ui-chip--active .demmi-ui-chip__text {
  color: white;
}
body.theme-dark .demmi-ui-chip.demmi-ui-chip--active .demmi-ui-chip__text {
  color: white;
}

.demmi-ui-chip .demmi-ui-chip__text {
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.12rem;
}
.demmi-ui-chip .demmi-ui-chip__text {
  color: hsla(var(--demmi-700-hsl), 1);
}
body.theme-dark .demmi-ui-chip .demmi-ui-chip__text {
  color: white;
}

.demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  background-color: 0.6;
}

.demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  border-color: hsla(var(--demmi-100-hsl), 1);
}
body.theme-dark .demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  border-color: 0.6;
}

.demmi-ui-chip.demmi-ui-chip--disabled {
  pointer-events: none;
  opacity: 0.4;
}

.demmi-ui-card {
  width: 100%;
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
}
.demmi-ui-card {
  color: var(--demmi-600);
}
body.theme-dark .demmi-ui-card {
  color: var(--demmi-100);
}

.demmi-ui-card {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-card {
  background-color: hsla(var(--demmi-400-hsl), 0.3);
}

.demmi-ui-card {
  border-radius: 1.6rem;
}
body.theme-dark .demmi-ui-card {
  border-radius: 1.6rem;
}

body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  width: unset;
  padding: 0;
}
body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  background-color: unset;
}
body.theme-dark body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  background-color: unset;
}

body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  border-radius: unset;
}
body.theme-dark body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  border-radius: unset;
}

.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__title {
  margin-bottom: 0;
}
.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__title .demmi-ui-card__button-collapse svg {
  transform: rotate3d(0, 0, 1, 180deg);
}
.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__content {
  display: none;
}
.demmi-ui-card .demmi-ui-card__title {
  height: 4.4rem;
  max-height: 4.4rem;
  display: flex;
  justify-content: space-between;
  line-height: 4.4rem;
  margin: 0 0 1rem 1rem;
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  text-transform: uppercase;
  align-items: flex-end;
}
.demmi-ui-card .demmi-ui-card__title {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .demmi-ui-card .demmi-ui-card__title {
  color: rgba(255, 255, 255, 0.7);
}

.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__button-collapse {
  margin-left: -1rem;
  margin-right: 1rem;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__button-collapse svg {
  transition: transform 0.2s ease-in-out;
}
.demmi-ui-card .demmi-ui-card__title span {
  display: flex;
  align-items: center;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__title-with-subtitle {
  line-height: 2rem;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__title-with-subtitle .demmi-ui-card__subtitle {
  display: flex;
  justify-content: space-between;
  line-height: 1.6rem;
  padding-bottom: 0.4rem;
  font-size: 1.1rem;
  letter-spacing: 0.15rem;
  font-weight: 600;
  text-transform: uppercase;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__control-buttons {
  display: flex;
  gap: 1rem;
}
.demmi-ui-card .demmi-ui-card__divider {
  margin: 1rem 0;
  height: 0.2rem;
  width: 100%;
}
.demmi-ui-card .demmi-ui-card__divider {
  background-color: hsla(var(--demmi-50-hsl), 1);
}
body.theme-dark .demmi-ui-card .demmi-ui-card__divider {
  background-color: 0.2;
}

.demmi-ui-card.demmi-ui-card--loading .demmi-ui-card__content {
  opacity: 0.4;
}

.firebase-emulator-warning {
  display: none;
}

html {
  font-size: 62.5%;
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: "Montserrat", "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  color: hsla(172, 80%, 10%, 0.6);
  background-color: black;
}

* {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  font-family: "Montserrat", "Raleway", sans-serif;
}

button {
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
}

input,
textarea {
  font-family: "Montserrat", "Raleway", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/styles/utils/colours.scss","webpack://./src/styles/index.scss","webpack://./src/styles/utils/scrollbar.scss","webpack://./src/styles/utils/cssvars.scss","webpack://./src/styles/demmi-core.scss","webpack://./src/styles/core/text.scss","webpack://./src/styles/components/asyncImage/async-image.scss","webpack://./src/styles/components/loadingOverlay/loading-overlay.scss","webpack://./src/styles/components/loadingOverlay/element-loading-spinner.scss","webpack://./src/styles/components/toolbar/toolbar.scss","webpack://./src/styles/utils/elevations.scss","webpack://./src/styles/components/sidebar/sidebar-button.scss","webpack://./src/styles/components/sidebar/sidebar.scss","webpack://./src/styles/utils/constants.scss","webpack://./src/styles/components/themeSwitcher/theme-switcher.scss","webpack://./src/styles/components/notifications/notifications-panel.scss","webpack://./src/styles/components/notifications/notifications-item.scss","webpack://./src/styles/components/notifications/notifications.scss","webpack://./src/styles/components/portalWrapper/_portal-sidebar-button.scss","webpack://./src/styles/components/portalWrapper/_portal-sidebar.scss","webpack://./src/styles/components/portalWrapper/portal-wrapper.scss","webpack://./src/styles/components/rawDetails/raw-details.scss","webpack://./src/styles/components/page/page.scss","webpack://./src/styles/components/modals/_modal-create-invite-code.scss","webpack://./src/styles/pages/login/_card-authentication.scss","webpack://./src/styles/pages/login/_error.scss","webpack://./src/styles/pages/login/login.scss","webpack://./src/styles/pages/home/_customer-details.scss","webpack://./src/styles/pages/home/home.scss","webpack://./src/styles/pages/customers/_customer-address.scss","webpack://./src/styles/pages/customers/_customer-details.scss","webpack://./src/styles/pages/customers/customers.scss","webpack://./src/styles/pages/orders/_order-details.scss","webpack://./src/styles/pages/orders/orders.scss","webpack://./src/styles/pages/support/_chat.scss","webpack://./src/styles/utils/utils.scss","webpack://./src/styles/pages/support/_chat-item.scss","webpack://./src/styles/pages/support/support.scss","webpack://./src/styles/pages/vendors/_vendor-details.scss","webpack://./src/styles/pages/vendors/_vendor-address.scss","webpack://./src/styles/pages/vendors/_vendor-inventory.scss","webpack://./src/styles/pages/vendors/_vendor-stripe.scss","webpack://./src/styles/pages/vendors/_vendor-raw.scss","webpack://./src/styles/pages/vendors/vendors.scss","webpack://./src/styles/pages/inviteCodes/invite-codes.scss","webpack://./src/styles/demmi-ui/_modal.scss","webpack://./src/styles/demmi-ui/_button.scss","webpack://./src/styles/demmi-ui/_toggle.scss","webpack://./src/styles/demmi-ui/_icon-button.scss","webpack://./src/styles/demmi-ui/_item-switch.scss","webpack://./src/styles/demmi-ui/_button-switch.scss","webpack://./src/styles/demmi-ui/_input-file-button.scss","webpack://./src/styles/demmi-ui/_input-time.scss","webpack://./src/styles/demmi-ui/_input.scss","webpack://./src/styles/demmi-ui/_menu.scss","webpack://./src/styles/demmi-ui/_menu-trigger-button.scss","webpack://./src/styles/demmi-ui/_chip.scss","webpack://./src/styles/demmi-ui/_card.scss"],"names":[],"mappings":"AAMA;EACI,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;EAEA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,gFAAA;ACRJ;;ADaA;;CAAA;AAgBA;;;;;CAAA;AEpEI;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ADmDR;ACjDiB;EACL,gCAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,0CAAA;ADmDZ;ACjDY;EACI,oBAAA;EACA,0CAAA;ADmDhB;ACjDY;EACI,oBAAA;EACA,0CAAA;ADmDhB;;AChDiB;EACL,uBAAA;EACA,mBAAA;ADmDZ;;ACjDiB;EACL,6BAAA;ADoDZ;;AC9CI;EACI,6BAAA;ADiDR;AC/CiB;EACL,gCAAA;EACA,iDAAA;ADiDZ;AC/CY;EACI,+CAAA;ADiDhB;AC/CY;EACI,+CAAA;ADiDhB;;AC9CiB;EACL,uBAAA;ADiDZ;;AC/CiB;EACL,6BAAA;ADkDZ;;AEvGA;EAEI,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,uDAAA;EACA,2DAAA;AFyGJ;;AG7GA;EACI;IACI,kCAAA;IACA,UAAA;EHgHN;EG9GE;IACI,mBAAA;EHgHN;AACF;AG7GA;EACI;IACI,mBAAA;EH+GN;EG7GE;IACI,kCAAA;IACA,UAAA;EH+GN;AACF;AG5GA;EACI,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AH8GJ;AD9DI;EAIQ,yBInD4B;AHgHxC;AD1DiB;EAID,YI1D4C;AHmH5D;;AGjHI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AHoHR;ADhCI;EACI,UAAA;EAEA,qBAAA;ACiCR;AD/EI;EAEQ,iDAAA;ACgFZ;AD3EiB;EAED,iDAAA;AC4EhB;;ADpCQ;EACI,UAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,wQAtCkB;EAuClB,0BAAA;EACA,4BAAA;ACuCZ;ADrCQ;EACI,UAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,+BAAA;ACuCZ;ADvGI;EAIQ,0BA6DqC;ACyCjD;ADnGiB;EAID,2BAsD6C;AC4C7D;;AD7GI;EAIQ,YA8D8B;AC+C1C;AD1GiB;EAID,YAuD+B;ACkD/C;;AD9CY;EACI,YAAA;EACA,wQA3Ca;AC4F7B;;AIhLA;EACI,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AJmLJ;AI5MI;EACI,aAyBgB;EAxBhB,kBAAA;EACA,WAAA;EACA,WAsBsB;EArBtB,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AJ8MR;AI5MQ;EAbJ;IAcQ,aAAA;EJ+MV;AACF;ADpJI;EAIQ,yBKnD4B;AJsMxC;ADhJiB;EAID,gCK1D4C;AJyM5D;;AItMA;EACI,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AJyMJ;AI7OI;EACI,aAoCgB;EAnChB,kBAAA;EACA,WAAA;EACA,WAiCsB;EAhCtB,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AJ+OR;AI7OQ;EAbJ;IAcQ,aAAA;EJgPV;AACF;ADrLI;EAIQ,yBKxC4B;AJ4NxC;ADjLiB;EAID,gCK/C4C;AJ+N5D;;AI5NA;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AJ+NJ;AI9QI;EACI,aA+CgB;EA9ChB,kBAAA;EACA,WAAA;EACA,WA4CsB;EA3CtB,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AJgRR;AI9QQ;EAbJ;IAcQ,aAAA;EJiRV;AACF;ADtNI;EAIQ,yBK7B4B;AJkPxC;ADlNiB;EAID,gCKpC4C;AJqP5D;;AIlPA;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AJqPJ;AI/SI;EACI,aA0DgB;EAzDhB,kBAAA;EACA,WAAA;EACA,WAuDsB;EAtDtB,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AJiTR;AI/SQ;EAbJ;IAcQ,aAAA;EJkTV;AACF;ADvPI;EAIQ,yBKlB4B;AJwQxC;ADnPiB;EAID,gCKzB4C;AJ2Q5D;;AIxQA;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AJ2QJ;AIjVI;EACI,aAsEgB;EArEhB,kBAAA;EACA,WAAA;EACA,WAmEsB;EAlEtB,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AJmVR;AIjVQ;EAbJ;IAcQ,aAAA;EJoVV;AACF;ADzRI;EAIQ,yBKN4B;AJ8RxC;ADrRiB;EAID,gCKb4C;AJiS5D;;AI9RA;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AJiSJ;AInXI;EACI,aAkFgB;EAjFhB,kBAAA;EACA,WAAA;EACA,WA+EsB;EA9EtB,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AJqXR;AInXQ;EAbJ;IAcQ,aAAA;EJsXV;AACF;AD3TI;EAIQ,yBKM4B;AJoTxC;ADvTiB;EAID,gCKD4C;AJuT5D;;AIpTA;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AJuTJ;AD1UI;EAIQ,yBKgB4B;AJyTxC;ADtUiB;EAID,yBKS4C;AJ4T5D;;AI1TI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,UAAA;AJ6TR;AD3VI;EAIQ,oCK2B2C;AJ+TvD;ADvViB;EAID,oCKoB2D;AJkU3E;;AI9TQ;EACI,UAAA;AJiUZ;;AI5TA;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AJ+TJ;AI7TI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,oCAAA;AJ+TR;ADzXI;EAIQ,oCKwD2C;AJgUvD;ADrXiB;EAID,0CKiD2D;AJmU3E;;AI/TA;EACI,aAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AJkUJ;AD7YI;EAIQ,yBKwE4B;AJoUxC;ADzYiB;EAID,+BKiE4C;AJuU5D;;AIpUA;EACI,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;AJuUJ;;AIlUI;;EACI,aAAA;AJsUR;;AKhfA;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALkfJ;AK/eQ;EACI,sCAAA;ALifZ;AK/eQ;EACI,wCAAA;ALifZ;AK7eI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AL+eR;AK7eQ;EAGI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;AL6eZ;ADrcI;EAIQ,gHMlDkB;ALsf9B;ADjciB;EAID,gEMxDa;ALwf7B;;AKhfY;EACI,WAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;ALmfhB;ADrdI;EAIQ,gHMlDkB;ALsgB9B;ADjdiB;EAID,gEMxDa;ALwgB7B;;AKrfY;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ALwfhB;ADleI;EAIQ,kCMzBmD;AL0f/D;AD9diB;EAID,qBMhCwE;AL6fxF;;AKvfA;EACI;IACI,uBAAA;EL0fN;EKxfE;IACI,yBAAA;EL0fN;AACF;AKvfA;EACI;IACI,UAAA;ELyfN;EKvfE;IACI,UAAA;ELyfN;AACF;AKtfA;EACI;IACI,UAAA;ELwfN;EKtfE;IACI,UAAA;ELwfN;AACF;AM5kBA;EAEI,kBAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;AN6kBJ;AD5gBI;EAIQ,uBOjEJ;AN4kBR;ADxgBiB;EAED,+CAAA;ACygBhB;;ADlhBI;EAIQ,uFO1DkB;AN4kB9B;AD/gBiB;EAID,wFO5Da;AN0kB7B;;ADzhBI;EAIQ,uFO1DkB;ANmlB9B;ADthBiB;EAID,wFO5Da;ANilB7B;;AMnkBQ;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;ANskBZ;AMnkBQ;EACI,sCAAA;EACA,qBAAA;EACA,UAAA;ANqkBZ;AMjkBI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;ANmkBR;AMhkBI;EACI,kBAAA;ANkkBR;AMhkBQ;EACI,YAAA;ANkkBZ;AM9jBI;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBP9EO;EO+EP,oBAAA;EACA,iBAAA;ANgkBR;AM7jBI;EAGI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8CAAA;EACA,oCAAA;EACA,wFATa;EAUb,YAAA;AN6jBR;AM3jBQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,wFAnBS;ANglBrB;AM1jBQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AN4jBZ;AD/lBI;EAIQ,uBOgC+C;AN8jB3D;AD3lBiB;EAED,+CAAA;AC4lBhB;;AM5jBQ;EACI,UAAA;EACA,eAAA;AN+jBZ;;AM1jBA;EACI;IACI,UAAA;IACA,0BAAA;EN6jBN;EM3jBE;IACI,mBAAA;IACA,2BAAA;EN6jBN;AACF;AM1jBA;EACI;IACI,mBAAA;IACA,2BAAA;EN4jBN;EM1jBE;IACI,UAAA;IACA,0BAAA;EN4jBN;AACF;AMzjBA;EACI;IACI,uBAAA;EN2jBN;EMzjBE;IACI,yBAAA;EN2jBN;AACF;AMxjBA;EACI;IACI,2BAAA;IACA,UAAA;EN0jBN;EMvjBE;IACI,6BAAA;IACA,YAAA;ENyjBN;EMtjBE;IACI,2BAAA;IACA,UAAA;ENwjBN;AACF;AMrjBA;EACI;IACI,aAAA;ENujBN;EMpjBE;IACI,cAAA;IACA,UAAA;ENsjBN;EMnjBE;IACI,SAAA;IACA,UAAA;ENqjBN;AACF;AMnjBA;EACI;IACI,cAAA;ENqjBN;EMljBE;IACI,eAAA;IACA,UAAA;ENojBN;EMjjBE;IACI,SAAA;IACA,UAAA;ENmjBN;AACF;AO1vBA;EAEI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AP2vBJ;AOzvBI;EACI,aAAA;AP2vBR;AOxvBI;EAGI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,YAAA;EACA,cAAA;APwvBR;ADlsBI;EAIQ,gHQlEc;APmwB1B;AD9rBiB;EAID,gEQxES;APqwBzB;;AO3vBQ;EACI,WAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AP8vBZ;ADltBI;EAIQ,gHQlEc;APmxB1B;AD9sBiB;EAID,gEQxES;APqxBzB;;AOhwBQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;APmwBZ;AD/tBI;EAIQ,kCQvC+C;APqwB3D;AD3tBiB;EAED,iDAAA;AC4tBhB;;AOnwBA;EACI;IACI,uBAAA;EPswBN;EOpwBE;IACI,yBAAA;EPswBN;AACF;AQvzBA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;ARyzBJ;AQvzBI;EACI,aAAA;EACA,WAAA;EACA,qBAAA;ARyzBR;AD1vBI;EAEQ,8CAAA;AC2vBZ;ADtvBiB;EAED,iDAAA;ACuvBhB;;AQ5zBQ;EACI,iBAAA;EACA,8BAAA;EACA,iCAAA;AR+zBZ;AQ5zBQ;EACI,+BAAA;EACA,kCAAA;EACA,gBAAA;AR8zBZ;AQ5zBY;EACI,gBAAA;AR8zBhB;AQ1zBQ;EACI,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sIACI;AR2zBhB;ADxxBI;EAEQ,sCAAA;ACyxBZ;ADpxBiB;EAID,YS1CqC;AR6zBrD;;AD9xBI;EAIQ,uBShCmD;AR8zB/D;AD3xBiB;EAED,+CAAA;AC4xBhB;;ADryBI;EAEQ,sCAAA;ACuyBZ;ADlyBiB;EAID,YStCyC;ARu0BzD;;ASj2BI;EACI,kDAAA;ATo2BR;AS/1BiB;EACL,yCAAA;ATi2BZ;;ADnzBI;EAEQ,sCAAA;ACqzBZ;ADhzBiB;EAID,YSlC6C;ARi1B7D;;AQ70BY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;ARg1BhB;ADp0BI;EAEQ,sCAAA;ACq0BZ;ADh0BiB;EAID,YStByC;ARq1BzD;;AQn1BY;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ARs1BhB;ADj1BI;EAIQ,0CSLmD;ARq1B/D;AD70BiB;EAED,iDAAA;AC80BhB;;AS54BI;EACI,kDAAA;AT+4BR;AS14BiB;EACL,yCAAA;AT44BZ;;AQ31BY;EACI,0CAAA;AR81BhB;ADl2BI;EAIQ,0CSCmD;ARg2B/D;AD91BiB;EAED,iDAAA;AC+1BhB;;AS75BI;EACI,mDAAA;ATg6BR;AS35BiB;EACL,yCAAA;AT65BZ;;AQp2BI;EACI;IACI,WAAA;ERu2BV;EQr2BU;IACI,sBAAA;IACA,WAAA;ERu2Bd;EQr2Bc;IACI,iBAAA;IACA,uBAAA;ERu2BlB;AACF;AQl2BI;EAIgB;IACI,aAAA;ERi2BtB;AACF;AQ31BI;EAGY;IACI,aAAA;ER21BlB;AACF;AQt1BI;EA1HJ;IA2HQ,WAAA;IACA,WAAA;ERy1BN;EQx1BM;IACI,wBAAA;IACA,WAAA;IACA,WAAA;ER01BV;EQz1BU;IACI,eAAA;IACA,qBAAA;IAEA,wBAAA;ER01Bd;EQx1BU;IACI,qBAAA;ER01Bd;EQv1BU;IACI,sBAAA;IACA,WAAA;IACA,oBAAA;ERy1Bd;EQx1Bc;IACI,cAAA;ER01BlB;AACF;;AU7+BA;EAEI,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wDAAA;EACA,qKACI;AV8+BR;ADn7BI;EAIQ,yBW1D4B;AV4+BxC;AD/6BiB;EAID,YWjE4C;AV++B5D;;AU7+BI;EACI,YAAA;AVg/BR;AD77BI;EAIQ,0CWnD2C;AV++BvD;ADz7BiB;EAED,iDAAA;AC07BhB;;ADn8BI;EAIQ,0CW/C2C;AVk/BvD;ADh8BiB;EAED,iDAAA;ACi8BhB;;AD18BI;EAIQ,uBW3C2C;AVq/BvD;ADv8BiB;EAED,iDAAA;ACw8BhB;;ADj9BI;EAIQ,yBW1CgC;AV2/B5C;AD98BiB;EAID,YWjDgD;AV8/BhE;;ADx9BI;EAIQ,yBWtCwC;AV8/BpD;ADr9BiB;EAID,YW7CwD;AVigCxE;;AU5/BI;EACI,cAAA;EACA,mBAAA;AV+/BR;AU7/BQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AV+/BZ;AD1+BI;EAIQ,yBWxBoC;AVigChD;ADt+BiB;EAID,+BW/BoD;AVogCpE;;AUhgCI;EACI,cAAA;EACA,UAAA;AVmgCR;;AW3jCA;EACI,kBAAA;EACA,YCVW;EDWX,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sCAAA;EACA,oCAAA;AX8jCJ;ADlgCI;EAEQ,8CAAA;ACmgCZ;AD9/BiB;EAED,iDAAA;AC+/BhB;;AWjkCI;EACI,YCtBO;EDuBP,UAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;AXokCR;AWlkCQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AXokCZ;AD7hCI;EAEQ,sCAAA;AC8hCZ;ADzhCiB;EAID,YYjDqC;AXykCrD;;AWvkCY;EACI,aAAA;EACA,WAAA;AX0kChB;AWtkCQ;EACI,gBAAA;AXwkCZ;AWpkCI;EACI,YCtDO;EDuDP,UAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,oCAAA;AXskCR;AWnkCI;EACI,+BAAA;EACA,uBAAA;AXqkCR;AWpkCQ;EACI,UAAA;AXskCZ;AWpkCQ;EACI,UAAA;AXskCZ;AWpkCQ;EACI,UAAA;EACA,oCAAA;EACA,oBAAA;AXskCZ;AWlkCI;EACI,+BAAA;AXokCR;AWnkCQ;EACI,UAAA;AXqkCZ;AWnkCQ;EACI,UAAA;AXqkCZ;AWnkCQ;EACI,UAAA;EACA,oCAAA;EACA,oBAAA;AXqkCZ;AWjkCI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WCrGgB;EDsGhB,gEACI;AXkkCZ;AW/jCQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AXikCZ;ADvmCI;EAEQ,oCAAA;ACwmCZ;ADnmCiB;EAED,oCAAA;AComChB;;AatrCA;EAEI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,mEACI;AburCR;AD1nCI;EAEQ,iDAAA;AC2nCZ;ADtnCiB;EAED,iDAAA;ACunChB;;AazrCI;EACI,iCAAA;Ab4rCR;AazrCI;EACI,iCAAA;Ab2rCR;AaxrCI;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAjCG;EAkCH,WAlCG;EAmCH,WAAA;EACA,2BAAA;Ab0rCR;AaxrCQ;EACI,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,+BAAA;Ab0rCZ;ADzpCI;EAIQ,YcpCoC;Ab4rChD;ADrpCiB;EAID,Yc3CuC;Ab+rCvD;;Aa9rCY;EACI,cAAA;EACA,aAAA;AbisChB;Aa9rCQ;EACI,aAAA;AbgsCZ;ADvqCI;EAEQ,sCAAA;ACwqCZ;ADnqCiB;EAID,Yc/ByC;AbisCzD;;AD7qCI;EAEQ,sCAAA;AC+qCZ;AD1qCiB;EAID,Yc5ByC;AbqsCzD;;Aa7rCY;EACI,UAAA;EACA,QAAA;AbgsChB;Aa3rCI;EACI,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;Ab6rCR;ADpsCI;EAIQ,uBcI2C;Ab+rCvD;ADhsCiB;EAED,+CAAA;ACisChB;;Aa9rCQ;EACI,kCAAA;AbisCZ;Aa7rCQ;EACI,kCAAA;Ab+rCZ;;Ac3xCA;EAEI,kBAAA;EACA,QAAA;EACA,aAAA;Ad6xCJ;Ac1xCQ;EACI,UAAA;Ad4xCZ;Ac1xCQ;EACI,UAAA;Ad4xCZ;Ac1xCQ;EACI,mCAAA;EACA,+BAAA;Ad4xCZ;AcxxCI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;Ad0xCR;AD1uCI;EAIQ,oCejDA;Ad0xCZ;ADtuCiB;EAID,oCevDJ;Ad4xCZ;;ActxCA;EAEI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAPI;EAQJ,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kCAAA;AdwxCJ;AD9vCI;EAIQ,yBe7B4B;Ad0xCxC;AD1vCiB;EAID,YepC4C;Ad6xC5D;;ADpwCI;EAIQ,uBe1BJ;Ad8xCR;ADjwCiB;EAID,oDehCR;AdgyCR;;AD3wCI;EAIQ,4DerBJ;AdgyCR;ADxwCiB;EAID,+Ce3BR;AdkyCR;;Ac/xCI;EACI,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AdkyCR;AD3xCI;EAEQ,sCAAA;AC4xCZ;ADvxCiB;EAED,mCAAA;ACwxChB;;AcpyCI;EACI,cAAA;EACA,gBAAA;AduyCR;;Aeh3CA;EAEI,kBAAA;EACA,aAAA;EACA,6GACI;EAKJ,oBAAA;EACA,WAAA;EACA,oCAAA;EACA,uCAAA;EACA,6CAAA;Af62CJ;ADjzCI;EAEQ,6CAAA;ACkzCZ;AD7yCiB;EAED,6CAAA;AC8yChB;;Aeh3CI;EACI,mBAAA;Afm3CR;AD3zCI;EAEQ,kDAAA;AC4zCZ;ADvzCiB;EAED,iDAAA;ACwzChB;;Aej3CQ;EACI,kBAAA;Afo3CZ;Ael3CQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;Afo3CZ;AD90CI;EAIQ,oCgBzC+C;Afs3C3D;AD10CiB;EAID,oCgBhD+D;Afy3C/E;;Aer3CI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;Afw3CR;ADp2CI;EAEQ,sCAAA;ACq2CZ;ADh2CiB;EAED,mCAAA;ACi2ChB;;AD12CI;EAEQ,8CAAA;AC42CZ;ADv2CiB;EAED,iDAAA;ACw2ChB;;Aej4CQ;EACI,kBAAA;EACA,cAAA;Afo4CZ;Aeh4CI;EACI,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;Afk4CR;ADx4CI;EAEQ,sCAAA;ACy4CZ;ADp4CiB;EAED,mCAAA;ACq4ChB;;AD94CI;EAEQ,8CAAA;ACg5CZ;AD34CiB;EAED,iDAAA;AC44ChB;;Ae34CQ;EACI,kBAAA;EACA,cAAA;Af84CZ;Ae34CQ;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;Af64CZ;Aez4CI;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;Af24CR;AD36CI;EAEQ,sCAAA;AC46CZ;ADv6CiB;EAED,mCAAA;ACw6ChB;;Ae74CI;EACI,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;Afg5CR;AS/+CI;EACI,yCAAA;ATi/CR;AS5+CiB;EACL,yCAAA;AT8+CZ;;Ae/4CI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;Afk5CR;ADt8CI;EAEQ,sCAAA;ACu8CZ;ADl8CiB;EAED,mCAAA;ACm8ChB;;Aer5CQ;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wBAAA;Afw5CZ;Aet5CY;EACI,gBAAA;Afw5ChB;;AgB5hDA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AhB+hDJ;AgB7hDI;EALJ;IAMQ,YAAA;IACA,WAAA;EhBgiDN;AACF;AgB9hDI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AhBgiDR;ADj/CI;EAIQ,oCiBhDA;AhBgiDZ;AD7+CiB;EAID,oCiBtDJ;AhBkiDZ;;AiBlkDA;EAEI,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wDAAA;EACA,qKACI;AjBmkDR;ADzgDI;EAIQ,YkBzD4B;AjBikDxC;ADrgDiB;EAID,YkBhE+B;AjBokD/C;;AiBlkDI;EACI,YAAA;AjBqkDR;ADnhDI;EAIQ,0CkB/CA;AjBikDZ;AD/gDiB;EAED,iDAAA;ACghDhB;;ADzhDI;EAIQ,0CkBtCA;AjB+jDZ;ADthDiB;EAED,iDAAA;ACuhDhB;;ADhiDI;EAIQ,0CkB7BA;AjB6jDZ;AD7hDiB;EAED,iDAAA;AC8hDhB;;AiB1jDI;EACI,cAAA;EACA,mBAAA;AjB6jDR;AiB3jDQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AjB6jDZ;ADljDI;EAIQ,YkBZI;AjB6jDhB;AD9iDiB;EAID,+BkBlBA;AjB+jDhB;;AkBnoDA;EAKI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AlBkoDJ;AkB/nDI;EACI,eAAA;AlBioDR;ADnkDI;EAIQ,amBhEsC;AlBkoDlD;AD/jDiB;EAID,cmBvEwC;AlBqoDxD;;ADzkDI;EAIQ,cmB7DsC;AlBsoDlD;ADtkDiB;EAID,amBpEyC;AlByoDzD;;AkBtoDQ;EACI,YAAA;AlByoDZ;AkBroDI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AlBuoDR;AkBpoDI;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AlBsoDR;AkBnoDI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;AlBqoDR;AkBnoDQ;;EAEI,aAAA;EACA,8BAAA;AlBqoDZ;AkBloDQ;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AlBooDZ;AD9nDI;EAEQ,oCAAA;AC+nDZ;AD1nDiB;EAED,oCAAA;AC2nDhB;;AkBtoDQ;EACI,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AlByoDZ;AD5oDI;EAEQ,oCAAA;AC6oDZ;ADxoDiB;EAED,oCAAA;ACyoDhB;;AmBxtDA;EAEI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,8CAAA;AnB0tDJ;AmBxtDI;EAEI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAPe;EAQf,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gEAAA;EACA,gBAAA;AnBytDR;AD3qDI;EAIQ,oCoB/CA;AnBytDZ;ADvqDiB;EAED,+CAAA;ACwqDhB;;AmBxtDQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,mBAzBW;AnBovDvB;ADzrDI;EAIQ,6IoBnCI;AnB2tDhB;ADrrDiB;EAID,gHoBpCA;AnBwtDhB;;AmBhtDQ;EACI,aAAA;EACA,cAAA;EACA,qBAAA;AnBmtDZ;AmB/sDI;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YApEI;AnBqxDZ;AmB/sDQ;EACI,kBAAA;EACA,YAxEA;EAyEA,WAzEA;EA0EA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AnBitDZ;AmB/sDQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AnBitDZ;AD5tDI;EAIQ,aoBU0C;AnBitDtD;ADxtDiB;EAID,coBG4C;AnBotD5D;;ADluDI;EAIQ,coBa0C;AnBqtDtD;AD/tDiB;EAID,aoBM6C;AnBwtD7D;;AmBrtDY;EACI,cAAA;AnBwtDhB;AmBrtDQ;EACI,WAjGA;AnBwzDZ;AmBntDI;EAnGJ;IAoGQ,cAAA;EnBstDN;EmBptDM;IACI,aAAA;IACA,8BAAA;EnBstDV;EmBptDc;IACI,aAAA;EnBstDlB;EmBptDc;IACI,cAAA;EnBstDlB;EmB/sDc;IACI,cAAA;EnBitDlB;EmB/sDc;IACI,aAAA;EnBitDlB;EmB9sDU;IACI,mCAAA;EnBgtDd;EmB9sDU;IACI,UAAA;EnBgtDd;EmB5sDM;IACI,kBAAA;IACA,UAAA;IACA,cAAA;IACA,QAAA;IACA,kCAAA;EnB8sDV;EmB3sDM;IACI,kBAAA;IACA,SAhJA;IAiJA,SAAA;IACA,OAAA;IACA,YAAA;IACA,UAAA;IACA,oCAAA;EnB6sDV;EmB3sDU;IACI,aAAA;EnB6sDd;AACF;;AoBv2DA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;ApB02DJ;AoBx2DI;EACI,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;ApB02DR;AoBx2DQ;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;ApB02DZ;ADpzDI;EAEQ,iDAAA;ACqzDZ;ADhzDiB;EAED,iDAAA;ACizDhB;;AoB72DY;EACI,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;ApBg3DhB;ADr0DI;EAEQ,oCAAA;ACs0DZ;ADj0DiB;EAED,oCAAA;ACk0DhB;;AD30DI;EAEQ,oCAAA;AC60DZ;ADx0DiB;EAED,mCAAA;ACy0DhB;;ADl1DI;EAEQ,iDAAA;ACo1DZ;AD/0DiB;EAED,iDAAA;ACg1DhB;;AoB33DY;EACI,aAAA;EACA,SAAA;ApB83DhB;AD91DI;EAEQ,oCAAA;AC+1DZ;AD11DiB;EAED,mCAAA;AC21DhB;;AoB/3DgB;EACI,cAAA;ApBk4DpB;AoB73DQ;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;ApB+3DZ;AoB73DY;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;ApB+3DhB;ADv3DI;EAEQ,+CAAA;ACw3DZ;ADn3DiB;EAED,gDAAA;ACo3DhB;;AoBj4DY;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;ApBo4DhB;ADr4DI;EAEQ,oCAAA;ACs4DZ;ADj4DiB;EAED,mCAAA;ACk4DhB;;AoBt4DY;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;ApBy4DhB;ADr5DI;EAEQ,oCAAA;ACs5DZ;ADj5DiB;EAED,oCAAA;ACk5DhB;;AqBn+DA;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,6CAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,iCAAA;ArBs+DJ;ADx6DI;EAIQ,yBsBjE4B;ArBw+DxC;ADp6DiB;EAID,YsBxE4C;ArB2+D5D;;AqBz+DI;EACI,8CAAA;ArB4+DR;AqBz+DI;EACI,8CAAA;ArB2+DR;AqBx+DI;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;ArB0+DR;;AsBzgEA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;AtB2gEJ;AsBzgEI;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AtB2gER;ADh9DI;EAIQ,yBuB9DgC;AtB6gE5C;AD58DiB;EAID,YuBrEgD;AtBghEhE;;AsB7gEI;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AtBghER;ADl+DI;EAIQ,uBuB/CA;AtBghEZ;AD99DiB;EAID,wBuBrDJ;AtBkhEZ;;AsB9gEI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AtBihER;ADn/DI;EAEQ,iDAAA;ACo/DZ;AD/+DiB;EAED,iDAAA;ACg/DhB;;AsB9gEQ;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AtBihEZ;ADjgEI;EAEQ,oCAAA;ACkgEZ;AD7/DiB;EAED,oCAAA;AC8/DhB;;AsBnhEQ;EACI,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AtBshEZ;AD/gEI;EAEQ,oCAAA;ACghEZ;AD3gEiB;EAED,oCAAA;AC4gEhB;;AsBvhEY;EACI,gBAAA;AtB0hEhB;;AuBlmEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;AvBqmEJ;AuBnmEI;EACI,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EAEA,mBAAA;EACA,gBAAA;AvBomER;AuBlmEQ;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBxBhCE;EwBiCF,yBAAA;AvBomEZ;AuBlmEY;EACI,YAAA;AvBomEhB;AuBjmEY;EACI,gBAAA;EACA,cAAA;AvBmmEhB;AuB/lEQ;EACI,uBAAA;EACA,sBAAA;AvBimEZ;AuB/lEY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AvBimEhB;AuB7lEQ;EACI,UAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AvB+lEZ;AuB7lEY;EACI,UAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;AvB+lEhB;ADzlEI;EAEQ,+CAAA;AC0lEZ;ADrlEiB;EAID,qCwBbI;AvBimEpB;;AwBxqEA;EAEI,gBAAA;EACA,wBAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,iHAAA;AxB0qEJ;AwBvqEI;EACI,UAAA;EACA,aAAA;AxByqER;AwBtqEI;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AxBwqER;;AyBhsEA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gEAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;AzBmsEJ;AyBjsEI;EACI,kCAAA;EACA,UAAA;AzBmsER;AyB/rEQ;EACI,gBAAA;AzBisEZ;AyB/rEQ;EACI,gBAAA;AzBisEZ;AyB7rEI;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;AzB+rER;ASjtEI;EACI,yCAAA;ATmtER;AS9sEiB;EACL,yCAAA;ATgtEZ;;AyB9rEI;EACI,UAAA;EACA,6DAAA;AzBisER;ADvqEI;EAEQ,8CAAA;ACwqEZ;ADnqEiB;EAED,iDAAA;ACoqEhB;;AD7qEI;EAIQ,yB0BpBuC;AzBisEnD;AD1qEiB;EAID,yB0B3BgD;AzBosEhE;;ADprEI;EAEQ,oCAAA;ACsrEZ;ADjrEiB;EAED,mCAAA;ACkrEhB;;AShvEI;EACI,yCAAA;ATmvER;AS9uEiB;EACL,yCAAA;ATgvEZ;;ADlsEI;EAEQ,8CAAA;ACosEZ;AD/rEiB;EAED,iDAAA;ACgsEhB;;AS9vEI;EACI,yCAAA;ATiwER;AS5vEiB;EACL,yCAAA;AT8vEZ;;ADhtEI;EAEQ,8CAAA;ACktEZ;AD7sEiB;EAED,iDAAA;AC8sEhB;;AS5wEI;EACI,yCAAA;AT+wER;AS1wEiB;EACL,yCAAA;AT4wEZ;;AyBrtEI;EACI,eAAA;EACA,YAAA;EACA,WAAA;AzBwtER;;A0B7yEA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;A1BgzEJ;A0B9yEI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;A1BgzER;ADrvEI;EAEQ,oCAAA;ACsvEZ;ADjvEiB;EAED,oCAAA;ACkvEhB;;A0BlzEI;EACI,aAAA;EACA,4DAAA;EACA,cAAA;EACA,SAAA;A1BqzER;A0BnzEQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;A1BqzEZ;ADzwEI;EAIQ,uB2B/C+C;A1BuzE3D;ADrwEiB;EAED,iDAAA;ACswEhB;;A0BxzEY;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A1B2zEhB;A0BzzEgB;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;A1B2zEpB;A0BrzEI;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;A1BuzER;A0BrzEQ;EACI,cAAA;EACA,gBAAA;A1BuzEZ;A0BrzEY;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A1BuzEhB;A0BrzEY;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;A1BuzEhB;A0BrzEgB;EACI,cAAA;EACA,mBAAA;A1BuzEpB;A0BrzEoB;EACI,gBAAA;A1BuzExB;A0BhzEI;EAEI,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;A1BizER;A0B/yEQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;A1BizEZ;ADp1EI;EAIQ,oC2BkCmD;A1BizE/D;ADh1EiB;EAED,iDAAA;ACi1EhB;;A0BjzEY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;A1BozEhB;ADn2EI;EAIQ,Y2B4CwC;A1BszEpD;AD/1EiB;EAED,oCAAA;ACg2EhB;;A0BvzEgB;EACI,eAAA;EACA,aAAA;EACA,SAAA;A1B0zEpB;A0BxzEoB;EACI,cAAA;A1B0zExB;A0BxzEwB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;A1B0zE5B;AD13EI;EAEQ,oCAAA;AC23EZ;ADt3EiB;EAID,Y2BsDqD;A1B+zErE;;A0B1zEgB;EACI,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;A1B6zEpB;ADz4EI;EAEQ,oCAAA;AC04EZ;ADr4EiB;EAID,Y2BkE6C;A1Bk0E7D;;A2Bx9EA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;A3By9EJ;A2Bt9EI;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,wB5BnBM;E4BoBN,gBAAA;EACA,mBAAA;A3Bw9ER;A2Br9EI;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;A3Bu9ER;A2Bp9EI;EAhCJ;IAiCQ,uBAAA;E3Bu9EN;AACF;;A4Bz/EA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;A5B4/EJ;A4B1/EI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;A5B4/ER;A4B1/EQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;A5B4/EZ;A4Bz/EQ;EAEI,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;A5B0/EZ;A4Bx/EY;EACI,YAAA;EACA,sBAAA;A5B0/EhB;AD78EI;EAEQ,8CAAA;AC88EZ;ADz8EiB;EAED,+CAAA;AC08EhB;;A4B7/EgB;EACI,UAAA;A5BggFpB;AS5gFI;EACI,mDAAA;AT8gFR;ASzgFiB;EACL,mDAAA;AT2gFZ;;AD79EI;EAEQ,8CAAA;AC+9EZ;AD19EiB;EAED,+CAAA;AC29EhB;;A4BxgFgB;EACI,UAAA;A5B2gFpB;ADx+EI;EAEQ,8CAAA;ACy+EZ;ADp+EiB;EAED,+CAAA;ACq+EhB;;A4B5gFY;EACI,kBAAA;EACA,sBAAA;A5B+gFhB;A4B7gFgB;EACI,iBAAA;A5B+gFpB;A4B3gFY;EACI,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0HACI;A5B4gFpB;A4BvgFQ;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;A5BygFZ;A4BvgFY;EACI,0BAAA;EACA,gBAAA;A5BygFhB;A4BvgFgB;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A5BygFpB;A4BvgFgB;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;A5BygFpB;A4BpgFQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;A5BsgFZ;;A6B3mFA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;A7B8mFJ;A6B5mFI;EACI,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;A7B8mFR;ADnjFI;EAEQ,+CAAA;ACojFZ;AD/iFiB;EAED,iDAAA;ACgjFhB;;ADzjFI;EAEQ,oCAAA;AC2jFZ;ADtjFiB;EAED,mCAAA;ACujFhB;;A6B/mFQ;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A7BknFZ;A6BhnFY;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;A7BknFhB;ADhlFI;EAEQ,+CAAA;ACilFZ;AD5kFiB;EAED,gDAAA;AC6kFhB;;A6B9mFY;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A7BinFhB;AD9lFI;EAEQ,oCAAA;AC+lFZ;AD1lFiB;EAED,mCAAA;AC2lFhB;;A6BnnFY;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;A7BsnFhB;AD9mFI;EAEQ,oCAAA;AC+mFZ;AD1mFiB;EAED,oCAAA;AC2mFhB;;A8B1rFA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;A9B6rFJ;AD3nFI;EAEQ,sCAAA;AC4nFZ;ADvnFiB;EAID,Y+B5E6B;A9BksF7C;;A8BhsFI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;A9BmsFR;A8BjsFI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;A9BmsFR;;A8B/rFA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;A9BisFJ;A8B/rFI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A9BisFR;ADjqFI;EAEQ,oCAAA;ACkqFZ;AD7pFiB;EAED,oCAAA;AC8pFhB;;A8BnsFI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;A9BssFR;ADhrFI;EAEQ,oCAAA;ACirFZ;AD5qFiB;EAED,oCAAA;AC6qFhB;;A8BzsFQ;EACI,gBAAA;EACA,uBAAA;A9B4sFZ;A8BxsFI;EACI,mBAAA;A9B0sFR;A8BvsFI;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;A9BysFR;A8BvsFQ;EACI,cAAA;EACA,gBAAA;A9BysFZ;A8BvsFY;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A9BysFhB;A8BvsFY;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;A9BysFhB;;A+BlyFA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;A/BqyFJ;A+BnyFI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;A/BqyFR;AD1uFI;EAEQ,oCAAA;AC2uFZ;ADtuFiB;EAED,oCAAA;ACuuFhB;;A+BvyFI;EACI,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;A/B0yFR;AD1vFI;EAEQ,+CAAA;AC2vFZ;ADtvFiB;EAED,iDAAA;ACuvFhB;;ADhwFI;EAEQ,oCAAA;ACkwFZ;AD7vFiB;EAED,mCAAA;AC8vFhB;;A+B3yFQ;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A/B8yFZ;A+B5yFY;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;A/B8yFhB;ADvxFI;EAEQ,+CAAA;ACwxFZ;ADnxFiB;EAED,gDAAA;ACoxFhB;;A+B1yFY;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A/B6yFhB;ADryFI;EAEQ,oCAAA;ACsyFZ;ADjyFiB;EAED,mCAAA;ACkyFhB;;A+B/yFY;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;A/BkzFhB;ADrzFI;EAEQ,oCAAA;ACszFZ;ADjzFiB;EAED,oCAAA;ACkzFhB;;AgCl4FA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AhCq4FJ;ADl0FI;EAEQ,sCAAA;ACm0FZ;AD9zFiB;EAID,YiC7E6B;AhC04F7C;;AgCx4FI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AhC24FR;AgCz4FI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AhC24FR;;AgCv4FA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AhCy4FJ;AgCv4FI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AhCy4FR;ADx2FI;EAEQ,oCAAA;ACy2FZ;ADp2FiB;EAED,oCAAA;ACq2FhB;;AgC34FI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AhC84FR;ADv3FI;EAEQ,oCAAA;ACw3FZ;ADn3FiB;EAED,oCAAA;ACo3FhB;;AgCh5FI;EACI,mBAAA;AhCm5FR;;AiC38FA;EAEI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AjC68FJ;AD/4FI;EAEQ,8CAAA;ACg5FZ;AD34FiB;EAID,oCkCrER;AjC+8FR;;AkCl+FI;EACI,YAAA;AlCq+FR;AkCj+FQ;EACI,YAAA;AlCm+FZ;;AiCh9FI;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AjCm9FR;AD36FI;EAEQ,sCAAA;AC46FZ;ADv6FiB;EAID,YkClDiC;AjCw9FjD;;ADj7FI;EAIQ,oCkCxCA;AjCy9FZ;AD96FiB;EAED,iDAAA;AC+6FhB;;AiCv9FQ;EACI,iBAAA;EACA,YAAA;AjC09FZ;AiCt9FI;EACI,cAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;AjCw9FR;AiCt9FQ;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AjCw9FZ;AD/8FI;EAEQ,sCAAA;ACg9FZ;AD38FiB;EAED,oCAAA;AC48FhB;;AiCz9FI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AjC49FR;AkC1iGI;EACI,YAAA;AlC4iGR;AkCxiGQ;EACI,YAAA;AlC0iGZ;;AmC7iGA;EAII,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qCAAA;EACA,UAAA;AnC6iGJ;AD3+FI;EAIQ,oCoCrEuC;AnC+iGnD;ADv+FiB;EAED,+CAAA;ACw+FhB;;AmChjGI;EACI,UAAA;EACA,4BAAA;EACA,qCAAA;AnCmjGR;ADv/FI;EAIQ,oCoC/D2C;AnCqjGvD;ADn/FiB;EAED,+CAAA;ACo/FhB;;AmCtjGQ;EACI,WAAA;EACA,WAAA;AnCyjGZ;ADlgGI;EAIQ,oCoC1D+C;AnC2jG3D;AD9/FiB;EAED,+CAAA;AC+/FhB;;AmC1jGI;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AnC6jGR;ADthGI;EAIQ,oCoC1C2C;AnC+jGvD;ADlhGiB;EAED,+CAAA;ACmhGhB;;AmC/jGI;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AnCkkGR;ADniGI;EAEQ,oCAAA;ACoiGZ;AD/hGiB;EAID,YoCzCiC;AnCukGjD;;AmCpkGI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AnCukGR;ADtjGI;EAEQ,sCAAA;ACujGZ;ADljGiB;EAED,qCAAA;ACmjGhB;;AoCjoGI;EACI,gBAAA;ApCooGR;;AoChoGA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;ApCmoGJ;ADxkGI;EAEQ,sCAAA;ACykGZ;ADpkGiB;EAID,YqCrE6B;ApCwoG7C;;AoCtoGI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;ApCyoGR;AoCtoGI;EACI,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;ApCwoGR;ADhmGI;EAEQ,iDAAA;ACimGZ;AD5lGiB;EAED,iDAAA;AC6lGhB;;ADtmGI;EAEQ,oCAAA;ACwmGZ;ADnmGiB;EAID,YqC3CiC;ApC6oGjD;;AoC1oGI;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;ApC6oGR;ADpnGI;EAEQ,sCAAA;ACqnGZ;ADhnGiB;EAED,oCAAA;ACinGhB;;AoC/oGI;EACI,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;ApCkpGR;ADloGI;EAEQ,sCAAA;ACmoGZ;AD9nGiB;EAED,oCAAA;AC+nGhB;;AoCnpGA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;ApCqpGJ;AoCnpGI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ApCqpGR;AD1pGI;EAEQ,oCAAA;AC2pGZ;ADtpGiB;EAED,oCAAA;ACupGhB;;AoCvpGI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;ApC0pGR;ADzqGI;EAEQ,oCAAA;AC0qGZ;ADrqGiB;EAED,oCAAA;ACsqGhB;;AqCxvGA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;ArC2vGJ;AqCzvGI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;ArC2vGR;AD/rGI;EAEQ,oCAAA;ACgsGZ;AD3rGiB;EAED,oCAAA;AC4rGhB;;AqC7vGI;EACI,aAAA;EACA,4DAAA;EACA,cAAA;EACA,SAAA;ArCgwGR;AqC9vGQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;ArCgwGZ;ADntGI;EAIQ,uBsChD+C;ArCkwG3D;AD/sGiB;EAED,iDAAA;ACgtGhB;;AqCnwGY;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArCswGhB;AqCpwGgB;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;ArCswGpB;AqChwGI;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;ArCkwGR;AqChwGQ;EACI,cAAA;EACA,gBAAA;ArCkwGZ;AqChwGY;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;ArCkwGhB;AqChwGY;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;ArCkwGhB;AqChwGgB;EACI,cAAA;EACA,mBAAA;ArCkwGpB;AqChwGoB;EACI,gBAAA;ArCkwGxB;AqC3vGI;EAEI,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;ArC4vGR;AqC1vGQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;ArC4vGZ;AD9xGI;EAIQ,oCsCiCmD;ArC4vG/D;AD1xGiB;EAED,iDAAA;AC2xGhB;;AqC5vGY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;ArC+vGhB;AD7yGI;EAIQ,YsC2CwC;ArCiwGpD;ADzyGiB;EAED,oCAAA;AC0yGhB;;AqClwGgB;EACI,eAAA;EACA,aAAA;EACA,SAAA;ArCqwGpB;AqCnwGoB;EACI,cAAA;ArCqwGxB;AqCnwGwB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;ArCqwG5B;ADp0GI;EAEQ,oCAAA;ACq0GZ;ADh0GiB;EAID,YsCqDqD;ArC0wGrE;;AqCrwGgB;EACI,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;ArCwwGpB;ADn1GI;EAEQ,oCAAA;ACo1GZ;AD/0GiB;EAID,YsCiE6C;ArC6wG7D;;AsCl6GA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AtCq6GJ;AsCn6GI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AtCq6GR;AsCn6GQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AtCq6GZ;AsCl6GQ;EAEI,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AtCm6GZ;AsCj6GY;EACI,YAAA;EACA,sBAAA;AtCm6GhB;ADt3GI;EAEQ,8CAAA;ACu3GZ;ADl3GiB;EAED,+CAAA;ACm3GhB;;AsCt6GgB;EACI,UAAA;AtCy6GpB;ASr7GI;EACI,mDAAA;ATu7GR;ASl7GiB;EACL,mDAAA;ATo7GZ;;ADt4GI;EAEQ,8CAAA;ACw4GZ;ADn4GiB;EAED,+CAAA;ACo4GhB;;AsCj7GgB;EACI,UAAA;AtCo7GpB;ADj5GI;EAEQ,8CAAA;ACk5GZ;AD74GiB;EAED,+CAAA;AC84GhB;;AsCr7GY;EACI,kBAAA;EACA,sBAAA;AtCw7GhB;AsCt7GgB;EACI,iBAAA;AtCw7GpB;AsCp7GY;EACI,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0HACI;AtCq7GpB;AsCh7GQ;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AtCk7GZ;AsCh7GY;EACI,0BAAA;EACA,gBAAA;AtCk7GhB;AsCh7GgB;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AtCk7GpB;AsCh7GgB;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;AtCk7GpB;AsC76GQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AtC+6GZ;;AuCnhHA;EACI,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AvCshHJ;AuCphHI;EACI,kBAAA;EACA,cAAA;AvCshHR;AuCphHQ;EACI,aAAA;EACA,sDACI;EAEJ,YAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AvCohHZ;ADr+GI;EAEQ,sCAAA;ACs+GZ;ADj+GiB;EAID,YwCzDqC;AvCyhHrD;;AuCvhHY;EACI,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AvC0hHhB;AuCvhHgB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AvCyhHpB;AuCthHY;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AvCwhHhB;AuCthHY;EACI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AvCwhHhB;AuCthHgB;EACI,iBAAA;AvCwhHpB;AuCthHgB;EACI,eAAA;AvCwhHpB;AuClhHI;EACI,kBAAA;EACA,aAAA;EACA,wCACI;EAEJ,cAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;AvCkhHR;AD5hHI;EAIQ,0CwCSA;AvCkhHZ;ADxhHiB;EAED,iDAAA;ACyhHhB;;AuChhHQ;EACI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AvCmhHZ;AuChhHQ;EACI,kBAAA;AvCkhHZ;AuChhHY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AvCkhHhB;;AwC1nHA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AxC6nHJ;AwC3nHI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AxC6nHR;ADlkHI;EAEQ,oCAAA;ACmkHZ;AD9jHiB;EAED,oCAAA;AC+jHhB;;AyCjpHA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AzCopHJ;AyClpHI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AzCopHR;ADzlHI;EAEQ,oCAAA;AC0lHZ;ADrlHiB;EAED,oCAAA;ACslHhB;;A0ClqHA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;A1CqqHJ;ADtmHI;EAEQ,sCAAA;ACumHZ;ADlmHiB;EAID,Y2CzE6B;A1C0qH7C;;A0CxqHI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;A1C2qHR;A0CzqHI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;A1C2qHR;;A0CvqHA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;A1CyqHJ;A0CvqHI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A1CyqHR;AD7oHI;EAEQ,oCAAA;AC8oHZ;ADzoHiB;EAED,oCAAA;AC0oHhB;;A0C3qHI;EACI,mBAAA;A1C8qHR;A0C3qHI;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;A1C6qHR;A0C3qHQ;EACI,cAAA;EACA,gBAAA;A1C6qHZ;A0C3qHY;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A1C6qHhB;A0C3qHY;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;A1C6qHhB;;A2C3vHA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;A3C8vHJ;ADzrHI;EAEQ,sCAAA;AC0rHZ;ADrrHiB;EAID,Y4C/E6B;A3CmwH7C;;A2CjwHI;EACI,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;A3CowHR;A2ClwHI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;A3CowHR;;A2ChwHA;EAEI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;A3CkwHJ;A2ChwHI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;A3CkwHR;A2C/vHI;EACI,WAAA;A3CiwHR;A2C/vHQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;A3CiwHZ;A2C/vHY;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;A3CiwHhB;AD7uHI;EAEQ,sCAAA;AC8uHZ;ADzuHiB;EAID,Y4C3BI;A3CmwHpB;;A2C9vHY;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;A3CiwHhB;;A4Cp0HA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A5Cu0HJ;A4Cp0HQ;EACI,UAAA;A5Cs0HZ;A4Cp0HQ;EACI,UAAA;A5Cs0HZ;A4Cl0HI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;A5Co0HR;ADnxHI;EAEQ,iDAAA;ACoxHZ;AD/wHiB;EAID,oC6CtDJ;A5Co0HZ;;A4C/zHI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,oCAAA;EACA,uBAAA;A5Ck0HR;A4Ch0HQ;EACI,gBAAA;EACA,mBAAA;A5Ck0HZ;AS71HI;EACI,mDAAA;AT+1HR;AS11HiB;EACL,yCAAA;AT41HZ;;A4Cn0HY;EACI,cAAA;EACA,cAAA;EACA,WAAA;A5Cs0HhB;ADpzHI;EAIQ,uC6CnBQ;A5Cs0HpB;ADhzHiB;EAID,uB6CzBI;A5Cw0HpB;;A4Cp0HY;EACI,WAAA;EACA,sBAAA;A5Cu0HhB;AD/zHI;EAIQ,a6CXyC;A5Cy0HrD;AD3zHiB;EAID,c6ClB4C;A5C40H5D;;ADr0HI;EAIQ,oB6CRoD;A5C60HhE;ADl0HiB;EAID,qB6CfuD;A5Cg1HvE;;AD50HI;EAEQ,8CAAA;AC80HZ;ADz0HiB;EAED,iDAAA;AC00HhB;;ADn1HI;EAIQ,oB6CEoD;A5Ci1HhE;ADh1HiB;EAID,qB6CLuD;A5Co1HvE;;AD11HI;EAIQ,uB6CKY;A5Cq1HxB;ADv1HiB;EAED,iDAAA;ACw1HhB;;A4Cj1HY;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;A5Co1HhB;A4Cj1HY;EACI,aAAA;EACA,kBAAA;A5Cm1HhB;A4Ch1HoB;EACI,YAAA;EACA,oBAAA;A5Ck1HxB;A4C90HgB;EACI,aAAA;EACA,yBAAA;EACA,SAAA;A5Cg1HpB;;A6Ch8HA;EAEI,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qKACI;A7Ci8HR;ADv4HI;EAEQ,8CAAA;ACw4HZ;ADn4HiB;EAID,oC8ChEuC;A7Ck8HvD;;AD74HI;EAEQ,2CAAA;AC+4HZ;AD14HiB;EAID,yB8C/DoC;A7Cw8HpD;;ADp5HI;EAEQ,oCAAA;ACs5HZ;ADj5HiB;EAID,Y8C9D6B;A7C88H7C;;ASh9HI;EACI,mDAAA;ATm9HR;AS98HiB;EACL,yCAAA;ATg9HZ;;A6Cl9HI;EACI,eAAA;EACA,YAAA;A7Cq9HR;A6Cl9HI;EACI,mBAAA;A7Co9HR;AD16HI;EAEQ,8CAAA;AC26HZ;ADt6HiB;EAID,8B8CpD2C;A7Cy9H3D;;ASr+HI;EACI,kDAAA;ATw+HR;ASn+HiB;EACL,yCAAA;ATq+HZ;;A6C59HI;EACI,iCAAA;EACA,mBAAA;A7C+9HR;AD57HI;EAEQ,8CAAA;AC67HZ;ADx7HiB;EAID,8B8C7C2C;A7Co+H3D;;ASv/HI;EACI,mDAAA;AT0/HR;ASr/HiB;EACL,yCAAA;ATu/HZ;;ADz8HI;EAIQ,0C8CjC2C;A7C0+HvD;ADt8HiB;EAID,6B8CxCiE;A7C6+HjF;;ADh9HI;EAEQ,2CAAA;ACk9HZ;AD78HiB;EAID,iB8CvCwC;A7Cm/HxD;;ADv9HI;EAEQ,oCAAA;ACy9HZ;ADp9HiB;EAID,Y8CtCiC;A7Cy/HjD;;ASnhII;EACI,yCAAA;ATshIR;ASjhIiB;EACL,yCAAA;ATmhIZ;;ADr+HI;EAEQ,2CAAA;ACu+HZ;ADl+HiB;EAID,e8ClC4C;A7CmgI5D;;AD5+HI;EAEQ,8CAAA;AC8+HZ;ADz+HiB;EAID,kC8CjC+C;A7CygI/D;;ASxiII;EACI,kDAAA;AT2iIR;AStiIiB;EACL,yCAAA;ATwiIZ;;AD1/HI;EAEQ,2CAAA;AC4/HZ;ADv/HiB;EAID,e8C5B4C;A7CkhI5D;;ADjgII;EAEQ,8CAAA;ACmgIZ;AD9/HiB;EAID,kC8C3B+C;A7CwhI/D;;AS7jII;EACI,mDAAA;ATgkIR;AS3jIiB;EACL,yCAAA;AT6jIZ;;A6C1hII;EACI,yBAAA;EACA,YAAA;A7C6hIR;ADphII;EAIQ,kC8CZ2C;A7C+hIvD;ADhhIiB;EAID,kC8CnByD;A7CkiIzE;;AD1hII;EAIQ,kC8CT+C;A7CmiI3D;ADvhIiB;EAID,kC8ChB6D;A7CsiI7E;;ADjiII;EAIQ,kC8CL+C;A7CsiI3D;AD9hIiB;EAID,kC8CZ6D;A7CyiI7E;;A6CriII;EACI,yBAAA;EACA,YAAA;A7CwiIR;AD7iII;EAIQ,mC8CE2C;A7C0iIvD;ADziIiB;EAID,mC8CL0D;A7C6iI1E;;ADnjII;EAIQ,mC8CK+C;A7C8iI3D;ADhjIiB;EAID,mC8CF8D;A7CijI9E;;AD1jII;EAIQ,mC8CS+C;A7CijI3D;ADvjIiB;EAID,mC8CE8D;A7CojI9E;;A6ChjII;EACI,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A7CmjIR;A6ChjII;EACI,oBAAA;EACA,cAAA;EACA,mBAAA;A7CkjIR;A6ChjIQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;A7CkjIZ;;A8ChqIA;EAEI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sGAAA;A9CkqIJ;ADtmII;EAIQ,yB+C3DJ;A9CgqIR;ADlmIiB;EAID,+B+CjER;A9CkqIR;;A8C/pII;EACI,aAAA;A9CkqIR;A8C/pIY;EACI,oCAAA;A9CiqIhB;ADnnII;EAIQ,mB+CjDmD;A9CmqI/D;AD/mIiB;EAED,+CAAA;ACgnIhB;;ADznII;EAEQ,8CAAA;AC2nIZ;ADtnIiB;EAID,2C+C/CJ;A9CoqIZ;;A8ChqII;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;A9CmqIR;ADxoII;EAEQ,+CAAA;ACyoIZ;ADpoIiB;EAID,qB+CrC4C;A9CwqI5D;;AD9oII;EAIQ,qD+C3BA;A9CyqIZ;AD3oIiB;EAID,qD+CjCJ;A9C2qIZ;;A8CxqIQ;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yEAAA;A9C2qIZ;ADhqII;EAEQ,gDAAA;ACiqIZ;AD5pIiB;EAED,iDAAA;AC6pIhB;;ADtqII;EAIQ,yF+CFI;A9CwqIhB;ADnqIiB;EAID,gG+CPA;A9CyqIhB;;A8CnqII;EACI,oBAAA;EACA,YAAA;A9CsqIR;;A+C7vIA;EAEI,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,qKACI;EAKJ,+BAAA;EACA,wDAAA;A/C0vIJ;ASvvII;EACI,yCAAA;ATyvIR;ASpvIiB;EACL,yCAAA;ATsvIZ;;A+C7vII;EACI,eAAA;EACA,YAAA;A/CgwIR;A+C7vII;EACI,kBAAA;A/C+vIR;ADhtII;EAEQ,iDAAA;ACitIZ;AD5sIiB;EAED,iDAAA;AC6sIhB;;A+CjwII;EACI,iCAAA;EACA,kBAAA;A/CowIR;AD3tII;EAEQ,iDAAA;AC4tIZ;ADvtIiB;EAED,iDAAA;ACwtIhB;;A+CtwII;EACI,qCAAA;A/CywIR;ADruII;EAEQ,iDAAA;ACsuIZ;ADjuIiB;EAED,iDAAA;ACkuIhB;;A+C3wII;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;A/C8wIR;ADlvII;EAEQ,oCAAA;ACmvIZ;AD9uIiB;EAID,YgDtCiC;A/CmxIjD;;ADxvII;EAEQ,iDAAA;AC0vIZ;ADrvIiB;EAED,iDAAA;ACsvIhB;;AD/vII;EAEQ,iDAAA;ACiwIZ;AD5vIiB;EAED,iDAAA;AC6vIhB;;ADtwII;EAEQ,iDAAA;ACwwIZ;ADnwIiB;EAED,iDAAA;ACowIhB;;AD7wII;EAEQ,mCAAA;AC+wIZ;AD1wIiB;EAID,YgDxBoC;A/CiyIpD;;A+C7xII;EACI,mBAAA;A/CgyIR;A+C9xIQ;EACI,cAAA;EACA,aAAA;A/CgyIZ;A+C5xII;EACI,iBAAA;EACA,eAAA;A/C8xIR;A+C5xIQ;EACI,cAAA;EACA,aAAA;A/C8xIZ;A+C3xIQ;EACI,kBAAA;A/C6xIZ;;AgDl3IA;EAEI,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,sGACI;EAGJ,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,WAAA;AhDi3IJ;ADrzII;EAEQ,iDAAA;ACszIZ;ADjzIiB;EAED,iDAAA;ACkzIhB;;AgD92II;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,oCAAA;EACA,gCAAA;EACA,uBAAA;EACA,YAAA;AhDi3IR;AgD/2IQ;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4DACI;EAEJ,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AhD+2IZ;AgD52IQ;EACI,UAAA;AhD82IZ;AgD52IQ;EACI,UAAA;AhD82IZ;AgD12II;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;EACA,oBAAA;EACA,qBAAA;EACA,wDAAA;EACA,uBAAA;AhD42IR;AS35II;EACI,mDAAA;AT65IR;ASx5IiB;EACL,mDAAA;AT05IZ;;AD52II;EAEQ,oCAAA;AC82IZ;ADz2IiB;EAED,mCAAA;AC02IhB;;ADn3II;EAEQ,oCAAA;ACq3IZ;ADh3IiB;EAED,oCAAA;ACi3IhB;;AiDz6IQ;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,2BAAA;EACA,gCAAA;EACA,uBAAA;AjD46IZ;ADv4II;EAEQ,sCAAA;ACw4IZ;ADn4IiB;EAED,oCAAA;ACo4IhB;;AiD/6IY;EACI,oBAAA;EACA,6BAAA;EACA,4DAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AjDk7IhB;AiD96IQ;EACI,YAAA;EACA,eAAA;EACA,OAAA;AjDg7IZ;;AkDz+IA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qKACI;AlD2+IR;ASl+II;EACI,mDAAA;ATo+IR;AS/9IiB;EACL,yCAAA;ATi+IZ;;ADn7II;EAEQ,8CAAA;ACq7IZ;ADh7IiB;EAID,oCmDnEuC;AlDk/IvD;;AD17II;EAEQ,2CAAA;AC47IZ;ADv7IiB;EAID,yBmDlEoC;AlDw/IpD;;ADj8II;EAEQ,oCAAA;ACm8IZ;AD97IiB;EAID,YmDjE6B;AlD8/I7C;;AkD5/II;EACI,mBAAA;AlD+/IR;ASjgJI;EACI,kDAAA;ATmgJR;AS9/IiB;EACL,yCAAA;ATggJZ;;ADl9II;EAEQ,2CAAA;ACo9IZ;AD/8IiB;EAID,yBmD5DwC;AlD0gJxD;;AkDvgJI;EACI,iCAAA;EACA,mBAAA;AlD0gJR;ASnhJI;EACI,mDAAA;ATqhJR;AShhJiB;EACL,yCAAA;ATkhJZ;;ADp+II;EAEQ,2CAAA;ACs+IZ;ADj+IiB;EAID,yBmDrDwC;AlDqhJxD;;AmDpjJA;EACI,YAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AnDujJJ;ADt/II;EAEQ,+CAAA;ACu/IZ;ADl/IiB;EAED,iDAAA;ACm/IhB;;AmD1jJI;EACI,iBAAA;EACA,gBAAA;AnD6jJR;ADjgJI;EAEQ,oCAAA;ACkgJZ;AD7/IiB;EAID,YoDtEiC;AnDkkJjD;;AmD/jJI;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,qKACI;AnDikJZ;ADzhJI;EAIQ,uBoDvC2C;AnD+jJvD;ADrhJiB;EAED,iDAAA;ACshJhB;;AD/hJI;EAEQ,2CAAA;ACiiJZ;AD5hJiB;EAID,yBoD7CwC;AnDwkJxD;;ADtiJI;EAEQ,oCAAA;ACwiJZ;ADniJiB;EAID,YoD5CiC;AnD8kJjD;;AmD5kJQ;EACI,mBAAA;AnD+kJZ;ADjjJI;EAIQ,uBoDjC+C;AnDilJ3D;AD7iJiB;EAED,iDAAA;AC8iJhB;;AS5mJI;EACI,kDAAA;AT+mJR;AS1mJiB;EACL,yCAAA;AT4mJZ;;AmDvlJQ;EACI,iCAAA;EACA,mBAAA;AnD0lJZ;ADnkJI;EAIQ,uBoD1B+C;AnD4lJ3D;AD/jJiB;EAED,iDAAA;ACgkJhB;;AS9nJI;EACI,mDAAA;ATioJR;AS5nJiB;EACL,yCAAA;AT8nJZ;;AmDhmJQ;EACI,eAAA;AnDmmJZ;;AmD7lJI;EACI,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AnDgmJR;AD5lJI;EAEQ,8CAAA;AC6lJZ;ADxlJiB;EAID,uBoDd2C;AnDqmJ3D;;AmDnmJQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AnDsmJZ;AD7mJI;EAIQ,YoDIoC;AnDwmJhD;ADzmJiB;EAID,YoDHuC;AnD2mJvD;;ADnnJI;EAIQ,uBoDOmD;AnD4mJ/D;ADhnJiB;EAID,uBAAA;AC+mJhB;;AD1nJI;EAIQ,YoDQwC;AnDknJpD;ADvnJiB;EAID,YoDC2C;AnDqnJ3D;;AoD5sJA;EAEI,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gCAAA;EACA,yIAAA;ApD8sJJ;AD9oJI;EAEQ,kDAAA;AC+oJZ;AD1oJiB;EAED,iDAAA;AC2oJhB;;ADppJI;EAEQ,oCAAA;ACspJZ;ADjpJiB;EAED,mCAAA;ACkpJhB;;AD3pJI;EAEQ,6CAAA;AC6pJZ;ADxpJiB;EAID,yBqD7DR;ApDotJR;;ADlqJI;EAIQ,8BqD/CA;ApDitJZ;AD/pJiB;EAID,gCqDrDJ;ApDmtJZ;;ADzqJI;EAIQ,0CqDxCA;ApDitJZ;ADtqJiB;EAID,qBqD9CJ;ApDmtJZ;;ADhrJI;EAIQ,gCqDnCA;ApDmtJZ;AD7qJiB;EAID,yBqDzCJ;ApDqtJZ;;ADvrJI;EAEQ,kDAAA;ACyrJZ;ADprJiB;EAED,iDAAA;ACqrJhB;;AD9rJI;EAIQ,0CqDlBI;ApDgtJhB;AD3rJiB;EAID,qBqDxBA;ApDktJhB;;AoD7sJI;EACI,mBAAA;ApDgtJR;ADzsJI;EAEQ,kDAAA;AC0sJZ;ADrsJiB;EAED,iDAAA;ACssJhB;;AD/sJI;EAEQ,6CAAA;ACitJZ;AD5sJiB;EAID,yBqDPJ;ApDktJZ;;AS3wJI;EACI,kDAAA;AT8wJR;ASzwJiB;EACL,yCAAA;AT2wJZ;;AD7tJI;EAIQ,0CqDQI;ApDqtJhB;AD1tJiB;EAID,qBqDEA;ApDutJhB;;ADpuJI;EAEQ,sCAAA;ACsuJZ;ADjuJiB;EAID,+BqDWJ;ApDqtJZ;;AoD/sJA;EACI,kBAAA;ApDktJJ;AoDhtJI;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;ApDktJR;AoDjtJQ;EACI,mBAAA;ApDmtJZ;AoD/sJI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,2BAAA;ApDitJR;ADxwJI;EAEQ,iDAAA;ACywJZ;ADpwJiB;EAID,qBqDgDJ;ApDmtJZ;;AqDv1JA;EACI,UAAA;EACA,qCAAA;EACA,gEACI;EAEJ,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;ArDw1JJ;AqDt1JI;EACI,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0HACI;ArDu1JZ;AqDn1JI;EACI,UAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;ArDq1JR;AqDn1JI;EACI,UAAA;EACA,+BAAA;ArDq1JR;AqDl1JI;EACI,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ArDo1JR;ADrzJI;EAIQ,yBsDhCA;ArDo1JZ;ADjzJiB;EAID,+BsDtCJ;ArDs1JZ;;AqDl1JI;EACI,aAAA;ArDq1JR;AqDn1JI;EACI,cAAA;EACA,kBAAA;ArDq1JR;ADn0JI;EAIQ,qCsDnBA;ArDq1JZ;AD/zJiB;EAID,2CsDzBJ;ArDu1JZ;;AqDn1JI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;ArDs1JR;AD31JI;EAIQ,yBsDEgC;ArDw1J5C;ADv1JiB;EAID,YsDLgD;ArD21JhE;;AqDz1JQ;EACI,aAAA;EACA,cAAA;EACA,YAAA;ArD41JZ;AqDz1JQ;EACI,YAAA;ArD21JZ;AD12JI;EAIQ,qCsDiBI;ArDw1JhB;ADt2JiB;EAID,uBsDWA;ArD01JhB;;ADh3JI;EAIQ,yBsDqBoC;ArD21JhD;AD72JiB;EAID,YsDcoD;ArD81JpE;;AqD51JY;EACI,YAAA;ArD+1JhB;AqDz1JQ;EACI,UAAA;ArD21JZ;AqDz1JQ;EACI,UAAA;ArD21JZ;;AsD78JA;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AtD+8JJ;ADz4JI;EAEQ,8CAAA;AC04JZ;ADr4JiB;EAID,0CuD7ER;AtDi9JR;;AD/4JI;EAEQ,2CAAA;ACi5JZ;AD54JiB;EAID,yBuD3EoC;AtDs9JpD;;ADt5JI;EAEQ,oCAAA;ACw5JZ;ADn5JiB;EAID,YuD1E6B;AtD49J7C;;AsD19JI;EACI,mBAAA;AtD69JR;ADj6JI;EAEQ,8CAAA;ACk6JZ;AD75JiB;EAID,uBuDtE2C;AtDk+J3D;;AS59JI;EACI,kDAAA;AT+9JR;AS19JiB;EACL,yCAAA;AT49JZ;;AsDr+JI;EACI,iCAAA;EACA,mBAAA;AtDw+JR;ADn7JI;EAEQ,8CAAA;ACo7JZ;AD/6JiB;EAID,uBuD/D2C;AtD6+J3D;;AS9+JI;EACI,mDAAA;ATi/JR;AS5+JiB;EACL,yCAAA;AT8+JZ;;AsDh/JI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AtDm/JR;AsD/+JQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AtDi/JZ;AD78JI;EAEQ,oCAAA;AC88JZ;ADz8JiB;EAID,YuD9CqC;AtDs/JrD;;AuD9hKA;EAEI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sGACI;AvD+hKR;AD99JI;EAEQ,gDAAA;AC+9JZ;AD19JiB;EAID,qBwDzEuC;AvDkiKvD;;ADp+JI;EAEQ,2CAAA;ACs+JZ;ADj+JiB;EAID,iBwDxEoC;AvDwiKpD;;AuDtiKI;EACI,aAAA;AvDyiKR;AD/+JI;EAEQ,+CAAA;ACg/JZ;AD3+JiB;EAID,mBwDjE4C;AvD2iK5D;;ADr/JI;EAEQ,2CAAA;ACu/JZ;ADl/JiB;EAID,yBwDhEwC;AvDijKxD;;AuD/iKQ;EACI,gBAAA;AvDkjKZ;ADhgKI;EAIQ,YwDrDoC;AvDojKhD;AD5/JiB;EAID,YwD5DgC;AvDujKhD;;AuDnjKI;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AvDsjKR;AD7gKI;EAEQ,oCAAA;AC8gKZ;ADzgKiB;EAID,YwDnDiC;AvD2jKjD;;ADnhKI;EAEQ,8CAAA;ACqhKZ;ADhhKiB;EAID,qBwD/C2C;AvD8jK3D;;AD1hKI;EAEQ,2CAAA;AC4hKZ;ADvhKiB;EAID,iBwD9CwC;AvDokKxD;;AuDjkKI;EACI,oBAAA;EACA,YAAA;AvDokKR;;AwD/mKA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AxDknKJ;ADhkKI;EACI,uBAAA;ACkkKR;ADjkKiB;EACL,uBAAA;ACmkKZ;;ADnjKI;EAEQ,8CAAA;ACqjKZ;ADhjKiB;EAED,iDAAA;ACijKhB;;AD1jKI;EAIQ,qByDtEoC;AxDgoKhD;ADvjKiB;EAID,qByD7EwC;AxDmoKxD;;AwDhoKiB;EACL,YAAA;EACA,UAAA;AxDmoKZ;ADtkKI;EAIQ,uByDhE+C;AxDqoK3D;ADlkKiB;EAID,uByDvEkD;AxDwoKlE;;AD5kKI;EAIQ,oByD/D4C;AxD2oKxD;ADzkKiB;EAID,oByDtE+C;AxD8oK/D;;AwDzoKQ;EACI,gBAAA;AxD4oKZ;AwDzoKgB;EACI,oCAAA;AxD2oKpB;AwDvoKQ;EACI,aAAA;AxDyoKZ;AwDroKI;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AxDuoKR;AD1mKI;EAIQ,yByDhCgC;AxDyoK5C;ADtmKiB;EAID,+ByDvCgD;AxD4oKhE;;AwD1oKQ;EACI,kBAAA;EACA,kBAAA;AxD6oKZ;AwD5oKY;EACI,sCAAA;AxD8oKhB;AwD1oKQ;EACI,aAAA;EACA,mBAAA;AxD4oKZ;AwDzoKQ;EACI,iBAAA;AxD2oKZ;AwDzoKY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AxD2oKhB;AwDvoKQ;EACI,aAAA;EACA,SAAA;AxDyoKZ;AwDroKI;EACI,cAAA;EACA,cAAA;EACA,WAAA;AxDuoKR;ADlpKI;EAEQ,8CAAA;ACmpKZ;AD9oKiB;EAID,qByDC2C;AxD4oK3D;;AwDxoKQ;EACI,YAAA;AxD2oKZ;;AA/tKA;EACI,aAAA;AAkuKJ;;AA/tKA;EACI,gBAAA;EACA,YAAA;AAkuKJ;;AA/tKA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;EACA,uBAAA;AAkuKJ;;AA/tKA;EACI,mDAAA;EACA,gDAAA;AAkuKJ;;AA/tKA;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAkuKJ;;AA/tKA;;EAEI,gDAAA;AAkuKJ","sourcesContent":["@use 'sass:list';\n@use 'sass:meta';\n\n$colour-light: hsl(99, 30%, 74%);\n$colour-dark: hsl(99, 22%, 57%);\n\n:root {\n    --demmi-50: #eff2ed;\n    --demmi-100: #d4ddd0;\n    --demmi-200: #b7c4b0;\n    --demmi-300: #99ae8f;\n    --demmi-400: #849b78;\n    --demmi-500: #6f8a60;\n    --demmi-600: #607854;\n    --demmi-700: #506345;\n    --demmi-800: #40493c;\n    --demmi-900: #2d312b;\n\n    --demmi-50-hsl: 96, 16%, 94%;\n    --demmi-100-hsl: 102, 16%, 84%;\n    --demmi-200-hsl: 99, 14%, 73%;\n    --demmi-300-hsl: 101, 16%, 62%;\n    --demmi-400-hsl: 99, 15%, 54%;\n    --demmi-500-hsl: 99, 18%, 46%;\n    --demmi-600-hsl: 100, 18%, 40%;\n    --demmi-700-hsl: 98, 18%, 33%;\n    --demmi-800-hsl: 102, 10%, 26%;\n    --demmi-900-hsl: 100, 7%, 18%;\n\n    --palette-50-s: 35%;\n    --palette-50-l: 93%;\n    --palette-100-s: 40%;\n    --palette-100-l: 84%;\n    --palette-200-s: 45%;\n    --palette-200-l: 73%;\n    --palette-300-s: 50%;\n    --palette-300-l: 63%;\n    --palette-400-s: 55%;\n    --palette-400-l: 55%;\n    --palette-500-s: 60%;\n    --palette-500-l: 47%;\n    --palette-600-s: 65%;\n    --palette-600-l: 42%;\n    --palette-700-s: 70%;\n    --palette-700-l: 36%;\n    --palette-800-s: 75%;\n    --palette-800-l: 30%;\n    --palette-900-s: 80%;\n    --palette-900-l: 23%;\n\n    --palette-50: hsl(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l));\n}\n\n$swatches: 50, 100, 200, 300, 400, 500, 600, 700, 800, 900;\n\n/**\n    Get values from Demmi palette\n*/\n@mixin demmi($prop, $shade, $shadeDark: $shade) {\n    & {\n        #{$prop}: var(--demmi-#{$shade});\n        @at-root body.theme-dark #{&} {\n            #{$prop}: var(--demmi-#{$shadeDark});\n        }\n    }\n}\n\n@function get($hue, $alpha: 1) {\n    @return hsla(var(--demmi-#{$hue}-hsl), $alpha);\n}\n\n/**\n    Set a custom colour value for light/dark mode.\n        - If exists in palette, parse palette value.\n        - If type is number, something?????\n        - Else use provided value.\n*/\n@mixin customValue($prop, $light, $dark: $light, $alphaLight: 1, $alphaDark: 1) {\n    & {\n        @if list.index($swatches, $light) {\n            #{$prop}: hsla(var(--demmi-#{$light}-hsl), $alphaLight);\n        } @else {\n            #{$prop}: $light;\n        }\n\n        @at-root body.theme-dark #{&} {\n            @if list.index($swatches, $dark) {\n                #{$prop}: hsla(var(--demmi-#{$dark}-hsl), $alphaDark);\n            } @else {\n                #{$prop}: $dark;\n            }\n        }\n    }\n}\n\n$radialBackgroundThemedLight: radial-gradient(\n        circle at calc(1% * var(--theme-bg-pos)) top,\n        hsla(var(--demmi-200-hsl), 0.5),\n        transparent,\n        transparent\n    ),\n    radial-gradient(\n        circle at calc(100% - 1% * var(--theme-bg-pos)) bottom,\n        hsla(var(--demmi-200-hsl), 0.3),\n        transparent,\n        transparent\n    );\n$radialBackgroundThemedDark: radial-gradient(\n        circle at calc(1% * var(--theme-bg-pos)) top,\n        hsla(var(--demmi-400-hsl), 0.3),\n        transparent,\n        transparent\n    ),\n    radial-gradient(\n        circle at calc(100% - 1% * var(--theme-bg-pos)) bottom,\n        hsla(var(--demmi-400-hsl), 0.2),\n        transparent,\n        transparent\n    );\n\n@mixin radialBackground() {\n    & {\n        z-index: 0;\n        // opacity: 0.4;\n        border-radius: 2.4rem;\n        @include customValue(background-color, 500, 500, $alphaDark: 0.1, $alphaLight: 0.2);\n\n        &::before {\n            z-index: 0;\n            content: '';\n            inset: 0;\n            position: absolute;\n            opacity: 0.4;\n            background: $radialBackgroundThemedLight;\n            background-size: 100% 100%;\n            background-repeat: no-repeat;\n        }\n        &::after {\n            z-index: 0;\n            content: '';\n            inset: 0;\n            position: absolute;\n            background: var(--theme-bg-svg);\n            @include customValue(mix-blend-mode, color-burn, color-dodge);\n            @include customValue(opacity, 0.3, 0.1);\n        }\n\n        @at-root body.theme-dark #{&} {\n            &::before {\n                opacity: 0.5;\n                background: $radialBackgroundThemedDark;\n            }\n        }\n    }\n}\n","@use './utils/colours' as Colours;\n@use './utils/elevations' as Elevations;\n@use './utils/scrollbar';\n@use './utils/cssvars';\n\n@use './demmi-core';\n@use './core/text';\n@use './components/components';\n@use './pages/pages';\n@use './demmi-ui/demmi-ui';\n\n.firebase-emulator-warning {\n    display: none;\n}\n\nhtml {\n    font-size: 62.5%;\n    height: 100%;\n}\n\nbody {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    font-family: 'Montserrat', 'Raleway', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    font-weight: 400;\n    letter-spacing: 0.05rem;\n    color: hsla(172, 80%, 10%, 0.6);\n    background-color: black;\n}\n\n* {\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n    font-family: 'Montserrat', 'Raleway', sans-serif;\n}\n\nbutton {\n    outline: none;\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n\ninput,\ntextarea {\n    font-family: 'Montserrat', 'Raleway', sans-serif;\n}\n","@use './colours.scss' as Colours;\n\nbody:not(.isCapacitor):not(.isMobile) * {\n    ::-webkit-scrollbar {\n        width: 1.6rem;\n        height: 1.6rem;\n        background-color: transparent;\n\n        @at-root #{&}-thumb {\n            border: 0.5rem solid transparent;\n            border-radius: 0.8rem;\n            background-clip: padding-box;\n            outline: none;\n            background-color: rgba(255, 255, 255, 0.7);\n\n            &:hover {\n                border-width: 0.4rem;\n                background-color: rgba(255, 255, 255, 0.9);\n            }\n            &:active {\n                border-width: 0.4rem;\n                background-color: rgba(255, 255, 255, 0.9);\n            }\n        }\n        @at-root #{&}-track {\n            background: transparent;\n            border-radius: 1rem;\n        }\n        @at-root #{&}-corner {\n            background-color: transparent;\n        }\n    }\n}\n\nbody.theme-dark:not(.isCapacitor):not(.isMobile) * {\n    ::-webkit-scrollbar {\n        background-color: transparent;\n\n        @at-root #{&}-thumb {\n            border: 0.5rem solid transparent;\n            background-color: Colours.get(100, 0.6);\n\n            &:hover {\n                background-color: Colours.get(100, 1);\n            }\n            &:active {\n                background-color: Colours.get(100, 1);\n            }\n        }\n        @at-root #{&}-track {\n            background: transparent;\n        }\n        @at-root #{&}-corner {\n            background-color: transparent;\n        }\n    }\n}\n",":root {\n    // Overridden in React code\n    --theme-bg-hue: 96;\n    --theme-bg-pos: 20;\n    --theme-bg-intensity: 0.6;\n    --theme-bg-grain: 0.4;\n    --theme-bg-svg: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 1000 1000' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\");\n    --theme-config-svg: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\");\n}\n","@use './utils/colours' as Colours;\n@use './utils/elevations' as Elevations;\n\n@keyframes inAnimation {\n    0% {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes outAnimation {\n    0% {\n        transform: scale(1);\n    }\n    100% {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n}\n\n#demmi-portal {\n    height: 100%;\n    width: 100vw;\n    box-sizing: border-box;\n    overflow: hidden;\n    justify-items: start;\n    position: relative;\n    color: rgba(0, 0, 0, 0.6);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), white);\n\n    &:after {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: 0;\n    }\n    @include Colours.radialBackground();\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n@mixin pseudoHint($content, $top) {\n    &::before {\n        content: $content;\n        position: absolute;\n        left: -3rem;\n        top: $top;\n        opacity: 0.4;\n        font-size: 1.3rem;\n        line-height: 1.3rem;\n        font-weight: 700;\n        letter-spacing: 0.12rem;\n        text-align: end;\n        text-transform: none;\n\n        @media (max-width: 600px) {\n            left: -2.4rem;\n        }\n    }\n}\n\nh1 {\n    position: relative;\n    margin: 2.8rem 0 1.2rem;\n    font-size: 3.2rem;\n    line-height: 3.6rem;\n    font-weight: 500;\n    letter-spacing: 0.08rem;\n    @include pseudoHint('h1', 1.8rem);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.86));\n}\n\nh2 {\n    position: relative;\n    margin: 2.4rem 0 1.2rem;\n    font-size: 2.4rem;\n    line-height: 2.8rem;\n    font-weight: 500;\n    letter-spacing: 0.08rem;\n    @include pseudoHint('h2', 1.1rem);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.86));\n}\n\nh3 {\n    position: relative;\n    margin: 2rem 0 1.2rem;\n    font-size: 1.8rem;\n    line-height: 2.1rem;\n    font-weight: 700;\n    letter-spacing: 0.1rem;\n    @include pseudoHint('h3', 0.6rem);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.86));\n}\n\nh4 {\n    position: relative;\n    margin: 1.6rem 0 1rem;\n    font-size: 1.6rem;\n    line-height: 1.8rem;\n    font-weight: 700;\n    letter-spacing: 0.1rem;\n    @include pseudoHint('h4', 0.3rem);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.86));\n}\n\nh5 {\n    position: relative;\n    margin: 1.2rem 0 1rem;\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.2rem;\n    @include pseudoHint('h5', 0.3rem);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.86));\n}\n\nh6 {\n    position: relative;\n    margin: 1rem 0;\n    font-size: 1.3rem;\n    line-height: 1.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.2rem;\n    @include pseudoHint('h6', 0.3rem);\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.86));\n}\n\np {\n    position: relative;\n    margin: 1rem 0;\n    line-height: 1.8rem;\n    font-size: 1.3rem;\n    font-weight: 400;\n    letter-spacing: 0.04rem;\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 1));\n\n    &::before {\n        content: '';\n        position: absolute;\n        left: -1rem;\n        top: 0;\n        bottom: 0;\n        width: 0.1rem;\n        transition: opacity 0.1s ease-in-out;\n        opacity: 0;\n        @include Colours.customValue(background-color, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 1));\n    }\n\n    &:hover {\n        &::before {\n            opacity: 1;\n        }\n    }\n}\n\nblockquote {\n    position: relative;\n    margin: 1.2rem 4rem;\n    line-height: 1.8rem;\n    font-size: 1.3rem;\n    font-weight: 400;\n    letter-spacing: 0.08rem;\n    font-style: italic;\n\n    &::before {\n        content: '';\n        position: absolute;\n        left: -1.4rem;\n        top: 0;\n        bottom: 0;\n        width: 0.3rem;\n        border-radius: 0.2rem;\n        transition: opacity 0.1s ease-in-out;\n\n        @include Colours.customValue(background-color, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0.2));\n    }\n}\n\ncode {\n    outline: none;\n    border: none;\n    padding: 0;\n    resize: none;\n    position: relative;\n    line-height: inherit;\n    font-size: 1.2rem;\n    font-family: monospace;\n    font-weight: 400;\n    letter-spacing: 0.06rem;\n    background: transparent;\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.9), rgba(255, 255, 255, 0.9));\n}\n\npre {\n    font-family: monospace;\n    outline: none;\n    border: none;\n    width: 100%;\n    height: auto;\n    padding: 0.8rem 1.2rem;\n    border-radius: 0.6rem;\n    font-size: 1.2rem;\n    line-height: 2rem;\n    box-sizing: border-box;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n}\n\nblockquote,\nul {\n    p::before {\n        display: none;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$fade-duration: 0.2s;\n\n.async-image {\n    $block: &;\n    content: '';\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &#{$block}--loaded {\n        img {\n            animation: image-fade-in $fade-duration forwards;\n        }\n        #{$block}__loading-indicator-wrapper {\n            animation: loader-fade-out $fade-duration forwards;\n        }\n    }\n\n    #{$block}__loading-indicator-wrapper {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        #{$block}__loading-indicator {\n            $backgroundLight: linear-gradient(Colours.get(400), hsla(99deg, 90%, 80%, 0), Colours.get(300));\n            $backgroundDark: linear-gradient(white, hsla(99deg, 90%, 80%, 0), white);\n            width: 3rem;\n            height: 3rem;\n            border-radius: 50%;\n            animation: image-loader 1.2s linear infinite;\n            opacity: 0.6;\n            @include Colours.customValue(background, $backgroundLight, $backgroundDark);\n\n            &:before {\n                content: '';\n                inset: 0;\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                border-radius: 50%;\n                filter: blur(0.4rem);\n                @include Colours.customValue(background, $backgroundLight, $backgroundDark);\n            }\n\n            &:after {\n                content: '';\n                position: absolute;\n                inset: 0.2rem;\n                border-radius: 50%;\n                @include Colours.customValue(background-color, hsla(99deg, 0%, 98%, 1), 0.8);\n            }\n        }\n    }\n}\n\n@keyframes image-loader {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes image-fade-in {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes loader-fade-out {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n.loading-overlay {\n    $block: &;\n    position: absolute;\n    inset: 0;\n    z-index: 99999;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    transition: opacity 0.5s ease-in-out;\n    border-radius: 2rem;\n\n    @include Colours.customValue(\n        background-color,\n        white,\n        // hsla(99deg, 22%, 8%, 1),\n        900\n    );\n\n    &#{$block}--login-page {\n        #{$block}__loading-indicator {\n            $backgroundLight: linear-gradient(\n                hsla(99deg, 30%, 74%, 1),\n                hsla(99deg, 90%, 0%, 0),\n                hsla(99deg, 22%, 57%, 1)\n            );\n            $backgroundDark: linear-gradient(\n                hsla(99deg, 30%, 74%, 1),\n                hsla(99deg, 90%, 80%, 0),\n                hsla(99deg, 22%, 57%, 1)\n            );\n            @include Colours.customValue(background, $backgroundLight, $backgroundDark);\n\n            &:before {\n                @include Colours.customValue(background, $backgroundLight, $backgroundDark);\n            }\n        }\n    }\n\n    &#{$block}--animated {\n        #{$block}__title {\n            animation: load-title 0.4s forwards;\n            animation-delay: 0.4s;\n            opacity: 0;\n        }\n\n        #{$block}__subtitle {\n            animation: load-subtitle 0.4s forwards;\n            animation-delay: 0.7s;\n            opacity: 0;\n        }\n    }\n\n    #{$block}__logo {\n        position: relative;\n        width: 30rem;\n        height: 30rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    #{$block}__title {\n        position: relative;\n\n        img {\n            width: 20rem;\n        }\n    }\n\n    #{$block}__subtitle {\n        position: relative;\n        font-size: 1.6rem;\n        line-height: 2rem;\n        font-weight: 400;\n        margin-top: 0.8rem;\n        letter-spacing: 0.05rem;\n        color: Colours.$colour-light;\n        pointer-events: none;\n        user-select: none;\n    }\n\n    #{$block}__loading-indicator {\n        $background: linear-gradient(Colours.$colour-light, hsla(99deg, 90%, 80%, 0), Colours.$colour-dark);\n\n        position: absolute;\n        inset: 0;\n        width: 30rem;\n        height: 30rem;\n        border-radius: 50%;\n        animation: animate-loader 1.2s linear infinite;\n        transition: opacity 0.3s ease-in-out;\n        background: $background;\n        opacity: 0.6;\n\n        &:before {\n            content: '';\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n            filter: blur(0.8rem);\n            background: $background;\n        }\n\n        &:after {\n            content: '';\n            position: absolute;\n            inset: 0.3rem;\n            border-radius: 50%;\n            @include Colours.customValue(background-color, white, 900);\n        }\n    }\n\n    &#{$block}--auth {\n        #{$block}__subtitle {\n            opacity: 1;\n            animation: none;\n        }\n    }\n}\n\n@keyframes globalLoadingIn {\n    0% {\n        opacity: 0;\n        backdrop-filter: blur(0px);\n    }\n    100% {\n        transform: scale(1);\n        backdrop-filter: blur(10px);\n    }\n}\n\n@keyframes globalLoadingOut {\n    0% {\n        transform: scale(1);\n        backdrop-filter: blur(10px);\n    }\n    100% {\n        opacity: 0;\n        backdrop-filter: blur(0px);\n    }\n}\n\n@keyframes animate-loader {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes load-text-in {\n    0% {\n        transform: scale3d(0, 0, 0);\n        opacity: 0;\n    }\n\n    50% {\n        transform: scale3d(1, 1.2, 1);\n        opacity: 0.7;\n    }\n\n    100% {\n        transform: scale3d(1, 1, 1);\n        opacity: 1;\n    }\n}\n\n@keyframes load-title {\n    0% {\n        bottom: -3rem;\n    }\n\n    50% {\n        bottom: 1.2rem;\n        opacity: 1;\n    }\n\n    100% {\n        bottom: 0;\n        opacity: 1;\n    }\n}\n@keyframes load-subtitle {\n    0% {\n        bottom: 1.6rem;\n    }\n\n    50% {\n        bottom: -0.4rem;\n        opacity: 1;\n    }\n\n    100% {\n        bottom: 0;\n        opacity: 1;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n.element-loading-indicator {\n    $block: &;\n    position: absolute;\n    inset: 0;\n    display: none;\n    align-items: center;\n    justify-content: center;\n\n    &#{$block}--loading {\n        display: flex;\n    }\n\n    #{$block}__loading-indicator {\n        $backgroundLight: linear-gradient(Colours.get(400), hsla(99deg, 90%, 80%, 0), Colours.get(300));\n        $backgroundDark: linear-gradient(white, hsla(99deg, 90%, 80%, 0), white);\n        position: relative;\n        width: 3rem;\n        height: 3rem;\n        border-radius: 50%;\n        animation: element-loading-indicator 1.2s linear infinite;\n        opacity: 0.6;\n        display: block;\n        @include Colours.customValue(background, $backgroundLight, $backgroundDark);\n\n        &:before {\n            content: '';\n            inset: 0;\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n            filter: blur(0.4rem);\n            @include Colours.customValue(background, $backgroundLight, $backgroundDark);\n        }\n\n        &:after {\n            content: '';\n            position: absolute;\n            inset: 0.2rem;\n            border-radius: 50%;\n            @include Colours.customValue(background-color, hsla(99deg, 0%, 98%, 1), 900, $alphaDark: 0.6);\n        }\n    }\n}\n\n@keyframes element-loading-indicator {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.toolbar';\n\n#{$block}__wrapper {\n    grid-area: toolbar;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.4rem;\n\n    #{$block} {\n        display: flex;\n        gap: 0.8rem;\n        border-radius: 0.8rem;\n        @include Colours.customValue(background-color, 50, 200, $alphaDark: 0.4);\n\n        &:first-child {\n            padding: 0 0.8rem;\n            border-top-left-radius: 2.2rem;\n            border-bottom-left-radius: 2.2rem;\n        }\n\n        &:last-child {\n            border-top-right-radius: 2.2rem;\n            border-bottom-right-radius: 2.2rem;\n            overflow: hidden;\n\n            #{$block}__item {\n                border-radius: 0;\n            }\n        }\n\n        #{$block}__item {\n            cursor: pointer;\n            user-select: none;\n            display: flex;\n            gap: 1.4rem;\n            padding: 1.4rem 2rem;\n            border-radius: 0.8rem;\n            color: rgba(0, 0, 0, 0.6);\n            transition:\n                transform 0.1s ease-in-out,\n                box-shadow 0.1s ease-in-out,\n                background-color 0.1s ease-in-out,\n                border-radius 0.2s ease-in-out;\n            @include Colours.customValue(color, 900, white, $alphaLight: 0.8);\n\n            &#{$block}__item--active {\n                @include Colours.customValue(background-color, white, 100);\n                @include Colours.customValue(color, 900, black, $alphaLight: 0.8);\n                @include Elevations.get(2, 0);\n\n                #{$block}__item-icon {\n                    @include Colours.customValue(color, 900, black, $alphaLight: 0.5);\n                }\n            }\n\n            #{$block}__item-icon {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                width: 1.6rem;\n                height: 1.6rem;\n                font-size: 1.4rem;\n                line-height: 1.4rem;\n                @include Colours.customValue(color, 900, white, $alphaLight: 0.5);\n            }\n            #{$block}__item-text {\n                font-size: 1.3rem;\n                font-weight: 500;\n                letter-spacing: 0.05rem;\n                line-height: 1.6rem;\n            }\n\n            &:not(#{$block}__item--active):not(:disabled):hover {\n                @include Colours.customValue(background-color, rgba(255, 255, 255, 0.6), 200, $alphaDark: 0.4);\n                @include Elevations.get(2, 0);\n            }\n\n            &:not(#{$block}__item--active):not(:disabled):active {\n                background-color: rgba(255, 255, 255, 0.8);\n                @include Colours.customValue(background-color, rgba(255, 255, 255, 0.8), 200, $alphaDark: 0.6);\n                @include Elevations.get(5, 0);\n            }\n        }\n    }\n\n    @media (max-width: 650px) {\n        #{$block} {\n            gap: 0.4rem;\n\n            #{$block}__item {\n                padding: 1.4rem 1.6rem;\n                gap: 1.2rem;\n\n                #{$block}__item-text {\n                    font-size: 1.2rem;\n                    letter-spacing: 0.02rem;\n                }\n            }\n        }\n    }\n\n    @media (max-width: 550px) {\n        #{$block} {\n            #{$block}__item {\n                &:not(#{$block}__item--active) {\n                    #{$block}__item-text {\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n\n    @media (max-width: 480px) {\n        #{$block} {\n            #{$block}__item {\n                #{$block}__item-text {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    @media (max-width: 480px) {\n        width: 100%;\n        gap: 0.4rem;\n        #{$block} {\n            flex: 1 1 calc(1 / 7 * 100%);\n            width: 100%;\n            gap: 0.2rem;\n            &:first-child {\n                padding: 0 0rem;\n                border-radius: 0.8rem;\n                // flex: 1 1 5fr;\n                flex: 1 1 calc(5 / 7 * 100%);\n            }\n            &:last-child {\n                border-radius: 0.8rem;\n                // flex: 1 1 5fr;\n            }\n            #{$block}__item {\n                box-sizing: border-box;\n                width: 100%;\n                padding: 1.4rem 1rem;\n                #{$block}__item-icon {\n                    margin: 0 auto;\n                }\n            }\n        }\n    }\n}\n","$_offset: (\n    0: 0 0 0,\n    1: 0 0.2rem 0.4rem,\n    2: 0 0.5rem 0.8rem,\n    3: 0 0.9rem 1.2rem,\n    4: 0 1.2rem 1.8rem,\n    5: 0 1.6rem 2.2rem,\n    6: 0 2rem 2.4rem,\n);\n\n@function _getAlpha($palette, $level) {\n    @if $palette == light {\n        @return 0.22 - ($level - 1) * 0.02;\n    } @else {\n        @return 0.24 - ($level - 1) * 0.04;\n    }\n}\n\n@function getShadowValue($palette, $level) {\n    $offset: map-get($_offset, $level);\n    $value: $offset + ' hsl(99, 100%, 20%,' + _getAlpha($palette, $level) + ')';\n    @return #{$value};\n}\n\n@mixin get($level, $levelDarkMode: $level, $scale: false, $growth: $level) {\n    & {\n        box-shadow: getShadowValue(light, $level);\n        @if $scale {\n            $s: calc(1 + 0.02 * $growth);\n            transform: scale3d($s, $s, $s);\n        }\n        @at-root body.theme-dark #{&} {\n            box-shadow: getShadowValue(dark, $levelDarkMode);\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n.sidebar-button {\n    $block: &;\n    cursor: pointer;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    font-size: 1.3rem;\n    box-sizing: border-box;\n    line-height: 1.6rem;\n    padding: 1.3rem 2.4rem;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    text-align: start;\n    background-color: hsla(var(--theme-bg-hue), 60%, 90%, 0);\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), white);\n\n    &:disabled {\n        opacity: 0.4;\n    }\n\n    &:not(:disabled):not(#{$block}--active):hover {\n        @include Colours.customValue(background-color, rgba(255, 255, 255, 0.5), 400, $alphaDark: 0.2);\n    }\n\n    &:not(:disabled):not(#{$block}--active):active {\n        @include Colours.customValue(background-color, rgba(255, 255, 255, 0.5), 400, $alphaDark: 0.3);\n    }\n\n    &#{$block}--active {\n        @include Colours.customValue(background-color, white, 400, $alphaDark: 0.2);\n        @include Colours.customValue(color, rgba(0, 0, 0, 0.6), white);\n\n        #{$block}__icon {\n            svg {\n                @include Colours.customValue(color, rgba(0, 0, 0, 0.4), white);\n            }\n        }\n    }\n\n    #{$block}__icon {\n        height: 1.6rem;\n        line-height: 1.6rem;\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n            @include Colours.customValue(color, rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.8));\n        }\n    }\n\n    &#{$block}--custom-button {\n        display: block;\n        padding: 0;\n    }\n}\n","@use '../../utils/constants.scss' as Constants;\n@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './sidebar-button';\n\n$block: '.sidebar';\n\n#{$block} {\n    position: relative;\n    width: Constants.$sidebarWidth;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    max-height: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    transition: transform Constants.$sidebarTransitionTime ease-in-out;\n    transform: translate3d(calc(0rem - Constants.$sidebarWidth + Constants.$sidebarCollapsedWidth), 0, 0);\n    @include Colours.customValue(background-color, 50, 900, $alphaDark: 0.4);\n\n    #{$block}__header {\n        width: Constants.$sidebarWidth;\n        opacity: 0;\n        flex: 0 0 auto;\n        transition: opacity Constants.$sidebarTransitionTime ease-in-out;\n        padding: 1.6rem;\n        box-sizing: border-box;\n\n        #{$block}__title {\n            font-size: 1.8rem;\n            letter-spacing: 0.15rem;\n            font-weight: 400;\n            line-height: 4rem;\n            text-align: center;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 2rem;\n            margin-left: 0.8rem;\n            @include Colours.customValue(color, 900, white, $alphaLight: 0.8);\n\n            #{$block}__title-buttons {\n                display: flex;\n                gap: 0.5rem;\n            }\n        }\n\n        #{$block}__search {\n            margin: 2rem 0 0;\n        }\n    }\n\n    #{$block}__buttons {\n        width: Constants.$sidebarWidth;\n        opacity: 0;\n        flex: 1 1 auto;\n        padding: 1rem 0;\n        display: flex;\n        gap: 0.5rem;\n        flex-direction: column;\n        overflow: auto;\n        box-sizing: border-box;\n        transition: opacity Constants.$sidebarTransitionTime ease-in-out;\n    }\n\n    &#{$block}--fixed {\n        transform: translate3d(0, 0, 0);\n        border: none !important;\n        #{$block}__header {\n            opacity: 1;\n        }\n        #{$block}__buttons {\n            opacity: 1;\n        }\n        #{$block}__invisible-contents {\n            opacity: 0;\n            transform: translate3d(calc(0rem - Constants.$sidebarWidth + Constants.$sidebarCollapsedWidth), 0, 0);\n            pointer-events: none;\n        }\n    }\n\n    &:hover {\n        transform: translate3d(0, 0, 0);\n        #{$block}__header {\n            opacity: 1;\n        }\n        #{$block}__buttons {\n            opacity: 1;\n        }\n        #{$block}__invisible-contents {\n            opacity: 0;\n            transform: translate3d(calc(0rem - Constants.$sidebarWidth + Constants.$sidebarCollapsedWidth), 0, 0);\n            pointer-events: none;\n        }\n    }\n\n    #{$block}__invisible-contents {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        width: Constants.$sidebarCollapsedWidth;\n        transition:\n            opacity Constants.$sidebarTransitionTime ease-in-out,\n            transform Constants.$sidebarTransitionTime ease-in-out;\n\n        #{$block}__invisible-contents-text {\n            font-size: 1.3rem;\n            font-weight: 600;\n            letter-spacing: 0.1rem;\n            transform: rotate3d(0, 0, 1, -90deg);\n            width: 100%;\n            height: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            @include Colours.customValue(color, 400, 100, $alphaLight: 1);\n        }\n    }\n}\n","$sidebarWidth: 34rem;\n$sidebarCollapsedWidth: 4rem;\n$sidebarTransitionTime: 0.3s;\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$iconSize: 3rem;\n\n.theme-switcher {\n    $block: &;\n    position: relative;\n    display: flex;\n    gap: 0rem;\n    width: fit-content;\n    box-sizing: border-box;\n    padding: 0 0.3rem;\n    border-radius: 2rem;\n    z-index: 100;\n    background-color: red;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out;\n    @include Colours.customValue(background-color, 200, 200, $alphaDark: 0.4, $alphaLight: 0.6);\n\n    &:not(:disabled):hover {\n        transform: scale3d(1.1, 1.1, 1.1);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(0.9, 0.9, 0.9);\n    }\n\n    #{$block}__item {\n        z-index: 1;\n        cursor: pointer;\n        flex: 0 0 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: $iconSize;\n        width: $iconSize;\n        gap: 1.2rem;\n        transition: color 0.1s ease;\n\n        #{$block}__item-icon {\n            flex: 0 0 1.2rem;\n            width: 1.2rem;\n            font-size: 1.2rem;\n            transition: transform 0.2s ease;\n            @include Colours.customValue(color, white, white, $alphaLight: 1);\n            svg {\n                display: block;\n                width: 1.2rem;\n            }\n        }\n        #{$block}__item-text {\n            display: none;\n        }\n\n        &#{$block}--active {\n            #{$block}__item-text {\n                @include Colours.customValue(color, 900, black, $alphaLight: 0.8);\n            }\n            #{$block}__item-icon {\n                @include Colours.customValue(color, 900, black, 0.5, 0.6);\n            }\n        }\n\n        &:not(#{$block}--active) {\n            #{$block}__item-icon {\n                // transform: translate3d(0.6rem, 0, 0);\n            }\n            #{$block}__item-text {\n                opacity: 0;\n                width: 0;\n            }\n        }\n    }\n\n    #{$block}__indicator {\n        z-index: 0;\n        pointer-events: none;\n        border-radius: 50%;\n        position: absolute;\n        width: $iconSize + 0.4rem;\n        top: -0.2rem;\n        bottom: -0.2rem;\n        left: 0.1rem;\n        transition: transform 0.2s ease;\n        @include Colours.customValue(background-color, white, 100);\n    }\n\n    &#{$block}--light {\n        #{$block}__indicator {\n            transform: translate3d($iconSize, 0, 0);\n        }\n    }\n    &#{$block}--dark {\n        #{$block}__indicator {\n            transform: translate3d($iconSize * 2, 0, 0);\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/constants.scss' as Constants;\n@use '../../utils/elevations.scss' as Elevations;\n\n.notifications-panel {\n    $block: &;\n    position: absolute;\n    inset: 0;\n    z-index: 9999;\n\n    &#{$block}--visible {\n        #{$block}__content {\n            opacity: 1;\n        }\n        #{$block}__backdrop {\n            opacity: 1;\n        }\n        .notifications-panel-content {\n            transition: transform 0.4s ease-out;\n            transform: translate3d(0, 0, 0);\n        }\n    }\n\n    #{$block}__backdrop {\n        opacity: 0;\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        inset: 0;\n        transition: opacity 0.3s ease-in-out;\n        @include Colours.customValue(\n            background-color,\n            rgba(0, 0, 0, 0.2),\n            rgba(0, 0, 0, 0.4)\n        );\n    }\n}\n\n$width: 46rem;\n.notifications-panel-content {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    width: calc(100% - 4rem);\n    max-width: $width;\n    height: calc(100% - 1rem);\n    margin: 0.5rem;\n    box-sizing: border-box;\n    border-radius: 2rem;\n    transform: translate3d((-$width - 2rem), 0, 0);\n    transition: transform 0.3s ease-in;\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.5), white);\n    @include Colours.customValue(\n        background-color,\n        white,\n        hsl(var(--theme-bg-hue), 10%, 18%)\n    );\n    @include Colours.customValue(\n        box-shadow,\n        1.2rem 0rem 4rem Colours.get(900, 0.1),\n        1.2rem 0rem 4rem rgba(0, 0, 0, 0.3)\n    );\n\n    #{$block}__title {\n        flex-direction: 0 0 auto;\n        text-align: center;\n        font-size: 1.6rem;\n        letter-spacing: 0.05rem;\n        font-weight: 500;\n        line-height: 6rem;\n        @include Colours.customValue(color, 900, 50, $alphaLight: 0.8);\n    }\n\n    #{$block}__content {\n        overflow: auto;\n        max-height: 100%;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/constants.scss' as Constants;\n@use '../../utils/elevations.scss' as Elevations;\n\n.notification-item {\n    $block: &;\n    position: relative;\n    display: grid;\n    grid-template:\n        'badge action' 3.8rem\n        'message message' auto\n        'timestamp title' 2rem\n        'type type' auto\n        / auto auto;\n    padding: 1.2rem 1rem;\n    gap: 1.6rem;\n    border-top: 0.1rem solid transparent;\n    border-bottom: 0.1rem solid transparent;\n    transition: background-color 0.1s ease-in-out;\n    @include Colours.customValue(border-color, 100, 400, $alphaLight: 0.6, $alphaDark: 0.4);\n\n    &:not(:last-child) {\n        border-bottom: none;\n    }\n\n    &:hover {\n        @include Colours.customValue(background-color, 400, 400, $alphaLight: 0.08, $alphaDark: 0.2);\n    }\n\n    &#{$block}--new {\n        #{$block}__badge {\n            padding-left: 3rem;\n        }\n        &::before {\n            content: '';\n            position: absolute;\n            width: 1rem;\n            height: 1rem;\n            left: 2rem;\n            top: 2.6rem;\n            border-radius: 0.5rem;\n            @include Colours.customValue(background-color, hsl(101, 71%, 68%), hsl(101, 71%, 68%));\n        }\n    }\n\n    #{$block}__badge {\n        grid-area: badge;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        justify-self: flex-start;\n        text-align: center;\n        border-radius: 0.8rem;\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        padding: 0 1.5rem;\n        line-height: 1.6rem;\n        @include Colours.customValue(color, 900, 50, $alphaLight: 0.8);\n        @include Colours.customValue(background-color, 50, 200, $alphaDark: 0.2);\n\n        svg {\n            margin-right: 1rem;\n            height: 1.4rem;\n        }\n    }\n\n    #{$block}__type-badge {\n        grid-area: type;\n        margin: -0.8rem -0.6rem -0.8rem -0.6rem;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        justify-self: stretch;\n        text-align: start;\n        border-radius: 0.4rem;\n        font-size: 1.1rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        box-sizing: border-box;\n        padding: 1rem 1.6rem;\n        line-height: 1.6rem;\n        text-transform: uppercase;\n        @include Colours.customValue(color, 900, 50, $alphaLight: 0.8);\n        @include Colours.customValue(background-color, 50, 200, $alphaDark: 0.2);\n\n        svg {\n            margin-right: 1rem;\n            height: 1.4rem;\n        }\n\n        span {\n            font-weight: 400;\n            margin-left: 0.8rem;\n            font-size: 1.3rem;\n            text-transform: none;\n        }\n    }\n\n    #{$block}__timestamp {\n        grid-area: timestamp;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        font-size: 1.2rem;\n        font-weight: 400;\n        letter-spacing: 0.1rem;\n        margin-left: 0.6rem;\n        margin-top: -1.2rem;\n        @include Colours.customValue(color, 900, 50, $alphaLight: 0.9);\n    }\n\n    #{$block}__buttons {\n        justify-self: flex-end;\n        grid-area: action;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 0.5rem;\n\n        .demmi-ui-button {\n            @include Elevations.get(0, 0);\n        }\n    }\n\n    #{$block}__message {\n        grid-area: message;\n        display: flex;\n        flex-direction: column;\n        @include Colours.customValue(color, 900, 50, $alphaLight: 0.7);\n\n        #{$block}__text {\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.05rem;\n            line-height: 2rem;\n            padding: 0 0.6rem 0.4rem;\n\n            strong {\n                font-weight: 600;\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/constants.scss' as Constants;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './notifications-panel';\n@use './notifications-item';\n\n$block: '.notifications';\n\n#{$block}__icon {\n    position: absolute;\n    top: 0.8rem;\n    left: 0.8rem;\n\n    @media (max-width: 1200px) {\n        left: 0.5rem;\n        top: 0.4rem;\n    }\n\n    #{$block}__icon-indicator {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        top: -0.3rem;\n        right: -0.3rem;\n        width: 2rem;\n        height: 2rem;\n        border-radius: 1rem;\n        font-weight: 700;\n        font-size: 1.1rem;\n        color: white;\n        @include Colours.customValue(\n            background-color,\n            hsl(101, 50%, 60%),\n            hsl(101, 37%, 55%)\n        );\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n.portal-sidebar-button {\n    $block: &;\n    cursor: pointer;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    font-size: 1.3rem;\n    box-sizing: border-box;\n    line-height: 2.4rem;\n    padding: 1.3rem 2.4rem;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    text-align: start;\n    border-radius: 0.8rem;\n    background-color: hsla(var(--theme-bg-hue), 60%, 90%, 0);\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Colours.customValue(color, white, white);\n\n    &:disabled {\n        opacity: 0.4;\n    }\n\n    // @include Colours.customValue(background-color, rgba(255, 255, 255, 0.2), transparent);\n    &:not(:disabled):not(#{$block}--active):hover {\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 0.1),\n            400,\n            $alphaDark: 0.2\n        );\n    }\n\n    &:not(:disabled):not(#{$block}--active):active {\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 0.1),\n            400,\n            $alphaDark: 0.2\n        );\n    }\n\n    &#{$block}--active {\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 0.2),\n            400,\n            $alphaDark: 0.3\n        );\n    }\n\n    #{$block}__icon {\n        height: 1.6rem;\n        line-height: 1.6rem;\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n            @include Colours.customValue(\n                color,\n                white,\n                rgba(255, 255, 255, 0.8)\n            );\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n.portal-sidebar {\n    $block: &;\n    // position: absolute;\n    // inset: 0;\n    // padding: 2rem;\n    grid-area: sidebar;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    // gap: 2rem;\n\n    #{$block}__logo {\n        padding: 3rem 0;\n        #{$block}__logo-colour {\n            @include Colours.customValue(display, none, block);\n        }\n        #{$block}__logo-white {\n            @include Colours.customValue(display, block, none);\n        }\n\n        img {\n            height: 3rem;\n        }\n    }\n\n    #{$block}__bottom {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 2rem;\n        box-sizing: border-box;\n    }\n\n    #{$block}__buttons {\n        display: flex;\n        flex: 1 1 auto;\n        flex-direction: column;\n        gap: 0.3rem;\n        width: 100%;\n        padding: 1rem;\n        box-sizing: border-box;\n    }\n\n    #{$block}__version {\n        z-index: 1;\n        display: flex;\n        flex-direction: column;\n        gap: 0.6rem;\n        width: 100%;\n        padding: 0 2rem 2rem 2rem;\n        box-sizing: border-box;\n        line-height: 1.4rem;\n        pointer-events: none;\n        user-select: none;\n        text-transform: uppercase;\n\n        #{$block}__version-build,\n        #{$block}__version-date {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        #{$block}__version-key {\n            display: inline-block;\n            font-size: 1rem;\n            font-weight: 600;\n            text-align: start;\n            letter-spacing: 0.1rem;\n            @include Colours.customValue(color, 300, 300);\n        }\n\n        #{$block}__version-val {\n            display: inline-block;\n            font-size: 1.2rem;\n            font-weight: 700;\n            text-align: end;\n            letter-spacing: 0.2rem;\n            @include Colours.customValue(color, 200, 200);\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './_portal-sidebar-button';\n@use './_portal-sidebar';\n\n$topHeight: 6rem;\n\n.portal-wrapper {\n    $block: &;\n    position: relative;\n    z-index: 100;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    display: grid;\n    grid-template: 'sidebar content' 1fr / 26rem 1fr;\n\n    #{$block}__content-wrapper {\n        $borderRadius: 2rem;\n        position: relative;\n        grid-area: content;\n        display: flex;\n        z-index: 1;\n        align-self: center;\n        justify-self: center;\n        border-radius: $borderRadius;\n        height: calc(100% - 2rem);\n        width: calc(100% - 1rem);\n        margin-right: 1rem;\n        box-sizing: border-box;\n        transition: transform 0.5s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n        overflow: hidden;\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 1),\n            900\n        );\n\n        &::before {\n            content: '';\n            position: absolute;\n            inset: 0;\n            pointer-events: none;\n            border-radius: $borderRadius;\n            @include Colours.customValue(\n                background,\n                radial-gradient(\n                    circle at 30% 80%,\n                    Colours.get(500, 0.1),\n                    Colours.get(500, 0),\n                    Colours.get(500, 0)\n                ),\n                radial-gradient(\n                    circle at 30% 80%,\n                    Colours.get(400, 0.3),\n                    Colours.get(400, 0.1)\n                ),\n                $alphaDark: 1\n            );\n        }\n        #{$block}__content {\n            display: flex;\n            flex: 1 1 auto;\n            overflow: auto hidden;\n        }\n    }\n\n    #{$block}__nav-bar {\n        display: none;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: $topHeight;\n\n        #{$block}__menu-toggle-button {\n            position: relative;\n            height: $topHeight;\n            width: $topHeight;\n            top: 0;\n            left: 0;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n        #{$block}__nav-bar-logo {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            #{$block}__logo-colour {\n                @include Colours.customValue(display, none, block);\n            }\n            #{$block}__logo-white {\n                @include Colours.customValue(display, block, none);\n            }\n\n            img {\n                height: 2.8rem;\n            }\n        }\n        #{$block}__nav-bar-empty {\n            width: $topHeight;\n        }\n    }\n\n    @media (max-width: 800px) {\n        display: block;\n\n        #{$block}__nav-bar {\n            display: flex;\n            justify-content: space-between;\n            #{$block}__menu-toggle-button {\n                .demmi-ui-icon-button.fa-arrow-left {\n                    display: none;\n                }\n                .demmi-ui-icon-button.fa-bars {\n                    display: block;\n                }\n            }\n        }\n\n        &#{$block}--menu-visible {\n            #{$block}__menu-toggle-button {\n                .demmi-ui-icon-button.fa-arrow-left {\n                    display: block;\n                }\n                .demmi-ui-icon-button.fa-bars {\n                    display: none;\n                }\n            }\n            #{$block}__content-wrapper {\n                transform: translate3d(28rem, 0, 0);\n            }\n            .portal-sidebar {\n                opacity: 1;\n            }\n        }\n\n        #{$block}__content-wrapper {\n            position: absolute;\n            left: 1rem;\n            bottom: 0.5rem;\n            right: 0;\n            height: calc(100% - 0.5rem - $topHeight);\n        }\n\n        .portal-sidebar {\n            position: absolute;\n            top: $topHeight;\n            bottom: 0;\n            left: 0;\n            width: 28rem;\n            opacity: 0;\n            transition: opacity 0.5s ease-in-out;\n\n            .portal-sidebar__logo {\n                display: none;\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.raw-details';\n\n#{$block} {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__content {\n        position: relative;\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        #{$block}__dump {\n            width: 100%;\n            border-radius: 2rem;\n            user-select: none;\n            @include Colours.customValue(background-color, 300, 900, $alphaLight: 0.2, $alphaDark: 0.4);\n\n            #{$block}__dump-title {\n                cursor: pointer;\n                line-height: 4rem;\n                padding: 0 2rem;\n                font-size: 1.3rem;\n                font-weight: 600;\n                letter-spacing: 0.1rem;\n                text-align: center;\n                border-radius: 2rem;\n                @include Colours.customValue(color, 400, 100, $alphaLight: 1);\n\n                &:hover {\n                    @include Colours.customValue(color, 600, 50, $alphaLight: 1);\n                    @include Colours.customValue(background-color, 300, 900, $alphaLight: 0.1, $alphaDark: 0.3);\n                }\n            }\n\n            pre {\n                display: none;\n                margin: 0;\n                @include Colours.customValue(color, 800, 50, $alphaLight: 1);\n            }\n\n            &#{$block}__dump--visible {\n                pre {\n                    display: block;\n                }\n            }\n        }\n\n        #{$block}__item {\n            position: relative;\n            flex: 1 0 100%;\n            min-width: 200px;\n            margin-top: 1rem;\n\n            &#{$block}__item--has-indent::before {\n                content: '';\n                position: absolute;\n                left: 1rem;\n                top: 2.5rem;\n                bottom: 0rem;\n                width: 0.2rem;\n                border-radius: 0.2rem;\n                @include Colours.customValue(background-color, 100, 50, $alphaDark: 0.5);\n            }\n\n            #{$block}__item-key {\n                position: relative;\n                line-height: 2rem;\n                font-size: 1.2rem;\n                font-weight: 600;\n                letter-spacing: 0.1rem;\n                @include Colours.customValue(color, 500, 50, $alphaLight: 1);\n            }\n\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2rem;\n                font-size: 1.3rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n                @include Colours.customValue(color, 500, 100, $alphaLight: 1);\n            }\n        }\n    }\n}\n","@use '../../utils/constants.scss' as Constants;\n@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.page';\n\n#{$block} {\n    position: relative;\n    z-index: 100;\n    margin: 0 auto;\n    display: grid;\n    grid-template: 'sidebar details' 1fr / #{Constants.$sidebarCollapsedWidth} 1fr;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: auto hidden;\n    transition: grid Constants.$sidebarTransitionTime ease-in-out;\n    @include Colours.customValue(color, rgba(0, 0, 0, 0.6), white);\n\n    &#{$block}--sidebar-fixed {\n        grid-template: 'sidebar details' 1fr / #{Constants.$sidebarWidth} 1fr;\n    }\n\n    &#{$block}:has(> .sidebar:hover) {\n        grid-template: 'sidebar details' 1fr / #{Constants.$sidebarWidth} 1fr;\n    }\n\n    #{$block}__view {\n        position: relative;\n        min-width: 60rem;\n        max-width: 120rem;\n        width: 100%;\n        margin: 0 auto;\n        padding: 2rem 2rem;\n        box-sizing: border-box;\n        overflow: auto;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/constants.scss' as Constants;\n@use '../../utils/elevations.scss' as Elevations;\n\n.modal-create-invite-code {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 50rem;\n    margin: 4rem auto 8rem;\n\n    #{$block}__title {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Colours.customValue(color, rgba(0, 0, 0, 0.5), white);\n    }\n\n    #{$block}__error {\n        margin-top: 1rem;\n        line-height: 2rem;\n        font-size: 1.2rem;\n        font-weight: 500;\n        letter-spacing: 0.1rem;\n        width: 100%;\n        border-radius: 1rem;\n        box-sizing: border-box;\n        text-align: center;\n        @include Colours.customValue(\n            color,\n            hsl(0, 70%, 70%),\n            hsl(0, 100%, 88%)\n        );\n    }\n\n    #{$block}__code-area {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n        border-radius: 1.6rem;\n        margin-top: 1rem;\n        padding: 2rem;\n        @include Colours.customValue(\n            background-color,\n            200,\n            800,\n            $alphaLight: 0.2,\n            $alphaDark: 0.6\n        );\n\n        #{$block}__code-title {\n            line-height: 2rem;\n            font-size: 1.4rem;\n            font-weight: 400;\n            letter-spacing: 0.16rem;\n            text-align: center;\n            @include Colours.customValue(color, 500, 100);\n        }\n\n        #{$block}__code {\n            text-align: center;\n            font-size: 2.4rem;\n            letter-spacing: 1.5rem;\n            font-weight: 300;\n            line-height: 3rem;\n            @include Colours.customValue(color, 500, 200);\n        }\n\n        #{$block}__toggle-item {\n            input {\n                margin-top: 1rem;\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.card-authentication';\n\n#{$block}__wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 2rem;\n    max-width: 40rem;\n    width: calc(100% - 2rem);\n    box-sizing: border-box;\n    background-color: Colours.get(400, 0.2);\n    border-radius: 2rem;\n\n    #{$block} {\n        flex: 0 0 auto;\n        padding: 0 !important;\n        position: relative;\n        box-sizing: border-box;\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n        // gap: 1rem;\n        border-radius: 2rem;\n        overflow: hidden;\n\n        #{$block}__title {\n            line-height: 2.4rem;\n            font-weight: 700;\n            font-size: 1.4rem;\n            letter-spacing: 0.4rem;\n            text-align: center;\n            margin-top: 4rem;\n            margin-bottom: 2rem;\n            color: Colours.$colour-dark;\n            text-transform: uppercase;\n\n            img {\n                width: 16rem;\n            }\n\n            span {\n                margin-top: 1rem;\n                display: block;\n            }\n        }\n\n        #{$block}__inputs-area {\n            padding: 2rem 2rem 2rem;\n            box-sizing: border-box;\n\n            #{$block}__inputs {\n                display: flex;\n                flex-direction: column;\n                gap: 1rem;\n            }\n        }\n\n        &#{$block}__invite-area {\n            z-index: 0;\n            position: relative;\n            padding: 3rem 0 !important;\n            flex: 0 0 auto;\n            text-align: center;\n            justify-content: space-evenly;\n\n            &::before {\n                z-index: 0;\n                content: '';\n                inset: 0;\n                position: absolute;\n                @include Colours.customValue(\n                    background-color,\n                    100,\n                    rgba(0, 0, 0, 0.15)\n                );\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.login-error';\n\n#{$block} {\n    $block: &;\n    max-width: 40rem;\n    width: calc(100% - 2rem);\n    opacity: 0;\n    margin-top: -5rem;\n    pointer-events: none;\n    transition: opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66),\n        margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n\n    &#{$block}--visible {\n        opacity: 1;\n        margin-top: 0;\n    }\n\n    #{$block}__error {\n        height: 5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: rgba(176, 51, 46, 0.5);\n        line-height: 2rem;\n        font-weight: 500;\n        font-size: 1.3rem;\n        letter-spacing: 0.05rem;\n        text-align: center;\n        color: white;\n        border-radius: 1.6rem;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './_card-authentication';\n@use './_error';\n\n$block: '.login';\n\n#{$block}__wrapper {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2rem;\n    z-index: 1;\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n    overflow: auto;\n    height: 100%;\n    box-sizing: border-box;\n\n    &#{$block}--hide {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n\n    &#{$block}--error {\n        #{$block}__sign-in {\n            margin-top: 0rem;\n        }\n        #{$block}__submit-button {\n            margin-top: 0rem;\n        }\n    }\n\n    .demmi-ui-input {\n        text-align: center;\n        font-size: 1.5rem;\n        line-height: 3.2rem;\n        font-weight: 300;\n        border: none;\n        letter-spacing: 0.2rem;\n        color: white;\n\n        &:focus {\n            @include Elevations.get(0, 0);\n        }\n    }\n\n    #{$block}__submit-button {\n        z-index: 1;\n        transition: margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n    }\n\n    .demmi-ui-button {\n        @include Colours.customValue(\n            background-color,\n            50,\n            400,\n            $alphaDark: 0.6\n        );\n        @include Colours.customValue(border-color, transparent, transparent);\n        @include Colours.customValue(color, 700, 50);\n        @include Elevations.get(0, 0);\n\n        &:not(:disabled):hover {\n            @include Colours.customValue(\n                background-color,\n                50,\n                400,\n                $alphaDark: 0.6\n            );\n            @include Elevations.get(0, 0);\n        }\n\n        &:not(:disabled):active {\n            @include Colours.customValue(\n                background-color,\n                50,\n                400,\n                $alphaDark: 0.6\n            );\n            @include Elevations.get(0, 0);\n        }\n    }\n\n    .theme-switcher {\n        position: fixed;\n        bottom: 2rem;\n        right: 2rem;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.customer-details';\n\n#{$block} {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__title {\n        line-height: 3rem;\n        font-weight: 300;\n        font-size: 2.4rem;\n        letter-spacing: 0.1rem;\n        text-align: start;\n        margin-top: 3rem;\n        margin-left: 2rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__image-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));\n        overflow: auto;\n        gap: 1rem;\n\n        #{$block}__image-item {\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            border-radius: 1.5rem;\n            padding: 0.5rem;\n            @include Colours.customValue(background-color, white, 900, $alphaDark: 0.2);\n\n            #{$block}__image-wrapper {\n                width: 100%;\n                box-sizing: border-box;\n                height: 30rem;\n                overflow: hidden;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                img {\n                    max-height: 100%;\n                    max-width: 100%;\n                    border-radius: 0.5rem;\n                }\n            }\n        }\n    }\n\n    #{$block}__content {\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem 2rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        #{$block}__item {\n            flex: 1 0 100%;\n            min-width: 200px;\n\n            #{$block}__item-key {\n                line-height: 3rem;\n                font-size: 1.4rem;\n                font-weight: 300;\n                letter-spacing: 0.1rem;\n            }\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2.2rem;\n                font-size: 1.5rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n\n                span {\n                    display: block;\n                    margin-bottom: 2rem;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n\n    #{$block}-shop {\n        $block: #{$block}-shop;\n        max-width: 60rem !important;\n        min-width: 55rem !important;\n        border-radius: 2rem;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        gap: 3rem;\n        margin: 0 auto;\n\n        #{$block}__days {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            border-radius: 1.5rem;\n            box-sizing: border-box;\n            gap: 1rem;\n            padding: 0;\n\n            .demmi-ui-card {\n                @include Colours.customValue(background-color, rgba(255, 255, 255, 1), 400, $alphaDark: 0.3);\n            }\n\n            #{$block}__details-item {\n                display: flex;\n                align-items: center;\n                width: 100%;\n                padding: 0.2rem 1rem;\n                box-sizing: border-box;\n                border-radius: 1.6rem;\n                @include Colours.customValue(color, white, 200);\n\n                #{$block}__details-hours {\n                    flex: 1 1 18rem;\n                    display: flex;\n                    gap: 2rem;\n\n                    #{$block}__details-hours-item {\n                        flex: 1 1 auto;\n\n                        #{$block}__details-hours-item-title {\n                            font-size: 1.1rem;\n                            letter-spacing: 0.05rem;\n                            font-weight: 600;\n                            line-height: 1.4rem;\n                            text-transform: uppercase;\n                            margin: 0.2rem 0 1rem 1rem;\n                            @include Colours.customValue(color, 500, white);\n                        }\n                    }\n                }\n\n                #{$block}__details-title {\n                    flex: 1 1 10rem;\n                    font-size: 1.5rem;\n                    letter-spacing: 0.05rem;\n                    font-weight: 400;\n                    line-height: 1.4rem;\n                    margin: 0.5rem 1rem 1rem;\n                    @include Colours.customValue(color, 500, white);\n                }\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './_customer-details';\n\n.home {\n    $block: &;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    // height: 100%;\n    padding: 4rem;\n    box-sizing: border-box;\n    // overflow: auto hidden;\n\n    #{$block}__title {\n        line-height: 5rem;\n        font-weight: 300;\n        font-size: 4rem;\n        letter-spacing: 0.1rem;\n        text-align: center;\n        color: Colours.$colour-dark;\n        margin-top: 1rem;\n        margin-bottom: 4rem;\n    }\n\n    #{$block}__description {\n        line-height: 2.4rem;\n        font-weight: 400;\n        font-size: 1.5rem;\n        letter-spacing: 0.05rem;\n        text-align: center;\n        margin-top: 2rem;\n    }\n\n    @media (max-width: 520px) {\n        padding: 4rem 2rem 2rem;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.customers-view';\n\n#{$block}--address {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__geo {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        box-sizing: border-box;\n\n        #gmaps-view {\n            height: 40rem;\n            border-radius: 1rem;\n            overflow: hidden;\n        }\n\n        .gmap-autocomplete {\n            $block: &;\n            width: 30rem;\n            box-sizing: border-box;\n            margin-top: 0.8rem;\n            margin-left: 0.8rem;\n\n            .demmi-ui-input {\n                opacity: 0.9;\n                box-sizing: border-box;\n                @include Colours.customValue(background-color, 50, 800);\n\n                &:hover {\n                    opacity: 1;\n                    @include Elevations.get(3);\n                    @include Colours.customValue(background-color, 50, 800);\n                }\n\n                &:focus {\n                    opacity: 1;\n                    @include Colours.customValue(background-color, 50, 800);\n                }\n            }\n\n            .demmi-ui-menu {\n                margin-top: 0.8rem;\n                box-sizing: border-box;\n\n                .demmi-ui-menu-item {\n                    text-align: start;\n                }\n            }\n\n            #{$block}__predictions {\n                box-sizing: border-box;\n                background: white;\n                backdrop-filter: blur(10px);\n                -webkit-backdrop-filter: blur(10px);\n                overflow: hidden auto;\n                max-height: 40rem;\n                border-radius: 2rem;\n                box-shadow:\n                    0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n                    0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n            }\n        }\n\n        #{$block}__address-preview {\n            width: 100%;\n            padding: 0rem 1rem 2rem;\n            display: flex;\n            gap: 1rem;\n            flex-wrap: wrap;\n            margin-top: 3rem;\n            box-sizing: border-box;\n\n            #{$block}__details-item {\n                flex: 1 0 calc(50% - 2rem);\n                min-width: 200px;\n\n                #{$block}__details-key {\n                    line-height: 2.2rem;\n                    font-size: 1.2rem;\n                    font-weight: 300;\n                    letter-spacing: 0.1rem;\n                }\n                #{$block}__details-value {\n                    position: relative;\n                    line-height: 2rem;\n                    font-size: 1.3rem;\n                    font-weight: 500;\n                    letter-spacing: 0.05rem;\n                    word-wrap: break-word;\n                    white-space: pre-wrap;\n                }\n            }\n        }\n\n        #{$block}__buttons-row {\n            display: flex;\n            gap: 1rem;\n            align-items: center;\n            justify-content: flex-end;\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.customers-view';\n\n#{$block}--details {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__raw-content {\n        position: relative;\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        pre#{$block}__dump {\n            @include Colours.customValue(\n                background-color,\n                100,\n                900,\n                $alphaDark: 0.5\n            );\n            @include Colours.customValue(color, 800, 50, $alphaLight: 1);\n        }\n\n        #{$block}__item {\n            position: relative;\n            flex: 1 0 100%;\n            min-width: 200px;\n            margin-top: 1rem;\n\n            &#{$block}__item--has-indent::before {\n                content: '';\n                position: absolute;\n                left: 1rem;\n                top: 2.5rem;\n                bottom: 0rem;\n                width: 0.2rem;\n                border-radius: 0.2rem;\n\n                @include Colours.customValue(\n                    background-color,\n                    100,\n                    50,\n                    $alphaDark: 0.5\n                );\n            }\n\n            #{$block}__item-key {\n                position: relative;\n                line-height: 2rem;\n                font-size: 1.2rem;\n                font-weight: 600;\n                letter-spacing: 0.1rem;\n                @include Colours.customValue(color, 500, 50, $alphaLight: 1);\n            }\n\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2rem;\n                font-size: 1.4rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n                @include Colours.customValue(color, 500, 100, $alphaLight: 1);\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './customer-address';\n@use './customer-details';\n\n$block: '.customers';\n\n#{$block}__sidebar-button {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 2rem 2.4rem;\n    @include Colours.customValue(color, 800, white, $alphaLight: 0.8);\n\n    #{$block}__sidebar-button-text {\n        font-size: 1.4rem;\n        letter-spacing: 0.1rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n    }\n    #{$block}__sidebar-button-address {\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        line-height: 1.6rem;\n        opacity: 0.7;\n    }\n}\n\n#{$block}-view {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n\n    #{$block}__title {\n        line-height: 4rem;\n        font-weight: 300;\n        font-size: 3.2rem;\n        letter-spacing: 0.1rem;\n        text-align: center;\n        margin-top: 2rem;\n        margin-bottom: 1rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__subtitle {\n        line-height: 3rem;\n        font-weight: 400;\n        font-size: 1.6rem;\n        letter-spacing: 0.1rem;\n        text-align: start;\n        margin-bottom: 4rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n\n        span {\n            font-weight: 500;\n            letter-spacing: 0.16rem;\n        }\n    }\n\n    #{$block}__tabs {\n        margin-bottom: 3rem;\n    }\n\n    #{$block}__content {\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem 2rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        #{$block}__item {\n            flex: 1 0 100%;\n            min-width: 200px;\n\n            #{$block}__item-key {\n                line-height: 3rem;\n                font-size: 1.4rem;\n                font-weight: 300;\n                letter-spacing: 0.1rem;\n            }\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2.2rem;\n                font-size: 1.5rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.order-details';\n\n#{$block} {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__title {\n        line-height: 3rem;\n        font-weight: 300;\n        font-size: 2.4rem;\n        letter-spacing: 0.1rem;\n        text-align: start;\n        margin-top: 3rem;\n        margin-left: 2rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__raw-content {\n        position: relative;\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        pre#{$block}__dump {\n            @include Colours.customValue(\n                background-color,\n                100,\n                900,\n                $alphaDark: 0.5\n            );\n            @include Colours.customValue(color, 800, 50, $alphaLight: 1);\n        }\n\n        #{$block}__item {\n            position: relative;\n            flex: 1 0 100%;\n            min-width: 200px;\n            margin-top: 1rem;\n\n            &#{$block}__item--has-indent::before {\n                content: '';\n                position: absolute;\n                left: 1rem;\n                top: 2.5rem;\n                bottom: 0rem;\n                width: 0.2rem;\n                border-radius: 0.2rem;\n\n                @include Colours.customValue(\n                    background-color,\n                    100,\n                    50,\n                    $alphaDark: 0.5\n                );\n            }\n\n            #{$block}__item-key {\n                position: relative;\n                line-height: 2rem;\n                font-size: 1.2rem;\n                font-weight: 600;\n                letter-spacing: 0.1rem;\n                @include Colours.customValue(color, 500, 50, $alphaLight: 1);\n            }\n\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2rem;\n                font-size: 1.4rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n                @include Colours.customValue(color, 500, 100, $alphaLight: 1);\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './order-details';\n\n$block: '.orders';\n\n#{$block}__sidebar-button {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 2rem 2.4rem;\n    @include Colours.customValue(color, 800, white, $alphaLight: 0.8);\n\n    #{$block}__sidebar-button-text {\n        font-size: 1.4rem;\n        letter-spacing: 0.1rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n    }\n    #{$block}__sidebar-button-address {\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        line-height: 1.6rem;\n        opacity: 0.7;\n    }\n}\n\n#{$block}-view {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n\n    #{$block}__title {\n        line-height: 4rem;\n        font-weight: 300;\n        font-size: 3.2rem;\n        letter-spacing: 0.1rem;\n        text-align: center;\n        margin-top: 2rem;\n        margin-bottom: 1rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__subtitle {\n        line-height: 2rem;\n        font-weight: 300;\n        font-size: 1.8rem;\n        letter-spacing: 0.2rem;\n        text-align: center;\n        margin-bottom: 4rem;\n        @include Colours.customValue(color, 700, 100, $alphaLight: 1);\n    }\n\n    #{$block}__tabs {\n        margin-bottom: 3rem;\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/constants.scss' as Constants;\n@use '../../utils/utils.scss' as Utils;\n\n.demmi-support-chat {\n    $block: &;\n    grid-area: chat;\n    position: relative;\n    display: flex;\n    max-width: 60rem;\n    flex-direction: column;\n    border-radius: 2rem;\n    padding: 0;\n    margin: 0 auto;\n    box-sizing: border-box;\n    overflow: hidden;\n    height: 100%;\n    @include Colours.customValue(\n        background-color,\n        50,\n        rgba(0, 0, 0, 0.4),\n        $alphaLight: 1\n    );\n\n    @include Utils.loadingOpacity();\n\n    #{$block}__title {\n        display: flex;\n        padding: 0.8rem 0.21rem;\n        flex-direction: column;\n        gap: 0.4rem;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n        font-size: 1.3rem;\n        letter-spacing: 0.05rem;\n        font-weight: 500;\n        margin: 0.3rem;\n        border-radius: 1.8rem;\n        @include Colours.customValue(color, 900, white, $alphaLight: 0.6);\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 1),\n            300,\n            $alphaDark: 0.2\n        );\n\n        #{$block}__title-vendor-name {\n            font-size: 1.2rem;\n            opacity: 0.8;\n        }\n    }\n\n    #{$block}__content {\n        flex: 1 1 auto;\n        overflow: auto;\n        box-sizing: border-box;\n        padding: 1rem;\n\n        #{$block}__no-messages {\n            position: absolute;\n            inset: 0;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            font-size: 1.4rem;\n            letter-spacing: 0.1rem;\n            font-weight: 300;\n            line-height: 1.8rem;\n            text-align: center;\n            @include Colours.customValue(color, 900, 100, $alphaLight: 0.8);\n        }\n    }\n\n    #{$block}__input-area {\n        position: relative;\n        flex: 0 0 auto;\n        display: flex;\n        gap: 1rem;\n        margin: 0 1rem 1rem;\n        @include Utils.loadingOpacity();\n    }\n}\n","@mixin loadingOpacity($loadingClass: 'is-loading') {\n    &#{&}--#{$loadingClass} > *:not(.element-loading-indicator) {\n        opacity: 0.4;\n    }\n\n    @at-root body.theme-dark #{&}--#{$loadingClass} {\n        > :not(.element-loading-indicator) {\n            opacity: 0.4;\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/constants.scss' as Constants;\n@use '../../utils/elevations.scss' as Elevations;\n\n.demmi-support-chat-item {\n    $block: &;\n    $radius: 1.6rem;\n    $sidePadding: 6rem;\n    position: relative;\n    padding: 1rem 1.5rem;\n    margin: 0 0.5rem 1rem calc($sidePadding + 0.5rem);\n    border-radius: $radius 0 $radius $radius;\n    opacity: 1;\n    @include Colours.customValue(background-color, rgba(255, 255, 255, 1), 800);\n\n    &#{$block}--demmi {\n        opacity: 1;\n        margin: 0 calc($sidePadding + 0.5rem) 1rem 0.5rem;\n        border-radius: 0 $radius $radius $radius;\n        @include Colours.customValue(background-color, rgba(255, 255, 255, 1), 800);\n\n        &:after {\n            left: -1rem;\n            right: auto;\n            @include Colours.customValue(border-top-color, rgba(255, 255, 255, 1), 800);\n        }\n    }\n\n    &:after {\n        content: ' ';\n        position: absolute;\n        width: 0;\n        height: 0;\n        right: -1rem;\n        left: auto;\n        top: 0;\n        bottom: auto;\n        border: 1rem solid;\n        box-sizing: border-box;\n        border-color: transparent;\n        @include Colours.customValue(border-top-color, rgba(255, 255, 255, 1), 800);\n    }\n\n    #{$block}__text {\n        font-size: 1.3rem;\n        letter-spacing: 0.05rem;\n        font-weight: 400;\n        line-height: 2rem;\n        @include Colours.customValue(color, 900, white, $alphaLight: 1);\n    }\n\n    #{$block}__timestamp {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 1rem;\n        text-align: end;\n        margin-top: 1rem;\n        line-height: 2rem;\n        font-size: 1.2rem;\n        font-weight: 600;\n        letter-spacing: 0.15rem;\n        @include Colours.customValue(color, 900, 50, $alphaLight: 0.5, $alphaDark: 0.8);\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './chat';\n@use './chat-item';\n\n$block: '.demmi-support';\n\n.portal-wrapper--support-chat {\n    .page__view {\n        min-width: 34rem;\n    }\n}\n\n#{$block}__sidebar-button {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.8rem;\n    padding: 1.6rem 2.2rem;\n    @include Colours.customValue(color, 800, white, $alphaLight: 0.8);\n\n    #{$block}__sidebar-button-text {\n        font-size: 1.4rem;\n        letter-spacing: 0.1rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n    }\n\n    #{$block}__sidebar-button-vendor {\n        align-self: flex-end;\n        font-size: 1.1rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        line-height: 2rem;\n        border-radius: 0.4rem;\n        padding: 0 1rem;\n        margin-top: 0.8rem;\n        margin-right: -0.8rem;\n        @include Colours.customValue(\n            background-color,\n            200,\n            300,\n            $alphaLight: 0.5,\n            $alphaDark: 0.5\n        );\n        @include Colours.customValue(color, 800, white);\n    }\n\n    #{$block}__sidebar-button-message {\n        font-size: 1.2rem;\n        letter-spacing: 0.08rem;\n        font-weight: 500;\n        line-height: 1.5rem;\n        @include Colours.customValue(color, 700, 200, $alphaLight: 0.7);\n    }\n\n    #{$block}__sidebar-button-no-message {\n        font-size: 1rem;\n        letter-spacing: 0.12rem;\n        font-weight: 600;\n        line-height: 1.5rem;\n        text-transform: uppercase;\n        @include Colours.customValue(color, 700, 200, $alphaLight: 0.7);\n    }\n}\n\n#{$block}-view {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n\n    #{$block}__title {\n        line-height: 4rem;\n        font-weight: 300;\n        font-size: 3.2rem;\n        letter-spacing: 0.1rem;\n        text-align: center;\n        margin-top: 2rem;\n        margin-bottom: 1rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__subtitle {\n        line-height: 2rem;\n        font-weight: 300;\n        font-size: 1.8rem;\n        letter-spacing: 0.2rem;\n        text-align: center;\n        margin-bottom: 4rem;\n        @include Colours.customValue(color, 700, 100, $alphaLight: 1);\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.vendors-view';\n\n#{$block}--details {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__title {\n        line-height: 3rem;\n        font-weight: 300;\n        font-size: 2.4rem;\n        letter-spacing: 0.1rem;\n        text-align: start;\n        margin-left: 2rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__image-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));\n        overflow: auto;\n        gap: 1rem;\n\n        #{$block}__image-item {\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            border-radius: 1.5rem;\n            padding: 0.5rem;\n            @include Colours.customValue(background-color, white, 900, $alphaDark: 0.2);\n\n            #{$block}__image-wrapper {\n                width: 100%;\n                box-sizing: border-box;\n                height: 30rem;\n                overflow: hidden;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                img {\n                    max-height: 100%;\n                    max-width: 100%;\n                    border-radius: 0.5rem;\n                }\n            }\n        }\n    }\n\n    #{$block}__content {\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem 2rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        #{$block}__item {\n            flex: 1 0 100%;\n            min-width: 200px;\n\n            #{$block}__item-key {\n                line-height: 3rem;\n                font-size: 1.4rem;\n                font-weight: 300;\n                letter-spacing: 0.1rem;\n            }\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2.2rem;\n                font-size: 1.5rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n\n                span {\n                    display: block;\n                    margin-bottom: 2rem;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n\n    #{$block}-shop {\n        $block: #{$block}-shop;\n        max-width: 60rem !important;\n        min-width: 55rem !important;\n        border-radius: 2rem;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        gap: 3rem;\n        margin: 0 auto;\n\n        #{$block}__days {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            border-radius: 1.5rem;\n            box-sizing: border-box;\n            gap: 1rem;\n            padding: 0;\n\n            .demmi-ui-card {\n                @include Colours.customValue(background-color, rgba(255, 255, 255, 1), 400, $alphaDark: 0.3);\n            }\n\n            #{$block}__details-item {\n                display: flex;\n                align-items: center;\n                width: 100%;\n                padding: 0.2rem 1rem;\n                box-sizing: border-box;\n                border-radius: 1.6rem;\n                @include Colours.customValue(color, white, 200);\n\n                #{$block}__details-hours {\n                    flex: 1 1 18rem;\n                    display: flex;\n                    gap: 2rem;\n\n                    #{$block}__details-hours-item {\n                        flex: 1 1 auto;\n\n                        #{$block}__details-hours-item-title {\n                            font-size: 1.1rem;\n                            letter-spacing: 0.05rem;\n                            font-weight: 600;\n                            line-height: 1.4rem;\n                            text-transform: uppercase;\n                            margin: 0.2rem 0 1rem 1rem;\n                            @include Colours.customValue(color, 500, white);\n                        }\n                    }\n                }\n\n                #{$block}__details-title {\n                    flex: 1 1 10rem;\n                    font-size: 1.5rem;\n                    letter-spacing: 0.05rem;\n                    font-weight: 400;\n                    line-height: 1.4rem;\n                    margin: 0.5rem 1rem 1rem;\n                    @include Colours.customValue(color, 500, white);\n                }\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.vendors-view';\n\n#{$block}--address {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__geo {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        box-sizing: border-box;\n\n        #gmaps-view {\n            height: 40rem;\n            border-radius: 1rem;\n            overflow: hidden;\n        }\n\n        .gmap-autocomplete {\n            $block: &;\n            width: 30rem;\n            box-sizing: border-box;\n            margin-top: 0.8rem;\n            margin-left: 0.8rem;\n\n            .demmi-ui-input {\n                opacity: 0.9;\n                box-sizing: border-box;\n                @include Colours.customValue(background-color, 50, 800);\n\n                &:hover {\n                    opacity: 1;\n                    @include Elevations.get(3);\n                    @include Colours.customValue(background-color, 50, 800);\n                }\n\n                &:focus {\n                    opacity: 1;\n                    @include Colours.customValue(background-color, 50, 800);\n                }\n            }\n\n            .demmi-ui-menu {\n                margin-top: 0.8rem;\n                box-sizing: border-box;\n\n                .demmi-ui-menu-item {\n                    text-align: start;\n                }\n            }\n\n            #{$block}__predictions {\n                box-sizing: border-box;\n                background: white;\n                backdrop-filter: blur(10px);\n                -webkit-backdrop-filter: blur(10px);\n                overflow: hidden auto;\n                max-height: 40rem;\n                border-radius: 2rem;\n                box-shadow:\n                    0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n                    0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n            }\n        }\n\n        #{$block}__address-preview {\n            width: 100%;\n            padding: 0rem 1rem 2rem;\n            display: flex;\n            gap: 1rem;\n            flex-wrap: wrap;\n            margin-top: 3rem;\n            box-sizing: border-box;\n\n            #{$block}__details-item {\n                flex: 1 0 calc(50% - 2rem);\n                min-width: 200px;\n\n                #{$block}__details-key {\n                    line-height: 2.2rem;\n                    font-size: 1.2rem;\n                    font-weight: 300;\n                    letter-spacing: 0.1rem;\n                }\n                #{$block}__details-value {\n                    position: relative;\n                    line-height: 2rem;\n                    font-size: 1.3rem;\n                    font-weight: 500;\n                    letter-spacing: 0.05rem;\n                    word-wrap: break-word;\n                    white-space: pre-wrap;\n                }\n            }\n        }\n\n        #{$block}__buttons-row {\n            display: flex;\n            gap: 1rem;\n            align-items: center;\n            justify-content: flex-end;\n        }\n    }\n}\n","@use '../../utils/constants.scss' as Constants;\n@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.vendor-inventory';\n\n#{$block} {\n    position: relative;\n    display: grid;\n    grid-template: 'sidebar content' / Constants.$sidebarWidth 1fr;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    gap: 2rem;\n    margin-top: 2rem;\n\n    #{$block}__sidebar {\n        grid-area: sidebar;\n        overflow: auto;\n\n        #{$block}__sidebar-button {\n            display: grid;\n            grid-template:\n                'image title' 1fr\n                'image info' / 5rem 1fr;\n            height: 7rem;\n            flex-direction: column;\n            gap: 0 1.5rem;\n            padding: 1rem 1.5rem;\n            box-sizing: border-box;\n            align-items: center;\n            overflow: hidden;\n            @include Colours.customValue(color, 800, white, $alphaLight: 0.8);\n\n            #{$block}__sidebar-button-image {\n                grid-area: image;\n                flex: 0 0 5rem;\n                height: 5rem;\n                overflow: hidden;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                box-sizing: border-box;\n                // background-color: red;\n\n                img {\n                    width: 5rem;\n                    height: 5rem;\n                    border-radius: 0.5rem;\n                    object-fit: cover;\n                }\n            }\n            #{$block}__sidebar-button-title {\n                grid-area: title;\n                font-size: 1.3rem;\n                letter-spacing: 0.1rem;\n                font-weight: 500;\n                line-height: 2rem;\n            }\n            #{$block}__sidebar-button-text {\n                grid-area: info;\n                display: flex;\n                justify-content: space-between;\n                font-size: 1.2rem;\n                letter-spacing: 0.1rem;\n                font-weight: 500;\n                line-height: 2rem;\n                opacity: 0.7;\n\n                #{$block}__sidebar-button-variants {\n                    text-align: start;\n                }\n                #{$block}__sidebar-button-date {\n                    text-align: end;\n                }\n            }\n        }\n    }\n\n    #{$block}__content {\n        grid-area: content;\n        display: grid;\n        grid-template:\n            'tabs' 5rem\n            'content' / 1fr;\n        overflow: auto;\n        gap: 2rem;\n        border-radius: 1.6rem;\n        padding: 2rem 1rem 1rem;\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 0.6),\n            400,\n            $alphaDark: 0.3\n        );\n\n        #{$block}__tabs {\n            grid-area: tabs;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n\n        #{$block}__content-inner {\n            grid-area: content;\n\n            #{$block}-variants {\n                display: flex;\n                flex-direction: column;\n                gap: 2rem;\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.vendor-stripe';\n\n#{$block} {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__title {\n        line-height: 3rem;\n        font-weight: 300;\n        font-size: 2.4rem;\n        letter-spacing: 0.1rem;\n        text-align: start;\n        margin-top: 3rem;\n        margin-left: 2rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.vendor-raw';\n\n#{$block} {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 2rem;\n\n    #{$block}__title {\n        line-height: 3rem;\n        font-weight: 300;\n        font-size: 2.4rem;\n        letter-spacing: 0.1rem;\n        text-align: start;\n        margin-top: 3rem;\n        margin-left: 2rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n@use './vendor-details';\n@use './vendor-address';\n@use './vendor-inventory';\n@use './vendor-stripe';\n@use './vendor-raw';\n\n$block: '.vendors';\n\n#{$block}__sidebar-button {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 2rem 2.4rem;\n    @include Colours.customValue(color, 800, white, $alphaLight: 0.8);\n\n    #{$block}__sidebar-button-text {\n        font-size: 1.4rem;\n        letter-spacing: 0.1rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n    }\n    #{$block}__sidebar-button-address {\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        line-height: 1.6rem;\n        opacity: 0.7;\n    }\n}\n\n#{$block}-view {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    box-sizing: border-box;\n    padding-bottom: 1rem;\n\n    #{$block}__title {\n        line-height: 4rem;\n        font-weight: 300;\n        font-size: 3.2rem;\n        letter-spacing: 0.1rem;\n        text-align: center;\n        margin-top: 1rem;\n        margin-bottom: 3rem;\n        @include Colours.customValue(color, 500, 200, $alphaLight: 1);\n    }\n\n    #{$block}__tabs {\n        margin-bottom: 3rem;\n    }\n\n    #{$block}__content {\n        width: 100%;\n        padding: 0rem 1rem 2rem;\n        display: flex;\n        gap: 3rem 2rem;\n        flex-wrap: wrap;\n        box-sizing: border-box;\n\n        #{$block}__item {\n            flex: 1 0 100%;\n            min-width: 200px;\n\n            #{$block}__item-key {\n                line-height: 3rem;\n                font-size: 1.4rem;\n                font-weight: 300;\n                letter-spacing: 0.1rem;\n            }\n            #{$block}__item-value {\n                position: relative;\n                line-height: 2.2rem;\n                font-size: 1.5rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                word-wrap: break-word;\n                white-space: pre-wrap;\n            }\n        }\n    }\n}\n","@use '../../utils/colours.scss' as Colours;\n@use '../../utils/elevations.scss' as Elevations;\n\n$block: '.invite-codes';\n\n#{$block}__sidebar-button {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 1.6rem 2rem;\n    @include Colours.customValue(color, 800, white, $alphaLight: 0.8);\n\n    #{$block}__sidebar-button-code {\n        font-size: 1.6rem;\n        letter-spacing: 1rem;\n        font-weight: 400;\n        line-height: 2rem;\n    }\n    #{$block}__sidebar-button-email {\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        line-height: 1.6rem;\n        opacity: 0.7;\n    }\n}\n\n#{$block}-view {\n    $block: &;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    #{$block}__buttons {\n        display: flex;\n        justify-content: center;\n        gap: 1rem;\n        margin-top: 2rem;\n    }\n\n    #{$block}__card {\n        width: auto;\n\n        #{$block}__content {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            gap: 1rem;\n            padding: 1rem 3rem;\n\n            #{$block}__code {\n                line-height: 5rem;\n                text-align: center;\n                font-weight: 200;\n                font-size: 3.2rem;\n                letter-spacing: 1.5rem;\n                @include Colours.customValue(\n                    color,\n                    800,\n                    white,\n                    $alphaLight: 0.8\n                );\n            }\n\n            #{$block}__email {\n                line-height: 2rem;\n                text-align: center;\n                font-weight: 400;\n                font-size: 1.4rem;\n                letter-spacing: 0.2rem;\n            }\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n$block: '.demmi-ui-modal';\n\n#{$block} {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n\n    &#{$block}--visible {\n        #{$block}__content {\n            opacity: 1;\n        }\n        #{$block}__backdrop {\n            opacity: 1;\n        }\n    }\n\n    #{$block}__backdrop {\n        opacity: 0;\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        inset: 0;\n        transition: opacity 0.3s ease-in-out;\n        // backdrop-filter: blur(15px);\n        // -webkit-backdrop-filter: blur(15px);\n        @include Colours.customValue(\n            background-color,\n            900,\n            rgba(0, 0, 0, 0.8),\n            $alphaLight: 0.8\n        );\n    }\n\n    #{$block}__content {\n        position: relative;\n        opacity: 0;\n        z-index: 1;\n        max-height: 100%;\n        width: 100%;\n        overflow: visible auto;\n        transition: opacity 0.2s ease-in-out;\n        justify-content: center;\n\n        #{$block}__content-wrapper {\n            overflow: hidden;\n            border-radius: 2rem;\n            @include Elevations.get(4, 0);\n            // box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n            //     0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n\n            #{$block}__divider {\n                margin: 2rem 0;\n                height: 0.1rem;\n                width: 100%;\n                @include Colours.customValue(\n                    background-color,\n                    hsla(0, 0%, 0%, 0.06),\n                    black\n                );\n            }\n\n            #{$block}__area {\n                width: 100%;\n                box-sizing: border-box;\n                @include Colours.customValue(margin, unset, 1rem 0);\n\n                &#{$block}__area--dark {\n                    @include Colours.customValue(border-radius, unset, 1.6rem);\n                    @include Colours.customValue(\n                        background-color,\n                        50,\n                        200,\n                        $alphaDark: 0.4\n                    );\n                }\n\n                &#{$block}__area--light {\n                    @include Colours.customValue(border-radius, unset, 1.6rem);\n                    @include Colours.customValue(\n                        background-color,\n                        white,\n                        100,\n                        $alphaDark: 0.8\n                    );\n                }\n            }\n\n            #{$block}__area-title {\n                padding: 2rem;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n            }\n\n            #{$block}__area-buttons {\n                padding: 2rem;\n                position: relative;\n\n                &#{$block}__area-buttons--doing-request {\n                    #{$block}__action-buttons {\n                        opacity: 0.2;\n                        pointer-events: none;\n                    }\n                }\n\n                #{$block}__action-buttons {\n                    display: flex;\n                    justify-content: flex-end;\n                    gap: 2rem;\n                }\n            }\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-button {\n    $block: &;\n    cursor: pointer;\n    width: fit-content;\n    width: -webkit-fit-content;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    font-size: 1.3rem;\n    line-height: 2rem;\n    padding: 1.2rem 2.4rem;\n    border: 0.2rem solid;\n    border-radius: 1rem;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Colours.customValue(background-color, 50, rgba(0, 0, 0, 0.8));\n    @include Colours.customValue(border-color, 100, transparent);\n    @include Colours.customValue(color, 700, white);\n    @include Elevations.get(1, 0);\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.4;\n    }\n\n    &:not(:disabled):hover {\n        border-radius: 3rem;\n        @include Colours.customValue(background-color, 50, rgba(0, 0, 0, 1));\n        @include Elevations.get(2, 0);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 3rem;\n        @include Colours.customValue(background-color, 50, rgba(0, 0, 0, 1));\n        @include Elevations.get(4, 0);\n    }\n\n    &#{$block}--outlined {\n        @include Colours.customValue(background-color, rgba(255, 255, 255, 0.1), transparent);\n        @include Colours.customValue(border-color, 100, 0.5);\n        @include Colours.customValue(color, 700, black);\n        @include Elevations.get(0);\n\n        &:not(:disabled):hover {\n            @include Colours.customValue(border-color, 200, 1);\n            @include Colours.customValue(background-color, 50, rgba(0, 0, 0, 0));\n            @include Elevations.get(2, 0);\n        }\n\n        &:not(:disabled):active {\n            @include Colours.customValue(border-color, 200, 1);\n            @include Colours.customValue(background-color, 50, rgba(0, 0, 0, 0));\n            @include Elevations.get(4, 0);\n        }\n    }\n\n    &#{$block}--delete {\n        border-color: transparent;\n        color: white;\n        @include Colours.customValue(background-color, hsl(0, 70%, 70%), hsl(0, 40%, 50%));\n\n        &:not(:disabled):hover {\n            @include Colours.customValue(background-color, hsl(0, 70%, 70%), hsl(0, 40%, 50%));\n        }\n\n        &:not(:disabled):active {\n            @include Colours.customValue(background-color, hsl(0, 70%, 70%), hsl(0, 40%, 50%));\n        }\n    }\n\n    &#{$block}--save {\n        border-color: transparent;\n        color: white;\n        @include Colours.customValue(background-color, hsl(90, 50%, 70%), hsl(90, 25%, 50%));\n\n        &:not(:disabled):hover {\n            @include Colours.customValue(background-color, hsl(90, 50%, 70%), hsl(90, 25%, 50%));\n        }\n\n        &:not(:disabled):active {\n            @include Colours.customValue(background-color, hsl(90, 50%, 70%), hsl(90, 25%, 50%));\n        }\n    }\n\n    &#{$block}--size-small {\n        letter-spacing: 0.15rem;\n        font-size: 1.1rem;\n        line-height: 1.4rem;\n        font-weight: 700;\n        padding: 1rem 2rem;\n        text-transform: uppercase;\n    }\n\n    #{$block}__icon {\n        margin-right: 1.2rem;\n        height: 1.4rem;\n        line-height: 1.4rem;\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.4rem;\n            width: 1.4rem;\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-toggle {\n    $block: &;\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    font-size: 1.3rem;\n    line-height: 1.6rem;\n    padding: 0.8rem 0.8rem 0.8rem 1.6rem;\n    font-weight: 500;\n    letter-spacing: 0.1rem;\n    border-radius: 1.2rem;\n    transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n\n    @include Colours.customValue(\n        color,\n        rgba(0, 0, 0, 0.6),\n        rgba(255, 255, 255, 0.8)\n    );\n\n    input {\n        display: none;\n\n        &:checked {\n            ~ #{$block}__indicator:before {\n                transform: translate3d(2.8rem, 0, 0);\n                @include Colours.customValue(background-color, 1, 100);\n            }\n        }\n    }\n\n    &:hover {\n        @include Colours.customValue(\n            background-color,\n            50,\n            rgba(255, 255, 255, 0.12)\n        );\n    }\n\n    #{$block}__indicator {\n        cursor: pointer;\n        position: relative;\n        width: 6rem;\n        height: 3.2rem;\n        border-radius: 2rem;\n        @include Colours.customValue(background-color, 100, 0.3);\n        @include Colours.customValue(\n            box-shadow,\n            #{inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.08)},\n            #{0 0.1rem 0.1rem rgba(255, 255, 255, 0.16)}\n        );\n\n        &:before {\n            position: absolute;\n            content: '';\n            height: 2.4rem;\n            width: 2.4rem;\n            left: 0.4rem;\n            top: 0.4rem;\n            border-radius: 50%;\n            transition: transform 0.2s ease-in-out,\n                background-color 0.2s ease-in-out;\n            @include Colours.customValue(\n                background-color,\n                50,\n                100,\n                $alphaLight: 0.4,\n                $alphaDark: 0.2\n            );\n            $dropShadowLight: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.16);\n            $dropShadowDark: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.32);\n            @include Colours.customValue(\n                box-shadow,\n                #{inset 0 0.1rem 0.1rem rgba(255, 255, 255, 1),\n                $dropShadowLight},\n                #{inset 0 0.1rem 0.1rem rgba(255, 255, 255, 0.12),\n                $dropShadowDark}\n            );\n        }\n    }\n\n    &#{$block}--disabled {\n        pointer-events: none;\n        opacity: 0.6;\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-icon-button {\n    $block: &;\n    cursor: pointer;\n    width: fit-content;\n    width: -webkit-fit-content;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1.6rem;\n    border-radius: 0.8rem;\n    box-sizing: border-box;\n    padding: 1.2rem;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    color: rgba(255, 255, 255, 0.8);\n    background-color: hsla(var(--theme-bg-hue), 20%, 10%, 0);\n    @include Elevations.get(0);\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.4;\n    }\n\n    &:not(:disabled):hover {\n        border-radius: 50%;\n        @include Colours.customValue(background-color, 400, 400, $alphaDark: 0.2, $alphaLight: 0.2);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 50%;\n        @include Colours.customValue(background-color, 400, 400, $alphaDark: 0.4, $alphaLight: 0.3);\n    }\n\n    &:not(:disabled):focus-visible {\n        transform: translate3d(0, -0.1rem, 0);\n        @include Colours.customValue(background-color, 400, 400, $alphaDark: 0.4, $alphaLight: 0.3);\n    }\n\n    svg {\n        display: block;\n        pointer-events: none;\n        height: 1.6rem;\n        width: 1.6rem;\n        @include Colours.customValue(color, 400, white);\n    }\n\n    &#{$block}--invert {\n        &:not(:disabled):hover {\n            @include Colours.customValue(background-color, 400, 400, $alphaDark: 0.2, $alphaLight: 0.4);\n        }\n        &:not(:disabled):active {\n            @include Colours.customValue(background-color, 400, 400, $alphaDark: 0.4, $alphaLight: 0.6);\n        }\n        &:not(:disabled):focus-visible {\n            @include Colours.customValue(background-color, 400, 400, $alphaDark: 0.4, $alphaLight: 0.6);\n        }\n        svg {\n            @include Colours.customValue(color, 50, white);\n        }\n    }\n\n    &#{$block}--small {\n        line-height: 1.2rem;\n\n        svg {\n            height: 1.2rem;\n            width: 1.2rem;\n        }\n    }\n\n    &#{$block}--mini {\n        line-height: 1rem;\n        padding: 0.8rem;\n\n        svg {\n            height: 1.1rem;\n            width: 1.1rem;\n        }\n\n        &:not(:disabled):active {\n            border-radius: 50%;\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-item-switch {\n    $block: &;\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    justify-content: center;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n    width: fit-content;\n    box-sizing: border-box;\n    padding: 0rem 0.4rem;\n    margin: 0;\n    border-radius: 0.8rem;\n    gap: 0.4rem;\n    @include Colours.customValue(\n        background-color,\n        100,\n        400,\n        $alphaLight: 0.4,\n        $alphaDark: 0.2\n    );\n\n    #{$block}__item {\n        z-index: 1;\n        cursor: pointer;\n        flex: 0 0 auto;\n        display: flex;\n        align-items: center;\n        padding: 1.2rem 2rem;\n        transition: opacity 0.1s ease-in-out;\n        background: rgba(255, 0, 0, 0.1);\n        background: transparent;\n        opacity: 0.8;\n\n        #{$block}__item-content {\n            pointer-events: none;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: transparent;\n            transition:\n                width 0.3s ease-in-out,\n                opacity 0.3s ease-in-out;\n            font-size: 1.2rem;\n            line-height: 1.2rem;\n            font-weight: 500;\n            letter-spacing: 0.12rem;\n            text-align: center;\n            overflow: hidden;\n        }\n\n        &:hover:not(#{$block}--active) {\n            opacity: 1;\n        }\n        &#{$block}__item--active {\n            opacity: 1;\n        }\n    }\n\n    #{$block}__indicator {\n        position: absolute;\n        top: 0.4rem;\n        bottom: 0.4rem;\n        left: 0;\n        pointer-events: none;\n        border-radius: 0.8rem;\n        transition: all 0.3s cubic-bezier(0.38, 0.1, 0.26, 1.41);\n        background-color: white;\n        @include Elevations.get(4);\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n$coreblock: '.demmi-ui-item-switch';\n$block: '.demmi-ui-button-switch';\n\n#{$block} {\n    #{$coreblock} {\n        #{$coreblock}__item {\n            &:hover:not(#{$coreblock}--active) {\n                #{$block}__item {\n                    @include Colours.customValue(\n                        color,\n                        800,\n                        50,\n                        $alphaLight: 1\n                    );\n                }\n            }\n            &#{$coreblock}__item--active {\n                #{$block}__item {\n                    @include Colours.customValue(\n                        color,\n                        800,\n                        600,\n                        $alphaLight: 1\n                    );\n                }\n            }\n        }\n\n        #{$block}__item {\n            z-index: 1;\n            cursor: pointer;\n            flex: 0 0 auto;\n            display: flex;\n            height: 1.4rem;\n            align-items: center;\n            padding: 0;\n            transition: color 0.1s ease;\n            background: rgba(255, 0, 0, 0.1);\n            background: transparent;\n            @include Colours.customValue(color, 800, 100, $alphaLight: 0.8);\n\n            #{$block}__item-text {\n                pointer-events: none;\n                background-color: transparent;\n                transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;\n                font-size: 1.2rem;\n                line-height: 1.2rem;\n                font-weight: 500;\n                letter-spacing: 0.12rem;\n                text-align: center;\n                overflow: hidden;\n            }\n        }\n\n        .demmi-ui-item-switch__indicator {\n            top: -0.2rem;\n            bottom: -0.2rem;\n            left: 0;\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-input-file-button {\n    display: block;\n    margin: 0 auto;\n    cursor: pointer;\n    font-size: 1.3rem;\n    box-sizing: border-box;\n    line-height: 2rem;\n    padding: 1.2rem 2.4rem;\n    border-radius: 1rem;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    border: 0.2rem solid;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Elevations.get(1, 0);\n    @include Colours.customValue(background-color, 50, rgba(0, 0, 0, 0.8));\n    @include Colours.customValue(border-color, 100, transparent);\n    @include Colours.customValue(color, 700, white);\n\n    &:not(:disabled):hover {\n        border-radius: 3rem;\n        @include Elevations.get(2, 0);\n        @include Colours.customValue(border-color, 200, transparent);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 3rem;\n        @include Elevations.get(4, 0);\n        @include Colours.customValue(border-color, 200, transparent);\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n$block: '.demmi-ui-input-time';\n\n#{$block} {\n    width: 18rem;\n    box-sizing: border-box;\n    display: flex;\n    gap: 0.8rem;\n    align-items: center;\n    justify-content: center;\n    padding: 0.4rem;\n    border-radius: 1.6rem;\n    @include Colours.customValue(background-color, 100, 100, $alphaDark: 0.6);\n\n    span {\n        font-size: 1.8rem;\n        font-weight: 600;\n        @include Colours.customValue(color, 700, black);\n    }\n\n    #{$block}__button {\n        flex: 1 1 50%;\n        cursor: pointer;\n        width: fit-content;\n        width: -webkit-fit-content;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 1.3rem;\n        font-weight: 500;\n        letter-spacing: 0.3rem;\n        box-sizing: border-box;\n        line-height: 1.4rem;\n        padding: 1.2rem;\n        border-radius: 1.4rem;\n        transition:\n            transform 0.1s ease-in-out,\n            box-shadow 0.1s ease-in-out,\n            background-color 0.1s ease-in-out,\n            border-color 0.1s ease-in-out,\n            border-radius 0.2s ease-in-out;\n        @include Colours.customValue(background-color, white, 700, $alphaDark: 0.7);\n        @include Colours.customValue(border-color, 100, transparent);\n        @include Colours.customValue(color, 700, white);\n\n        &:not(:disabled):hover {\n            border-radius: 3rem;\n            @include Colours.customValue(background-color, white, 800, $alphaDark: 0.9);\n            @include Elevations.get(2, 0);\n        }\n\n        &:not(:disabled):active {\n            transform: scale3d(1.1, 1.1, 1.1);\n            border-radius: 3rem;\n            @include Colours.customValue(background-color, white, 800, $alphaDark: 0.9);\n            @include Elevations.get(4, 0);\n        }\n    }\n\n    &#{$block}--disabled {\n        #{$block}__button {\n            cursor: default;\n        }\n    }\n}\n\n#{$block}__overlay {\n    #{$block}__scroll {\n        max-height: 20rem;\n        padding: 0.5rem;\n        box-sizing: border-box;\n        border-radius: 1.6rem;\n        overflow: auto;\n        @include Colours.customValue(background-color, 50, white);\n\n        #{$block}__scroll-item {\n            font-size: 1.3rem;\n            font-weight: 500;\n            letter-spacing: 0.3rem;\n            text-align: center;\n            border-radius: 1.6rem;\n            padding: 1.2rem 1.6rem;\n            cursor: pointer;\n            user-select: none;\n            @include Colours.customValue(color, black, black);\n\n            &:hover {\n                @include Colours.customValue(background-color, white, black);\n                @include Colours.customValue(color, black, white);\n            }\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-input {\n    $block: &;\n    padding: 1rem 1.6rem;\n    font-size: 1.3rem;\n    letter-spacing: 0.08rem;\n    line-height: 2rem;\n    border-radius: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n    outline: none;\n    border: 0.2rem solid transparent;\n    transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n\n    @include Colours.customValue(\n        background-color,\n        600,\n        400,\n        $alphaLight: 0.04,\n        $alphaDark: 0.2\n    );\n    @include Colours.customValue(color, 800, 50);\n    @include Colours.customValue(\n        border-color,\n        700,\n        transparent,\n        $alphaLight: 0.2\n    );\n\n    &#{$block}--error {\n        @include Colours.customValue(\n            border-color,\n            rgb(228, 97, 97),\n            rgb(219, 113, 113)\n        );\n    }\n    &#{$block}--invert {\n        @include Colours.customValue(\n            background-color,\n            rgba(255, 255, 255, 0.3),\n            0.3\n        );\n        @include Colours.customValue(\n            border-color,\n            rgba(255, 255, 255, 1),\n            transparent\n        );\n    }\n\n    &:hover {\n        @include Colours.customValue(\n            background-color,\n            600,\n            400,\n            $alphaLight: 0.08,\n            $alphaDark: 0.3\n        );\n\n        &#{$block}--invert {\n            @include Colours.customValue(\n                background-color,\n                rgba(255, 255, 255, 0.8),\n                0.4\n            );\n        }\n    }\n\n    &:focus {\n        border-radius: 3rem;\n        @include Colours.customValue(\n            background-color,\n            600,\n            400,\n            $alphaLight: 0.08,\n            $alphaDark: 0.3\n        );\n        @include Colours.customValue(\n            border-color,\n            700,\n            transparent,\n            $alphaLight: 0.2\n        );\n        @include Elevations.get(2, 0);\n\n        &#{$block}--invert {\n            @include Colours.customValue(\n                background-color,\n                rgba(255, 255, 255, 0.8),\n                0.5\n            );\n        }\n    }\n\n    &::placeholder {\n        @include Colours.customValue(\n            color,\n            900,\n            rgba(255, 255, 255, 0.5),\n            $alphaLight: 0.5\n        );\n    }\n}\n\n.demmi-ui-input__wrapper {\n    position: relative;\n\n    textarea.demmi-ui-input {\n        height: 40rem;\n        max-width: 100%;\n        min-width: 100%;\n        resize: none;\n        box-sizing: border-box;\n        padding-bottom: 3rem;\n        &:focus {\n            border-radius: 1rem;\n        }\n    }\n\n    .demmi-ui-input__max-length {\n        position: absolute;\n        bottom: 1rem;\n        right: 0.6rem;\n        font-size: 1.1rem;\n        font-weight: 700;\n        line-height: 1.4rem;\n        border-radius: 0.5rem;\n        text-transform: uppercase;\n        margin: 0 auto;\n        padding: 0.5rem 1rem;\n        color: white;\n        backdrop-filter: blur(10px);\n        @include Colours.customValue(\n            background-color,\n            700,\n            0.8,\n            $alphaLight: 0.4\n        );\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n$block: '.demmi-ui-menu';\n\n#{$block} {\n    opacity: 0;\n    transform: translate3d(0, -1.2rem, 0);\n    transition:\n        opacity 0.2s ease-in-out,\n        transform 0.2s ease-in-out;\n    position: fixed;\n    top: 10rem;\n    left: 10rem;\n    z-index: 9999;\n\n    #{$block}__card {\n        box-sizing: border-box;\n        background: white;\n        backdrop-filter: blur(10px);\n        -webkit-backdrop-filter: blur(10px);\n        overflow: hidden auto;\n        max-height: 40rem;\n        border-radius: 2rem;\n        box-shadow:\n            0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n            0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n    }\n\n    &#{$block}--static {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n        position: relative;\n        top: unset;\n        left: unset;\n    }\n    &#{$block}--visible {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n    }\n\n    #{$block}__section-heading {\n        padding: 2rem 0rem 0;\n        margin: 0 2rem 0.8rem;\n        font-size: 1.4rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n        letter-spacing: 0.1rem;\n        @include Colours.customValue(\n            color,\n            rgba(0, 0, 0, 0.4),\n            rgba(255, 255, 255, 0.6)\n        );\n    }\n\n    #{$block}__section-items {\n        padding: 1rem;\n    }\n    #{$block}__divider {\n        height: 0.1rem;\n        margin: 2rem -1rem;\n        @include Colours.customValue(\n            background-color,\n            rgba(0, 0, 0, 0.08),\n            rgba(255, 255, 255, 0.08)\n        );\n    }\n\n    #{$block}-item {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 1.6rem;\n        border-radius: 0.8rem;\n        padding: 1.4rem 2rem 1.4rem 1.6rem;\n        box-sizing: border-box;\n        width: 100%;\n        line-height: 1.4rem;\n        font-size: 1.3rem;\n        letter-spacing: 0.1rem;\n        font-weight: 400;\n        background: transparent;\n        outline: none;\n        border: none;\n        @include Colours.customValue(color, rgba(0, 0, 0, 0.6), black);\n\n        svg {\n            width: 1.4rem;\n            height: 1.4rem;\n            opacity: 0.6;\n        }\n\n        &:disabled {\n            opacity: 0.4;\n        }\n\n        &:hover:not(:disabled) {\n            @include Colours.customValue(\n                background-color,\n                rgba(0, 0, 0, 0.04),\n                black\n            );\n\n            @include Colours.customValue(color, rgba(0, 0, 0, 0.8), white);\n\n            svg {\n                opacity: 0.8;\n            }\n        }\n    }\n\n    &#{$block}--visible {\n        #{$block}__content {\n            opacity: 1;\n        }\n        #{$block}__backdrop {\n            opacity: 1;\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n.demmi-ui-menu-trigger-button {\n    $block: &;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.2rem;\n    padding-right: 1.6rem;\n    @include Colours.customValue(\n        background-color,\n        50,\n        rgba(255, 255, 255, 0.8)\n    );\n    @include Colours.customValue(border-color, 100, transparent);\n    @include Colours.customValue(color, 700, black);\n\n    &:not(:disabled):hover {\n        border-radius: 3rem;\n        @include Colours.customValue(background-color, 50, white);\n        @include Elevations.get(2, 0);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 3rem;\n        @include Colours.customValue(background-color, 50, white);\n        @include Elevations.get(4, 0);\n    }\n\n    #{$block}__content {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 1.2rem;\n    }\n\n    #{$block}__dropdown-icon {\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n            @include Colours.customValue(color, 400, black);\n        }\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n.demmi-ui-chip {\n    $block: &;\n    cursor: pointer;\n    position: relative;\n    width: fit-content;\n    box-sizing: border-box;\n    padding: 0.8rem 1.6rem;\n    border-radius: 2rem;\n    border: 0.2rem solid;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n    @include Colours.customValue(background-color, 50, 0.2, $alphaLight: 0.6);\n    @include Colours.customValue(border-color, 100, 0.5);\n\n    input {\n        display: none;\n    }\n\n    &#{$block}--active {\n        @include Colours.customValue(background-color, 200, 1);\n        @include Colours.customValue(border-color, 200, transparent);\n\n        #{$block}__text {\n            font-weight: 500;\n            @include Colours.customValue(color, white);\n        }\n    }\n\n    #{$block}__text {\n        font-size: 1.2rem;\n        line-height: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.12rem;\n        @include Colours.customValue(color, 700, white);\n    }\n\n    &:not(#{$block}--active):hover {\n        @include Colours.customValue(background-color, 50, 0.6);\n        @include Colours.customValue(border-color, 100, 0.6);\n    }\n\n    &#{$block}--disabled {\n        pointer-events: none;\n        opacity: 0.4;\n    }\n}\n","@use '../utils/colours.scss' as Colours;\n@use '../utils/elevations.scss' as Elevations;\n\n$block: '.demmi-ui-card';\n\n#{$block} {\n    width: 100%;\n    position: relative;\n    padding: 1rem;\n    box-sizing: border-box;\n    @include Colours.demmi(color, 600, 100);\n    @include Colours.customValue(background-color, 50, 400, $alphaDark: 0.3);\n    @include Colours.customValue(border-radius, 1.6rem, 1.6rem);\n\n    &#{$block}--dark-only {\n        @at-root body:not(.theme-dark) #{&} {\n            width: unset;\n            padding: 0;\n            @include Colours.customValue(background-color, unset, unset);\n            @include Colours.customValue(border-radius, unset, unset);\n        }\n    }\n\n    &#{$block}--collapsed {\n        #{$block}__title {\n            margin-bottom: 0;\n\n            #{$block}__button-collapse {\n                svg {\n                    transform: rotate3d(0, 0, 1, 180deg);\n                }\n            }\n        }\n        #{$block}__content {\n            display: none;\n        }\n    }\n\n    #{$block}__title {\n        height: 4.4rem;\n        max-height: 4.4rem;\n        display: flex;\n        justify-content: space-between;\n        line-height: 4.4rem;\n        margin: 0 0 1rem 1rem;\n        font-size: 1.4rem;\n        letter-spacing: 0.1rem;\n        font-weight: 700;\n        text-transform: uppercase;\n        align-items: flex-end;\n        @include Colours.customValue(color, rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.7));\n\n        #{$block}__button-collapse {\n            margin-left: -1rem;\n            margin-right: 1rem;\n            svg {\n                transition: transform 0.2s ease-in-out;\n            }\n        }\n\n        span {\n            display: flex;\n            align-items: center;\n        }\n\n        #{$block}__title-with-subtitle {\n            line-height: 2rem;\n\n            #{$block}__subtitle {\n                display: flex;\n                justify-content: space-between;\n                line-height: 1.6rem;\n                padding-bottom: 0.4rem;\n                font-size: 1.1rem;\n                letter-spacing: 0.15rem;\n                font-weight: 600;\n                text-transform: uppercase;\n            }\n        }\n\n        #{$block}__control-buttons {\n            display: flex;\n            gap: 1rem;\n        }\n    }\n\n    #{$block}__divider {\n        margin: 1rem 0;\n        height: 0.2rem;\n        width: 100%;\n        @include Colours.customValue(background-color, 50, 0.2);\n    }\n\n    &#{$block}--loading {\n        #{$block}__content {\n            opacity: 0.4;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
